import { URLString } from "../flavours";
import _1HRTimeCandy from "../img/1_HR_Time_Candy.png";
import _2HRTimeCandy from "../img/2_HR_Time_Candy.png";
import _3rdAnniversaryIceCreamTopper from "../img/3rd_Anniversary_Ice_Cream_Topper.png";
import _3rdAnniversaryIdleOnNametag from "../img/3rd_Anniversary_IdleOn_Nametag.png";
import _4HRTimeCandy from "../img/4_HR_Time_Candy.png";
import _4thAnniversaryBag from "../img/4th_Anniversary_Bag.png";
import _4thAnniversaryIdleOnNametag from "../img/4th_Anniversary_IdleOn_Nametag.png";
import eightBallChain from "../img/8_Ball_Chain.png";
import nineBallChain from "../img/9_Ball_Chain.png";
import _12HRTimeCandy from "../img/12_HR_Time_Candy.png";
import _24HRTimeCandy from "../img/24_HR_Time_Candy.png";
import _72HRTimeCandy from "../img/72_HR_Time_Candy.png";
import _2021GiftmasBox from "../img/2021_Giftmas_Box.png";
import Acorn from "../img/Acorn.png";
import acornAssault from "../img/Acorn_Assault_Totem.gif";
import acornTopper from "../img/Acorn_Topper.png";
import adamsLeaf from "../img/Adam-s_Leaf.png";
import adeptRecipe from "../img/Adept_Recipe.png";
import adornmentOfTheHighPriest from "../img/Adornment_of_the_High_Priest.png";
import agileStamp from "../img/Agile_Stamp.png";
import alchGoBrrrStamp from "../img/Alch_Go_Brrr_Stamp.png";
import alienHeadband from "../img/Alien_Headband.png";
import alienHiveChunk from "../img/Alien_Hive_Chunk.png";
import alienHiveChunkCard from "../img/Alien_Hive_Chunk_Card.png";
import alienTree from "../img/Alien_Tree.png";
import amarokBodyplate from "../img/Amarok_Bodyplate.png";
import amarokCard from "../img/Amarok_Card.png";
import amarokHelmet from "../img/Amarok_Helmet.png";
import amarokHinds from "../img/Amarok_Hinds.png";
import amarokPaws from "../img/Amarok_Paws.png";
import amarokSlab from "../img/Amarok_Slab.png";
import amethystRhinestone from "../img/Amethyst_Rhinestone.png";
import amplestampleStamp from "../img/Amplestample_Stamp.png";
import ancientCardPack from "../img/Ancient_Card_Pack.png";
import angelWings from "../img/Angel_Wings.png";
import anglerBoots from "../img/Angler_Boots.png";
import anglerOfTheIliunne from "../img/Angler_of_the_Iliunne.png";
import annihilatorOfTheYggdrasil from "../img/Annihilator_of_the_Yggdrasil.png";
import anniversaryBox from "../img/Anniversary_Box.png";
import anvilResetWhetstone from "../img/Anvil_Reset_Whetstone.png";
import anvilStatue from "../img/Anvil_Statue.png";
import anvilTab2 from "../img/Anvil_Tab_2.png";
import anvilTab3 from "../img/Anvil_Tab_3.png";
import anvilTab4 from "../img/Anvil_Tab_4.png";
import anvilTab5 from "../img/Anvil_Tab_5.png";
import anvilTab6 from "../img/Anvil_Tab_6.png";
import anvilZoomerStamp from "../img/Anvil_Zoomer_Stamp.png";
import apple from "../img/Apple.png";
import appleLaunchHat from "../img/Apple_Launch_Hat.png";
import apprenticeRecipe from "../img/Apprentice_Recipe.png";
import aquaPearl from "../img/Aqua_Pearl.png";
import arcadeBallStamp from "../img/Arcade_Ball_Stamp.png";
import arcaneStamp from "../img/Arcane_Stamp.png";
import arcticLeaf from "../img/Arctic_Leaf.png";
import armorUpgradeStoneB from "../img/Armor_Upgrade_Stone_B.png";
import armorUpgradeStoneC from "../img/Armor_Upgrade_Stone_C.png";
import armorUpgradeStoneG from "../img/Armor_Upgrade_Stone_G.png";
import armorUpgradeStoneI from "../img/Armor_Upgrade_Stone_I.png";
import armorUpgradeStoneII from "../img/Armor_Upgrade_Stone_II.png";
import armorUpgradeStoneIII from "../img/Armor_Upgrade_Stone_III.png";
import armorUpgradeStoneIV from "../img/Armor_Upgrade_Stone_IV.png";
import armorUpgradeStoneSK from "../img/Armor_Upgrade_Stone_SK.png";
import armorUpgradeStoneV from "../img/Armor_Upgrade_Stone_V.png";
import armorUpgradeStoneVI from "../img/Armor_Upgrade_Stone_VI.png";
import atomicStamp from "../img/Atomic_Stamp.png";
import audioCord from "../img/Audio_Cord.png";
import avastYarStamp from "../img/Avast_Yar_Stamp.png";
import averageBugPouch from "../img/Average_Bug_Pouch.png";
import averageChoppinPouch from "../img/Average_Choppin_Pouch.png";
import averageEXPPotion from "../img/Average_EXP_Potion.png";
import averageFishPouch from "../img/Average_Fish_Pouch.png";
import averageFoodPouch from "../img/Average_Food_Pouch.png";
import averageLifePotion from "../img/Average_Life_Potion.png";
import averageManaPotion from "../img/Average_Mana_Potion.png";
import averageMaterialPouch from "../img/Average_Material_Pouch.png";
import averageMiningPouch from "../img/Average_Mining_Pouch.png";
import averageSpeedPotion from "../img/Average_Speed_Potion.png";
import averageStrengthPotion from "../img/Average_Strength_Potion.png";
import babaYagaBabyEggs from "../img/Baba_Yaga_Baby_Eggs.png";
import babaYagaCard from "../img/Baba_Yaga_Card.png";
import babyBoaCard from "../img/Baby_Boa_Card.png";
import babyTrollCard from "../img/Baby_Troll_Card.png";
import bagOHeadsStamp from "../img/Bag_o_Heads_Stamp.png";
import bagONuts from "../img/Bag_o_Nuts.png";
import ballTimerStamp from "../img/Ball_Timer_Stamp.png";
import baller from "../img/Baller.png";
import ballingNametag from "../img/Balling_Nametag.png";
import ballJoePickle from "../img/BallJoePickle.png";
import balloonDogChain from "../img/Balloon_Dog_Chain.png";
import bamboo from "../img/Bamboo.png";
import bambooHat from "../img/Bamboo_Hat.png";
import bambooLogs from "../img/Bamboo_Logs.png";
import bambooLogsCard from "../img/Bamboo_Logs_Card.png";
import bambooSpiritCard from "../img/Bamboo_Spirit_Card.png";
import bambooTree from "../img/Bamboo_Tree.png";
import bandageWraps from "../img/Bandage_Wraps.png";
import banditBobCard from "../img/Bandit_Bob_Card.png";
import banditBobMask from "../img/Bandit_Bob_Mask.png";
import banditBobToken from "../img/Bandit_Bob_Token.png";
import banditoBoots from "../img/Bandito_Boots.png";
import banditoPantaloon from "../img/Bandito_Pantaloon.png";
import bankedPtsStamp from "../img/Banked_Pts_Stamp.png";
import baseballHat from "../img/Baseball_Hat.png";
import basicBobber from "../img/Basic_Bobber.png";
import basketball from "../img/Basketball.png";
import battleaxeStamp from "../img/Battleaxe_Stamp.png";
import battleaxeStatue from "../img/Battleaxe_Statue.png";
import beachBro from "../img/Beach_Bro.png";
import beachOyster from "../img/Beach_Oyster.png";
import beanSlices from "../img/Bean_Slices.png";
import bedsheetWithHoles from "../img/Bedsheet_with_Holes.png";
import beeHive from "../img/Bee_Hive.png";
import beefieCard from "../img/Beefie_Card.png";
import beginnerRecipe from "../img/Beginner_Recipe.png";
import beholderStatue from "../img/Beholder_Statue.png";
import bejeweledRing from "../img/Bejeweled_Ring.png";
import bellowsToken from "../img/Bellows_Token.png";
import biblioStamp from "../img/Biblio_Stamp.png";
import bigBugPouch from "../img/Big_Bug_Pouch.png";
import bigBunny from "../img/Big_Bunny.png";
import bigChoppinPouch from "../img/Big_Choppin_Pouch.png";
import bigCritterPouch from "../img/Big_Critter_Pouch.png";
import bigFishPouch from "../img/Big_Fish_Pouch.png";
import bigFoodPouch from "../img/Big_Food_Pouch.png";
import bigMaterialsPouch from "../img/Big_Materials_Pouch.png";
import bigMiningPouch from "../img/Big_Mining_Pouch.png";
import bigPrettyBow from "../img/Big_Pretty_Bow.png";
import bigSoulPouch from "../img/Big_Soul_Pouch.png";
import biggieHoursCard from "../img/Biggie_Hours_Card.png";
import biggoleMoleCard from "../img/Biggole_Mole_Card.png";
import biggoleWurmCard from "../img/Biggole_Wurm_Card.png";
import billBrrToken from "../img/Bill_Brr_Token.png";
import billBrrsVote from "../img/Bill_Brr-s_Vote.png";
import billJackPepper from "../img/Bill_Jack_Pepper.png";
import birchLongbow from "../img/Birch_Longbow.png";
import birchTree from "../img/Birch_Tree.png";
import birthdayCandle from "../img/Birthday_Candle.png";
import birthdayCard from "../img/Birthday_Card.png";
import blackDiamondRhinestone from "../img/Black_Diamond_Rhinestone.png";
import blackDiamondUlthurite from "../img/Black_Diamond_Ulthurite.png";
import blackLense from "../img/Black_Lense.png";
import blackPearl from "../img/Black_Pearl.png";
import blackTee from "../img/Black_Tee.png";
import blackheartStamp from "../img/Blackheart_Stamp.png";
import blackholeBow from "../img/Blackhole_Bow.png";
import bleachLogs from "../img/Bleach_Logs.png";
import bleachLogsCard from "../img/Bleach_Logs_Card.png";
import bleachedDesignerWodePatchPants from "../img/Bleached_Designer_Wode_Patch_Pants.png";
import blightedChizoarCard from "../img/Blighted_Chizoar_Card.png";
import blightedChizoarShardCape from "../img/Blighted_Chizoar_Shard_Cape.png";
import blindingLantern from "../img/Blinding_Lantern.png";
import blitzkriegTrollCard from "../img/Blitzkrieg_Troll_Card.png";
import blizzardBow from "../img/Blizzard_Bow.png";
import bloach from "../img/Bloach.png";
import bloachCard from "../img/Bloach_Card.png";
import blobfish from "../img/Blobfish.png";
import blobfishCard from "../img/Blobfish_Card.png";
import bloodBone from "../img/Blood_Bone.png";
import bloodboneCard from "../img/Bloodbone_Card.png";
import bloomingVine from "../img/Blooming_Vine.png";
import bloqueCard from "../img/Bloque_Card.png";
import bloqueMask from "../img/Bloque_Mask.png";
import bloverStamp from "../img/Blover_Stamp.png";
import blueTee from "../img/Blue_Tee.png";
import blueTomePages from "../img/Blue_Tome_Pages.png";
import blunderHero from "../img/Blunder_Hero.png";
import blunderSkillsCompletionToken from "../img/Blunder_Skills_Completion_Token.png";
import blunderbag from "../img/Blunderbag.png";
import blunderhillsMiscCompletionToken from "../img/Blunderhills_Misc_Completion_Token.png";
import blunderhillsNPCCompletionToken from "../img/Blunderhills_NPC_Completion_Token.png";
import boatStatue from "../img/Boat_Statue.png";
import bobRing from "../img/Bob_Ring.png";
import bobGoldPickleChain from "../img/BobGoldPickle_Chain.png";
import bobJoePickle from "../img/BobJoePickle.png";
import bolsteredDNASplicer from "../img/Bolstered_DNA_Splicer.png";
import boltCutters from "../img/Bolt_Cutters.png";
import boneJoePickle from "../img/BoneJoePickle.png";
import bonemeal from "../img/Bonemeal.png";
import bookStamp from "../img/Book_Stamp.png";
import boopCard from "../img/Boop_Card.png";
import bopBoxCard from "../img/Bop_Box_Card.png";
import boredBeanCard from "../img/Bored_Bean_Card.png";
import boredBeanie from "../img/Bored_Beanie.png";
import boringBrick from "../img/Boring_Brick.png";
import borzoiTopper from "../img/Borzoi_Topper.png";
import bossiusObolStack from "../img/Bossius_Obol_Stack.png";
import bottleCap from "../img/Bottle_Cap.png";
import bottledTownTeleport from "../img/Bottled_Town_Teleport.png";
import bottledWind from "../img/Bottled_Wind.png";
import bottledWorldTownTeleport from "../img/Bottled_World_Town_Teleport.png";
import boxStatue from "../img/Box_Statue.png";
import boxingGloves from "../img/Boxing_Gloves.png";
import brainstewStamps from "../img/Brainstew_Stamps.png";
import breezyBattle from "../img/Breezy_Battle_Totem.gif";
import breezySoul from "../img/Breezy_Soul.png";
import breezySoulCard from "../img/Breezy_Soul_Card.png";
import brokenMic from "../img/Broken_Mic.png";
import brokenWeapon from "../img/Broken_Weapon.png";
import bronzeAGIObol from "../img/Bronze_AGI_Obol.png";
import bronzeChest from "../img/Bronze_Chest.png";
import bronzeLUKObol from "../img/Bronze_LUK_Obol.png";
import bronzeObolOfCards from "../img/Bronze_Obol_of_Cards.png";
import bronzeObolOfChippinChops from "../img/Bronze_Obol_of_Chippin_Chops.png";
import bronzeObolOfConstruction from "../img/Bronze_Obol_of_Construction.png";
import bronzeObolOfDefence from "../img/Bronze_Obol_of_Defence.png";
import bronzeObolOfExperience from "../img/Bronze_Obol_of_Experience.png";
import bronzeObolOfFewFlies from "../img/Bronze_Obol_of_Few_Flies.png";
import bronzeObolOfFiniteFish from "../img/Bronze_Obol_of_Finite_Fish.png";
import bronzeObolOfMultikill from "../img/Bronze_Obol_of_Multikill.png";
import bronzeObolOfPop from "../img/Bronze_Obol_of_Pop.png";
import bronzeObolOfPunyDamage from "../img/Bronze_Obol_of_Puny_Damage.png";
import bronzeObolOfSmallSwings from "../img/Bronze_Obol_of_Small_Swings.png";
import bronzeObolOfTrapping from "../img/Bronze_Obol_of_Trapping.png";
import bronzeObolOfWorship from "../img/Bronze_Obol_of_Worship.png";
import bronzeSTRObol from "../img/Bronze_STR_Obol.png";
import bronzeWISObol from "../img/Bronze_WIS_Obol.png";
import bubbleRing from "../img/Bubble_Ring.png";
import bubbulyteCard from "../img/Bubbulyte_Card.png";
import bucklerStamp from "../img/Buckler_Stamp.png";
import bugsackStamp from "../img/Bugsack_Stamp.png";
import bullet from "../img/Bullet.png";
import bullfrogHorn from "../img/Bullfrog_Horn.png";
import bullseyeStamp from "../img/Bullseye_Stamp.png";
import bullseyeStatue from "../img/Bullseye_Statue.png";
import bummoBag from "../img/Bummo_Bag.png";
import bunchaBanana from "../img/Buncha_Banana.png";
import bunny from "../img/Bunny.png";
import bunnyCard from "../img/Bunny_Card.png";
import bunnyEars from "../img/Bunny_Ears.png";
import buntCake from "../img/Bunt_Cake.png";
import burnedMarshmallow from "../img/Burned_Marshmallow.png";
import butterBar from "../img/Butter_Bar.png";
import butteredToastedButter from "../img/Buttered_Toasted_Butter.png";
import butterfly from "../img/Butterfly.png";
import butterflyBar from "../img/Butterfly_Bar.png";
import butterflyCard from "../img/Butterfly_Card.png";
import buzzBuzzStamp from "../img/Buzz_Buzz_Stamp.png";
import cabbage from "../img/Cabbage.png";
import cactopunkCard from "../img/Cactopunk_Card.png";
import cactusChain from "../img/Cactus_Chain.png";
import candyCanes from "../img/Candy_Canes.png";
import cannoli from "../img/Cannoli.png";
import canopy from "../img/Canopy.png";
import capitalistCase from "../img/Capitalist_Case.png";
import captalistStatsStamp from "../img/Captalist_Stats_Stamp.png";
import cardStamp from "../img/Card_Stamp.png";
import cardboardTraps from "../img/Cardboard_Traps.png";
import carpetiemToken from "../img/Carpetiem_Token.png";
import carrotCube from "../img/Carrot_Cube.png";
import carrotHorror from "../img/Carrot_Horror.png";
import carrotLauncher from "../img/Carrot_Launcher.png";
import carrotmanCard from "../img/Carrotman_Card.png";
import carrotmanMask from "../img/Carrotman_Mask.png";
import cascadingScaledCapeOfKrieg from "../img/Cascading_Scaled_Cape_of_Krieg.png";
import casualConfidante from "../img/Casual_Confidante.png";
import catchNetStamp from "../img/Catch_Net_Stamp.png";
import cattleCoreSoothsayerStaff from "../img/Cattle_Core_Soothsayer_Staff.png";
import cattleprodToken from "../img/Cattleprod_Token.png";
import cauldronStatue from "../img/Cauldron_Statue.png";
import caulifish from "../img/Caulifish.png";
import caulifishCard from "../img/Caulifish_Card.png";
import cauliflower from "../img/Cauliflower.png";
import causticGlaciaxusCard from "../img/Caustic_Glaciaxus_Card.png";
import cavernTrekkers from "../img/Cavern_Trekkers.png";
import cedarPendant from "../img/Cedar_Pendant.png";
import ceramicSkull from "../img/Ceramic_Skull.png";
import ceramicSpiritCard from "../img/Ceramic_Spirit_Card.png";
import chainLink from "../img/Chain_Link.png";
import chaoticAmarokCard from "../img/Chaotic_Amarok_Card.png";
import chaoticAmarokPendant from "../img/Chaotic_Amarok_Pendant.png";
import chaoticAmarokSlab from "../img/Chaotic_Amarok_Slab.png";
import chaoticChizoarCard from "../img/Chaotic_Chizoar_Card.png";
import chaoticEfauntCard from "../img/Chaotic_Efaunt_Card.png";
import chaoticEmperorCard from "../img/Chaotic_Emperor_Card.png";
import chaoticKattlekrukCard from "../img/Chaotic_Kattlekruk_Card.png";
import chaoticTrollCard from "../img/Chaotic_Troll_Card.png";
import charcoalHat from "../img/Charcoal_Hat.png";
import cheese from "../img/Cheese.png";
import cheeseNubCard from "../img/Cheese_Nub_Card.png";
import cheesyBread from "../img/Cheesy_Bread.png";
import cheesyChest from "../img/Cheesy_Chest.png";
import cheesyCrumbs from "../img/Cheesy_Crumbs.png";
import cheezyPizza from "../img/Cheezy_Pizza.png";
import chefHatShoes from "../img/Chef_Hat_Shoes.png";
import chefRing from "../img/Chef_Ring.png";
import cherryChoco from "../img/Cherry_Choco.png";
import chizoarBodyplate from "../img/Chizoar_Bodyplate.png";
import chizoarCard from "../img/Chizoar_Card.png";
import chizoarHelmet from "../img/Chizoar_Helmet.png";
import chizoarScaledLeggings from "../img/Chizoar_Scaled_Leggings.png";
import chizoarSpike from "../img/Chizoar_Spike.png";
import chizoarStalagmite from "../img/Chizoar_Stalagmite.png";
import chizoarWalkers from "../img/Chizoar_Walkers.png";
import chizoarsCavernKey from "../img/Chizoar-s_Cavern_Key.png";
import chizoarsBlankie from "../img/Chizoars_Blankie.png";
import chizoarsCausticScarf from "../img/Chizoars_Caustic_Scarf.png";
import choccieCard from "../img/Choccie_Card.png";
import choccoBoxCard from "../img/Chocco_Box_Card.png";
import chocoBox from "../img/Choco_Box.png";
import chocolateTruffle from "../img/Chocolate_Truffle.png";
import chocolateyChip from "../img/Chocolatey_Chip.png";
import choggNog from "../img/Chogg_Nog.png";
import choppedLeek from "../img/Chopped_Leek.png";
import choppinBagStamp from "../img/Choppin-_Bag_Stamp.png";
import chromatiumFrogCard from "../img/Chromatium_Frog_Card.png";
import cinderForgeCard from "../img/Cinder_Forge_Card.png";
import citricConflict from "../img/Citric_Conflict_Totem.gif";
import citringeCard from "../img/Citringe_Card.png";
import claimingCashe from "../img/Claiming_Cashe.png";
import clammieCard from "../img/Clammie_Card.png";
import clashOfCans from "../img/Clash_of_Cans_Totem.gif";
import classCertificate from "../img/Class_Certificate.png";
import cloudsoundFollower from "../img/Cloudsound_Follower.png";
import cloverStamp from "../img/Clover_Stamp.png";
import clubMaestro from "../img/Club_Maestro.png";
import clubMember from "../img/Club_Member.png";
import coastiolyteCard from "../img/Coastiolyte_Card.png";
import coconotnotto from "../img/Coconotnotto.png";
import coldseekerBullet from "../img/Coldseeker_Bullet.png";
import colossalBugPouch from "../img/Colossal_Bug_Pouch.png";
import colossalChoppingPouch from "../img/Colossal_Chopping_Pouch.png";
import colossalCrittaPouch from "../img/Colossal_Critta_Pouch.png";
import colossalFishPouch from "../img/Colossal_Fish_Pouch.png";
import colossalFoodPouch from "../img/Colossal_Food_Pouch.png";
import colossalMattyPouch from "../img/Colossal_Matty_Pouch.png";
import colossalMiningPouch from "../img/Colossal_Mining_Pouch.png";
import colossalSoulPouch from "../img/Colossal_Soul_Pouch.png";
import colosseumTicket from "../img/Colosseum_Ticket.png";
import compostBag from "../img/Compost_Bag.png";
import compostStatue from "../img/Compost_Statue.png";
import condensedZap from "../img/Condensed_Zap.png";
import conductiveMotherboard from "../img/Conductive_Motherboard.png";
import conductiveNanochip from "../img/Conductive_Nanochip.png";
import conductiveProcessor from "../img/Conductive_Processor.png";
import conductiveSoftware from "../img/Conductive_Software.png";
import conjocharmoStamp from "../img/Conjocharmo_Stamp.png";
import conquistadorPlume from "../img/Conquistador_Plume.png";
import contactLense from "../img/Contact_Lense.png";
import containmentOfTheZrgyios from "../img/Containment_of_the_Zrgyios.png";
import cookedMealStamp from "../img/Cooked_Meal_Stamp.png";
import cookingClogs from "../img/Cooking_Clogs.png";
import cookingLadle from "../img/Cooking_Ladle.png";
import coolDiggyToolStamp from "../img/Cool_Diggy_Tool_Stamp.png";
import copperBand from "../img/Copper_Band.png";
import copperBar from "../img/Copper_Bar.png";
import copperBoots from "../img/Copper_Boots.png";
import copperChopper from "../img/Copper_Chopper.png";
import copperFishRod from "../img/Copper_Fish_Rod.png";
import copperHelmet from "../img/Copper_Helmet.png";
import copperNettedNet from "../img/Copper_Netted_Net.png";
import copperOre from "../img/Copper_Ore.png";
import copperOreCard from "../img/Copper_Ore_Card.png";
import copperPickaxe from "../img/Copper_Pickaxe.png";
import copperPlatebody from "../img/Copper_Platebody.png";
import copperPlatelegs from "../img/Copper_Platelegs.png";
import copperTwine from "../img/Copper_Twine.png";
import copperVein from "../img/Copper_Vein.png";
import corgiTopper from "../img/Corgi_Topper.png";
import corn from "../img/Corn.png";
import cornKernels from "../img/Corn_Kernels.png";
import corndog from "../img/Corndog.png";
import corporatubeSub from "../img/Corporatube_Sub.png";
import cosmicBall from "../img/Cosmic_Ball.png";
import cosmicStorageChest from "../img/Cosmic_Storage_Chest.png";
import cosmicTimeCandy from "../img/Cosmic_Time_Candy.png";
import cottonCandy from "../img/Cotton_Candy.png";
import cowboGalloneer from "../img/Cowbo_Galloneer.png";
import cowboJonesToken from "../img/Cowbo_Jones_Token.png";
import crabbo from "../img/Crabbo.png";
import crabboCard from "../img/Crabbo_Card.png";
import crabbyCakey from "../img/Crabby_Cakey.png";
import crabcakeCard from "../img/Crabcake_Card.png";
import crackedGlass from "../img/Cracked_Glass.png";
import crackledSkullDestroyer from "../img/Crackled_Skull_Destroyer.png";
import crampedBugPouch from "../img/Cramped_Bug_Pouch.png";
import crampedChoppinPouch from "../img/Cramped_Choppin_Pouch.png";
import crampedFishPouch from "../img/Cramped_Fish_Pouch.png";
import crampedFoodPouch from "../img/Cramped_Food_Pouch.png";
import crampedMaterialPouch from "../img/Cramped_Material_Pouch.png";
import crampedMiningPouch from "../img/Cramped_Mining_Pouch.png";
import cranberryJam from "../img/Cranberry_Jam.png";
import crashBox from "../img/Crash_Box.png";
import crawlerCard from "../img/Crawler_Card.png";
import crescentMoonPendant from "../img/Crescent_Moon_Pendant.png";
import crescentScorpie from "../img/Crescent_Scorpie.png";
import crescentSpudCard from "../img/Crescent_Spud_Card.png";
import crimsonString from "../img/Crimson_String.png";
import critterBaron from "../img/Critter_Baron.png";
import critterNumnums from "../img/Critter_Numnums.png";
import croissant from "../img/Croissant.png";
import cropEvoStamp from "../img/Crop_Evo_Stamp.png";
import cropTransferTicket from "../img/Crop_Transfer_Ticket.png";
import crownOfTheGods from "../img/Crown_of_the_Gods.png";
import crowsNest from "../img/Crows_Nest.png";
import crudeOil from "../img/Crude_Oil.png";
import crumpledWrapper from "../img/Crumpled_Wrapper.png";
import cryosnakeCard from "../img/Cryosnake_Card.png";
import cryosnakeSkin from "../img/Cryosnake_Skin.png";
import crystalCandalightCard from "../img/Crystal_Candalight_Card.png";
import crystalCapybaraCard from "../img/Crystal_Capybara_Card.png";
import crystalCarrotCard from "../img/Crystal_Carrot_Card.png";
import crystalCattleCard from "../img/Crystal_Cattle_Card.png";
import crystalCrabalCard from "../img/Crystal_Crabal_Card.png";
import crystalCustardCard from "../img/Crystal_Custard_Card.png";
import crystalSkullOfEsquireVnoze from "../img/Crystal_Skull_of_Esquire_Vnoze.png";
import crystallin from "../img/Crystallin.png";
import crystalswineToken from "../img/Crystalswine_Token.png";
import cthulusRing from "../img/Cthulu-s_Ring.png";
import cubedLogs from "../img/Cubed_Logs.png";
import cubedLogsCard from "../img/Cubed_Logs_Card.png";
import cubedTree from "../img/Cubed_Tree.png";
import cueTape from "../img/Cue_Tape.png";
import cultistSkull from "../img/Cultist_Skull.png";
import cupcake from "../img/Cupcake.png";
import daintyBrim from "../img/Dainty_Brim.png";
import dairyDunk from "../img/Dairy_Dunk.png";
import damagedCog from "../img/Damaged_Cog.png";
import damascusPlates from "../img/Damascus_Plates.png";
import dandelioliTree from "../img/Dandelioli_Tree.png";
import dandielogs from "../img/Dandielogs.png";
import dandielogsCard from "../img/Dandielogs_Card.png";
import dango from "../img/Dango.png";
import dankPaypayChest from "../img/Dank_Paypay_Chest.png";
import darkLantern from "../img/Dark_Lantern.png";
import darkTriadEssenceStamp from "../img/Dark_Triad_Essence_Stamp.png";
import dawnStopwatch from "../img/Dawn_Stopwatch.png";
import dazeyToken from "../img/Dazey_Token.png";
import deathWish from "../img/Death_Wish.png";
import deathbloomFlowerPendant from "../img/Deathbloom_Flower_Pendant.png";
import deathlyClusterPendant from "../img/Deathly_Cluster_Pendant.png";
import decentEXPPotion from "../img/Decent_EXP_Potion.png";
import decentLifePotion from "../img/Decent_Life_Potion.png";
import decentManaPotion from "../img/Decent_Mana_Potion.png";
import decentSpeedPotion from "../img/Decent_Speed_Potion.png";
import decentStrengthPotion from "../img/Decent_Strength_Potion.png";
import dedotatedRamCard from "../img/Dedotated_Ram_Card.png";
import deepSeaGaloshes from "../img/Deep_Sea_Galoshes.png";
import deepwaterTrenchRing from "../img/Deepwater_Trench_Ring.png";
import defendersDignity from "../img/Defenders_Dignity.png";
import dementedEmperorOpal from "../img/Demented_Emperor_Opal.png";
import dementedSpiritlordCard from "../img/Demented_Spiritlord_Card.png";
import dementiaAGIObol from "../img/Dementia_AGI_Obol.png";
import dementiaBar from "../img/Dementia_Bar.png";
import dementiaBody from "../img/Dementia_Body.png";
import dementiaBoots from "../img/Dementia_Boots.png";
import dementiaDicer from "../img/Dementia_Dicer.png";
import dementiaHelmet from "../img/Dementia_Helmet.png";
import dementiaLUKObol from "../img/Dementia_LUK_Obol.png";
import dementiaNet from "../img/Dementia_Net.png";
import dementiaObolOfCards from "../img/Dementia_Obol_of_Cards.png";
import dementiaObolOfColossalCrawlies from "../img/Dementia_Obol_of_Colossal_Crawlies.png";
import dementiaObolOfConstruction from "../img/Dementia_Obol_of_Construction.png";
import dementiaObolOfDefence from "../img/Dementia_Obol_of_Defence.png";
import dementiaObolOfExperience from "../img/Dementia_Obol_of_Experience.png";
import dementiaObolOfInfinisixes from "../img/Dementia_Obol_of_Infinisixes.png";
import dementiaObolOfInfiniteDamage from "../img/Dementia_Obol_of_Infinite_Damage.png";
import dementiaObolOfKillionaire from "../img/Dementia_Obol_of_Killionaire.png";
import dementiaObolOfMagisterialMetals from "../img/Dementia_Obol_of_Magisterial_Metals.png";
import dementiaObolOfMonumentMarlins from "../img/Dementia_Obol_of_Monument_Marlins.png";
import dementiaObolOfPopPopPopPop from "../img/Dementia_Obol_of_Pop_Pop_Pop_Pop.png";
import dementiaObolOfTrapping from "../img/Dementia_Obol_of_Trapping.png";
import dementiaObolOfWorship from "../img/Dementia_Obol_of_Worship.png";
import dementiaObolOfWOWOWOWWO from "../img/Dementia_Obol_of_WOWOWOWWO.png";
import dementiaOre from "../img/Dementia_Ore.png";
import dementiaOreCard from "../img/Dementia_Ore_Card.png";
import dementiaPickaxe from "../img/Dementia_Pickaxe.png";
import dementiaRodForFishing from "../img/Dementia_Rod_for_Fishing.png";
import dementiaShins from "../img/Dementia_Shins.png";
import dementiaSTRObol from "../img/Dementia_STR_Obol.png";
import dementiaSwordStamp from "../img/Dementia_Sword_Stamp.png";
import dementiaVein from "../img/Dementia_Vein.png";
import dementiaWISObol from "../img/Dementia_WIS_Obol.png";
import demonGenieCard from "../img/Demon_Genie_Card.png";
import denseWater from "../img/Dense_Water.png";
import desertTopaz from "../img/Desert_Topaz.png";
import destroyerOfTheMolloGomme from "../img/Destroyer_of_the_Mollo_Gomme.png";
import deuscythe from "../img/Deuscythe.png";
import deviousSlippersOfTheDivine from "../img/Devious_Slippers_of_the_Divine.png";
import diabolicalAbdomen from "../img/Diabolical_Abdomen.png";
import diabolicalContinuit from "../img/Diabolical_Continuit.png";
import diabolicalFleshRipper from "../img/Diabolical_Flesh_Ripper.png";
import diabolicalGauntlet from "../img/Diabolical_Gauntlet.png";
import diabolicalHeadcase from "../img/Diabolical_Headcase.png";
import diabolicalOpticule from "../img/Diabolical_Opticule.png";
import diabolicalToeTips from "../img/Diabolical_Toe_Tips.png";
import diabolicalTrimedLegGuards from "../img/Diabolical_Trimed_Leg_Guards.png";
import diamonHorns from "../img/Diamon_Horns.png";
import diamondAxeStamp from "../img/Diamond_Axe_Stamp.png";
import diamondDuck from "../img/Diamond_Duck.png";
import diamondHonkerChain from "../img/Diamond_Honker_Chain.png";
import diceDynamo from "../img/Dice_Dynamo.png";
import digDougCard from "../img/Dig_Doug_Card.png";
import dilapidatedSlushCard from "../img/Dilapidated_Slush_Card.png";
import dioxideSynthesis from "../img/Dioxide_Synthesis.png";
import dirtyCoalMinerBaggySootPants from "../img/Dirty_Coal_Miner_Baggy_Soot_Pants.png";
import distilledWater from "../img/Distilled_Water.png";
import divineStamp from "../img/Divine_Stamp.png";
import divinityPearl from "../img/Divinity_Pearl.png";
import divvySlippers from "../img/Divvy_Slippers.png";
import djonnutToken from "../img/Djonnut_Token.png";
import dNAStamp from "../img/DNA_Stamp.png";
import dogBone from "../img/Dog_Bone.png";
import dogBoneToken from "../img/Dog_Bone_Token.png";
import domeoMagmusCard from "../img/Domeo_Magmus_Card.png";
import donut from "../img/Donut.png";
import donutCard from "../img/Donut_Card.png";
import doobleGoopi from "../img/Dooble_Goopi.png";
import dootjatEye from "../img/Dootjat_Eye.png";
import dootophone from "../img/Dootophone.png";
import doubleBarreledDNASplicer from "../img/Double_Barreled_DNA_Splicer.png";
import doubleCherry from "../img/Double_Cherry.png";
import doublestringGodshooter from "../img/Doublestring_Godshooter.png";
import drDefecausCard from "../img/Dr_Defecaus_Card.png";
import dreadloBar from "../img/Dreadlo_Bar.png";
import dreadloHatchet from "../img/Dreadlo_Hatchet.png";
import dreadloMattedNetting from "../img/Dreadlo_Matted_Netting.png";
import dreadloOre from "../img/Dreadlo_Ore.png";
import dreadloOreCard from "../img/Dreadlo_Ore_Card.png";
import dreadloPickolo from "../img/Dreadlo_Pickolo.png";
import dreadloRod from "../img/Dreadlo_Rod.png";
import dreadloVein from "../img/Dreadlo_Vein.png";
import dreadnaughtSkull from "../img/Dreadnaught_Skull.png";
import dreamParticulate from "../img/Dream_Particulate.png";
import driedPaintBlob from "../img/Dried_Paint_Blob.png";
import dripOfTheGods from "../img/Drip_of_the_Gods.png";
import drippyDropStamp from "../img/Drippy_Drop_Stamp.png";
import droplotsStamp from "../img/Droplots_Stamp.png";
import dualhookProngs from "../img/Dualhook_Prongs.png";
import dumbphoneChain from "../img/Dumbphone_Chain.png";
import dumpling from "../img/Dumpling.png";
import duneKillerRing from "../img/Dune_Killer_Ring.png";
import duneSoul from "../img/Dune_Soul.png";
import duneSoulCard from "../img/Dune_Soul_Card.png";
import dungBeat from "../img/Dung_Beat.png";
import dungBeatCard from "../img/Dung_Beat_Card.png";
import dungeonCardPack from "../img/Dungeon_Card_Pack.png";
import dungeonCredits from "../img/Dungeon_Credits.png";
import dungeonCreditsFlurboEdition from "../img/Dungeon_Credits_Flurbo_Edition.png";
import dungeonLootDice from "../img/Dungeon_Loot_Dice.png";
import duplogsStamp from "../img/Duplogs_Stamp.png";
import durianFruit from "../img/Durian_Fruit.png";
import dustMote from "../img/Dust_Mote.png";
import dustMoteCard from "../img/Dust_Mote_Card.png";
import dynamite from "../img/Dynamite.png";
import easterArmorStone from "../img/Easter_Armor_Stone.png";
import easterEggBackpack from "../img/Easter_Egg_Backpack.png";
import easterToolUpgradeStone from "../img/Easter_Tool_Upgrade_Stone.png";
import easterWeaponStone from "../img/Easter_Weapon_Stone.png";
import easyBlunderhillsNPCToken from "../img/Easy_Blunderhills_NPC_Token.png";
import easyFBTundraNPCToken from "../img/Easy_FB_Tundra_NPC_Token.png";
import easyYumyumDezNPCToken from "../img/Easy_Yumyum_Dez_NPC_Token.png";
import eclecticOrdeal from "../img/Eclectic_Ordeal.png";
import ecoFriendlyOil from "../img/Eco_Friendly_Oil.png";
import eel from "../img/Eel.png";
import efauntCard from "../img/Efaunt_Card.png";
import efauntHelmet from "../img/Efaunt_Helmet.png";
import efauntHipilium from "../img/Efaunt_Hipilium.png";
import efauntRibcage from "../img/Efaunt_Ribcage.png";
import efauntTrunculus from "../img/Efaunt_Trunculus.png";
import efauntsTombKey from "../img/Efaunt-s_Tomb_Key.png";
import efauntsBrokenAnkles from "../img/Efaunts_Broken_Ankles.png";
import effervescentEucalyptusTree from "../img/Effervescent_Eucalyptus_Tree.png";
import effervescentLogs from "../img/Effervescent_Logs.png";
import effervescentLogsCard from "../img/Effervescent_Logs_Card.png";
import egalitarianTraps from "../img/Egalitarian_Traps.png";
import egg from "../img/Egg.png";
import eggCapsule from "../img/Egg_Capsule.png";
import eggCapsuleCard from "../img/Egg_Capsule_Card.png";
import eggStamp from "../img/Egg_Stamp.png";
import eggStatue from "../img/Egg_Statue.png";
import egggulyteCard from "../img/Egggulyte_Card.png";
import eggplant from "../img/Eggplant.png";
import ehExPeeStatue from "../img/EhExPee_Statue.png";
import elderlyPeanut from "../img/Elderly_Peanut.png";
import eldritchCroakerCard from "../img/Eldritch_Croaker_Card.png";
import eleSorcererPointedHat from "../img/Ele_Sorcerer_Pointed_Hat.png";
import electricalWiring from "../img/Electrical_Wiring.png";
import elegantSpear from "../img/Elegant_Spear.png";
import elegantineRobes from "../img/Elegantine_Robes.png";
import elfTwistRing from "../img/Elf_Twist_Ring.png";
import eliteClassSwapToken from "../img/Elite_Class_Swap_Token.png";
import emeraldNavette from "../img/Emerald_Navette.png";
import emeraldPyramite from "../img/Emerald_Pyramite.png";
import emeraldRhinestone from "../img/Emerald_Rhinestone.png";
import emeraldRhombol from "../img/Emerald_Rhombol.png";
import emeraldUlthurite from "../img/Emerald_Ulthurite.png";
import emperorCard from "../img/Emperor_Card.png";
import employmentStatistics from "../img/Employment_Statistics.png";
import emptyBox from "../img/Empty_Box.png";
import emptyOysterShell from "../img/Empty_Oyster_Shell.png";
import enforcedSlasher from "../img/Enforced_Slasher.png";
import engravedBullet from "../img/Engraved_Bullet.png";
import enragedSnakenhotepCard from "../img/Enraged_Snakenhotep_Card.png";
import epicSantaHat from "../img/Epic_Santa_Hat.png";
import equinoxFish from "../img/Equinox_Fish.png";
import equinoxMirror from "../img/Equinox_Mirror.png";
import equinoxRing from "../img/Equinox_Ring.png";
import equinoxWillowTree from "../img/Equinox_Willow_Tree.png";
import ergonomicDNASplicer from "../img/Ergonomic_DNA_Splicer.png";
import essenceStatue from "../img/Essence_Statue.png";
import eternalCardPack from "../img/Eternal_Card_Pack.png";
import eternalFlamesOfTheDivine from "../img/Eternal_Flames_of_The_Divine.png";
import eternalLordOfTheUndyingEmber from "../img/Eternal_Lord_of_The_Undying_Ember.png";
import eventPoint from "../img/Event_Point.png";
import evergreenWraps from "../img/Evergreen_Wraps.png";
import evisceratedChunk from "../img/Eviscerated_Chunk.png";
import expBookStatue from "../img/Exp_Book_Statue.png";
import explosiveSalts from "../img/Explosive_Salts.png";
import eyeOweEssChain from "../img/Eye_Owe_Ess_Chain.png";
import fairy from "../img/Fairy.png";
import fairyCard from "../img/Fairy_Card.png";
import fairyHovel from "../img/Fairy_Hovel.png";
import falloweenNametag from "../img/Falloween_Nametag.png";
import falloweenPumpkinCard from "../img/Falloween_Pumpkin_Card.png";
import falloweenTreat from "../img/Falloween_Treat.png";
import fannedBlossomage from "../img/Fanned_Blossomage.png";
import farmerBrim from "../img/Farmer_Brim.png";
import farmerBrimest from "../img/Farmer_Brimest.png";
import fatAlbert from "../img/Fat_Albert.png";
import feastyStatue from "../img/Feasty_Statue.png";
import featherStamp from "../img/Feather_Stamp.png";
import feralLeathering from "../img/Feral_Leathering.png";
import festiveBeastMask from "../img/Festive_Beast_Mask.png";
import fiberousFootings from "../img/Fiberous_Footings.png";
import fieryMane from "../img/Fiery_Mane.png";
import fireForgeCard from "../img/Fire_Forge_Card.png";
import fireSpiritCard from "../img/Fire_Spirit_Card.png";
import firefly from "../img/Firefly.png";
import fireflyCard from "../img/Firefly_Card.png";
import fireflyNest from "../img/Firefly_Nest.png";
import fishheadPendant from "../img/Fishhead_Pendant.png";
import fishheadStamp from "../img/Fishhead_Stamp.png";
import fishingOveralls from "../img/Fishing_Overalls.png";
import fishingRodStamp from "../img/Fishing_Rod_Stamp.png";
import fishpasteToken from "../img/Fishpaste_Token.png";
import fistStamp from "../img/Fist_Stamp.png";
import flipFlops from "../img/Flip_Flops.png";
import flombeigeCard from "../img/Flombeige_Card.png";
import floofPloof from "../img/Floof_Ploof.png";
import floofieCard from "../img/Floofie_Card.png";
import flowies from "../img/Flowies.png";
import flowinStamp from "../img/Flowin_Stamp.png";
import fluffyRamsy from "../img/Fluffy_Ramsy.png";
import fly from "../img/Fly.png";
import flyCard from "../img/Fly_Card.png";
import flyIntelStamp from "../img/Fly_Intel_Stamp.png";
import flyNest from "../img/Fly_Nest.png";
import flycicle from "../img/Flycicle.png";
import flycicleCard from "../img/Flycicle_Card.png";
import flyingWormCard from "../img/Flying_Worm_Card.png";
import fMJBullet from "../img/FMJ_Bullet.png";
import forbiddenTraps from "../img/Forbidden_Traps.png";
import forestFibres from "../img/Forest_Fibres.png";
import forestFibresCard from "../img/Forest_Fibres_Card.png";
import forestSoul from "../img/Forest_Soul.png";
import forestSoulCard from "../img/Forest_Soul_Card.png";
import forestTree from "../img/Forest_Tree.png";
import forestVillaKey from "../img/Forest_Villa_Key.png";
import forestVillasFlyerThingy from "../img/Forest_Villas_Flyer_Thingy.png";
import forgeStamp from "../img/Forge_Stamp.png";
import forlornGrandfroggerCard from "../img/Forlorn_Grandfrogger_Card.png";
import fortuneCookie from "../img/Fortune_Cookie.png";
import frazzleberry from "../img/Frazzleberry.png";
import frenkFries from "../img/Frenk_Fries.png";
import frigidSoul from "../img/Frigid_Soul.png";
import frigidSoulCard from "../img/Frigid_Soul_Card.png";
import frisbeeRing from "../img/Frisbee_Ring.png";
import frogCard from "../img/Frog_Card.png";
import frogLeg from "../img/Frog_Leg.png";
import froge from "../img/Froge.png";
import frogeCard from "../img/Froge_Card.png";
import frostFlakeCard from "../img/Frost_Flake_Card.png";
import frostPrince from "../img/Frost_Prince.png";
import frostyFirefight from "../img/Frosty_Firefight_Totem.gif";
import frostymanNametag from "../img/Frostyman_Nametag.png";
import frozenObolOfChizoarsRage from "../img/Frozen_Obol_of_Chizoar-s_Rage.png";
import frozenTartChain from "../img/Frozen_Tart_Chain.png";
import fruitfly from "../img/Fruitfly.png";
import fruitflyCard from "../img/Fruitfly_Card.png";
import funFlags from "../img/Fun_Flags.png";
import funguyToken from "../img/Funguy_Token.png";
import funkyHat from "../img/Funky_Hat.png";
import funnyHat from "../img/Funny_Hat.png";
import furShirt from "../img/Fur_Shirt.png";
import furledFlag from "../img/Furled_Flag.png";
import furledRobes from "../img/Furled_Robes.png";
import fuscismatia from "../img/Fuscismatia.png";
import galacticLeaf from "../img/Galactic_Leaf.png";
import galaxialAmethyst from "../img/Galaxial_Amethyst.png";
import galaxyCardPack from "../img/Galaxy_Card_Pack.png";
import galvanicMotherboard from "../img/Galvanic_Motherboard.png";
import galvanicNanochip from "../img/Galvanic_Nanochip.png";
import galvanicProcessor from "../img/Galvanic_Processor.png";
import galvanicSoftware from "../img/Galvanic_Software.png";
import gamejoyStamp from "../img/Gamejoy_Stamp.png";
import gamingFertilizer from "../img/Gaming_Fertilizer.png";
import garbage from "../img/Garbage.png";
import gargantuanBugPouch from "../img/Gargantuan_Bug_Pouch.png";
import gargantuanChoppingPouch from "../img/Gargantuan_Chopping_Pouch.png";
import gargantuanCrittaPouch from "../img/Gargantuan_Critta_Pouch.png";
import gargantuanFishPouch from "../img/Gargantuan_Fish_Pouch.png";
import gargantuanFoodPouch from "../img/Gargantuan_Food_Pouch.png";
import gargantuanMattyPouch from "../img/Gargantuan_Matty_Pouch.png";
import gargantuanMiningPouch from "../img/Gargantuan_Mining_Pouch.png";
import gargantuanSoulPouch from "../img/Gargantuan_Soul_Pouch.png";
import garlicBread from "../img/Garlic_Bread.png";
import garliclessBread from "../img/Garlicless_Bread.png";
import gelChunk from "../img/Gel_Chunk.png";
import gelatinousChest from "../img/Gelatinous_Chest.png";
import gelatinousCuboidCard from "../img/Gelatinous_Cuboid_Card.png";
import gem from "../img/Gem.png";
import gemEnvelope from "../img/Gem_Envelope.png";
import genieLamp from "../img/Genie_Lamp.png";
import ghost from "../img/Ghost.png";
import ghostEventCard from "../img/Ghost_(Event)_Card.png";
import giantNightshade from "../img/Giant_Nightshade.png";
import giantRose from "../img/Giant_Rose.png";
import giantRoseCard from "../img/Giant_Rose_Card.png";
import giantStarflower from "../img/Giant_Starflower.png";
import giantTomato from "../img/Giant_Tomato.png";
import giantViolet from "../img/Giant_Violet.png";
import giftmasBlobulyteCard from "../img/Giftmas_Blobulyte_Card.png";
import giftmasBox from "../img/Giftmas_Box.png";
import giftmasHelmetUpgradeStone from "../img/Giftmas_Helmet_Upgrade_Stone.png";
import giftmasSnoozyCap from "../img/Giftmas_Snoozy_Cap.png";
import giftmasToolUpgradeStone from "../img/Giftmas_Tool_Upgrade_Stone.png";
import giftmasTree from "../img/Giftmas_Tree.png";
import giftybreadMan from "../img/Giftybread_Man.png";
import gigafrogCard from "../img/Gigafrog_Card.png";
import gildedAxeStamp from "../img/Gilded_Axe_Stamp.png";
import gildedEfauntCard from "../img/Gilded_Efaunt_Card.png";
import gildedEfauntDislodgedTusks from "../img/Gilded_Efaunt_Dislodged_Tusks.png";
import gildedHeadband from "../img/Gilded_Headband.png";
import gildedKeyChain from "../img/Gilded_Key_Chain.png";
import giveUpOnLifePants from "../img/Give_Up_On_Life_Pants.png";
import glaciaxusCard from "../img/Glaciaxus_Card.png";
import glacierQuartz from "../img/Glacier_Quartz.png";
import gladiator from "../img/Gladiator.png";
import glassShard from "../img/Glass_Shard.png";
import glaussSkull from "../img/Glauss_Skull.png";
import globohopperCard from "../img/Globohopper_Card.png";
import glublinCard from "../img/Glublin_Card.png";
import glublinEar from "../img/Glublin_Ear.png";
import glublinMask from "../img/Glublin_Mask.png";
import glumleeToken from "../img/Glumlee_Token.png";
import glumleesSpecialTutorialOil from "../img/Glumlee-s_Special_Tutorial_Oil.png";
import gnarledWand from "../img/Gnarled_Wand.png";
import goblinGorfest from "../img/Goblin_Gorfest_Totem.gif";
import godshardBar from "../img/Godshard_Bar.png";
import godshardOre from "../img/Godshard_Ore.png";
import godshardOreCard from "../img/Godshard_Ore_Card.png";
import godshardVein from "../img/Godshard_Vein.png";
import goldAGIObol from "../img/Gold_AGI_Obol.png";
import goldBallStamp from "../img/Gold_Ball_Stamp.png";
import goldBar from "../img/Gold_Bar.png";
import goldBoots from "../img/Gold_Boots.png";
import goldChest from "../img/Gold_Chest.png";
import goldFishingRod from "../img/Gold_Fishing_Rod.png";
import goldFoodCoupon from "../img/Gold_Food_Coupon.png";
import goldHelmet from "../img/Gold_Helmet.png";
import goldLUKObol from "../img/Gold_LUK_Obol.png";
import goldOre from "../img/Gold_Ore.png";
import goldOreCard from "../img/Gold_Ore_Card.png";
import goldPickaxe from "../img/Gold_Pickaxe.png";
import goldPlatebody from "../img/Gold_Platebody.png";
import goldPlatelegs from "../img/Gold_Platelegs.png";
import goldPocketwatch from "../img/Gold_Pocketwatch.png";
import goldSTRObol from "../img/Gold_STR_Obol.png";
import goldTwine from "../img/Gold_Twine.png";
import goldVein from "../img/Gold_Vein.png";
import goldWISObol from "../img/Gold_WIS_Obol.png";
import goldeggCapsule from "../img/Goldegg_Capsule.png";
import goldenAppleStamp from "../img/Golden_Apple_Stamp.png";
import goldenAxe from "../img/Golden_Axe.png";
import goldenBread from "../img/Golden_Bread.png";
import goldenCake from "../img/Golden_Cake.png";
import goldenCheese from "../img/Golden_Cheese.png";
import goldenDubloon from "../img/Golden_Dubloon.png";
import goldenDumpling from "../img/Golden_Dumpling.png";
import goldenGift from "../img/Golden_Gift.png";
import goldenGiftmasBoxCard from "../img/Golden_Giftmas_Box_Card.png";
import goldenGlaciaxusCard from "../img/Golden_Glaciaxus_Card.png";
import goldenGrilledCheeseNomwich from "../img/Golden_Grilled_Cheese_Nomwich.png";
import goldenHam from "../img/Golden_Ham.png";
import goldenHampterGummyCandy from "../img/Golden_Hampter_Gummy_Candy.png";
import goldenJam from "../img/Golden_Jam.png";
import goldenKebabs from "../img/Golden_Kebabs.png";
import goldenMeatPie from "../img/Golden_Meat_Pie.png";
import goldenNet from "../img/Golden_Net.png";
import goldenNigiri from "../img/Golden_Nigiri.png";
import goldenNomwich from "../img/Golden_Nomwich.png";
import goldenObolOfBigBoyDamage from "../img/Golden_Obol_of_Big_Boy_Damage.png";
import goldenObolOfCards from "../img/Golden_Obol_of_Cards.png";
import goldenObolOfConstruction from "../img/Golden_Obol_of_Construction.png";
import goldenObolOfCrazyCarp from "../img/Golden_Obol_of_Crazy_Carp.png";
import goldenObolOfDefence from "../img/Golden_Obol_of_Defence.png";
import goldenObolOfDiligentDigging from "../img/Golden_Obol_of_Diligent_Digging.png";
import goldenObolOfExperience from "../img/Golden_Obol_of_Experience.png";
import goldenObolOfHugeHackin from "../img/Golden_Obol_of_Huge_Hackin.png";
import goldenObolOfInsaneInsects from "../img/Golden_Obol_of_Insane_Insects.png";
import goldenObolOfPlentifulRiches from "../img/Golden_Obol_of_Plentiful_Riches.png";
import goldenObolOfPoppityPop from "../img/Golden_Obol_of_Poppity_Pop.png";
import goldenObolOfTrapping from "../img/Golden_Obol_of_Trapping.png";
import goldenObolOfTripleSixes from "../img/Golden_Obol_of_Triple_Sixes.png";
import goldenObolOfUltrakill from "../img/Golden_Obol_of_Ultrakill.png";
import goldenObolOfWorship from "../img/Golden_Obol_of_Worship.png";
import goldenOyster from "../img/Golden_Oyster.png";
import goldenPeanut from "../img/Golden_Peanut.png";
import goldenPlop from "../img/Golden_Plop.png";
import goldenRibs from "../img/Golden_Ribs.png";
import goldenSixesStamp from "../img/Golden_Sixes_Stamp.png";
import goldfish from "../img/Goldfish.png";
import goldfishCard from "../img/Goldfish_Card.png";
import goldricToken from "../img/Goldric_Token.png";
import gooGaloshes from "../img/Goo_Galoshes.png";
import googleyEyes from "../img/Googley_Eyes.png";
import grandfroggerCard from "../img/Grandfrogger_Card.png";
import grandmaDisguise from "../img/Grandma_Disguise.png";
import graniteObolOfAmaroksStare from "../img/Granite_Obol_of_Amarok-s_Stare.png";
import grassLeaf from "../img/Grass_Leaf.png";
import greenBeanie from "../img/Green_Beanie.png";
import greenHeadband from "../img/Green_Headband.png";
import greenMushroomCard from "../img/Green_Mushroom_Card.png";
import greenTee from "../img/Green_Tee.png";
import greyBeret from "../img/Grey_Beret.png";
import greyGatsby from "../img/Grey_Gatsby.png";
import grilledCheeseNomwich from "../img/Grilled_Cheese_Nomwich.png";
import groceryBag from "../img/Grocery_Bag.png";
import groundedMotherboard from "../img/Grounded_Motherboard.png";
import groundedNanochip from "../img/Grounded_Nanochip.png";
import groundedProcessor from "../img/Grounded_Processor.png";
import groundedSoftware from "../img/Grounded_Software.png";
import grumbieTheHatchetHammer from "../img/Grumbie_the_Hatchet_Hammer.png";
import grumbloCard from "../img/Grumblo_Card.png";
import grumpyObolOfTheGrandfrogger from "../img/Grumpy_Obol_of_the_Grandfrogger.png";
import guardianMane from "../img/Guardian_Mane.png";
import guildGiftbox from "../img/Guild_Giftbox.png";
import guildingTools from "../img/Guilding_Tools.png";
import gummyBunny from "../img/Gummy_Bunny.png";
import halfEatenDonut from "../img/Half_Eaten_Donut.png";
import hallowedTailPendant from "../img/Hallowed_Tail_Pendant.png";
import halloweenPumpkin from "../img/Halloween_Pumpkin.png";
import hampter from "../img/Hampter.png";
import hardBlunderhillsNPCToken from "../img/Hard_Blunderhills_NPC_Token.png";
import hardFBTundraNPCToken from "../img/Hard_FB_Tundra_NPC_Token.png";
import hardHat from "../img/Hard_Hat.png";
import hardYumyumDezNPCToken from "../img/Hard_Yumyum_Dez_NPC_Token.png";
import hatPremiumifier from "../img/Hat_Premiumifier.png";
import hatchetStamp from "../img/Hatchet_Stamp.png";
import headChefBread from "../img/Head_Chef_Bread.png";
import healthStatue from "../img/Health_Statue.png";
import heartStamp from "../img/Heart_Stamp.png";
import heiressHeaddress from "../img/Heiress_Headdress.png";
import helmetUpgradeStoneI from "../img/Helmet_Upgrade_Stone_I.png";
import helmetUpgradeStoneSK from "../img/Helmet_Upgrade_Stone_SK.png";
import herculeanBugPouch from "../img/Herculean_Bug_Pouch.png";
import herculeanChoppingPouch from "../img/Herculean_Chopping_Pouch.png";
import herculeanCrittaPouch from "../img/Herculean_Critta_Pouch.png";
import herculeanFishPouch from "../img/Herculean_Fish_Pouch.png";
import herculeanFoodPouch from "../img/Herculean_Food_Pouch.png";
import herculeanMattyPouch from "../img/Herculean_Matty_Pouch.png";
import herculeanMiningPouch from "../img/Herculean_Mining_Pouch.png";
import herculeanSoulPouch from "../img/Herculean_Soul_Pouch.png";
import hermesStamp from "../img/Hermes_Stamp.png";
import hermitCan from "../img/Hermit_Can.png";
import hermitCanCard from "../img/Hermit_Can_Card.png";
import hideShirt from "../img/Hide_Shirt.png";
import hideyBoxStamp from "../img/Hidey_Box_Stamp.png";
import highIQLumberStamp from "../img/High_IQ_Lumber_Stamp.png";
import highSteaks from "../img/High_Steaks.png";
import hoggiToken from "../img/Hoggi_Token.png";
import holidayChest from "../img/Holiday_Chest.png";
import holyMackerelStamp from "../img/Holy_Mackerel_Stamp.png";
import holyPearl from "../img/Holy_Pearl.png";
import hONKRing from "../img/HONK_Ring.png";
import honker from "../img/Honker.png";
import honkerCard from "../img/Honker_Card.png";
import honkerHat from "../img/Honker_Hat.png";
import hornChain from "../img/Horn_Chain.png";
import hornedSkull from "../img/Horned_Skull.png";
import hotDog from "../img/Hot_Dog.png";
import hotdogHero from "../img/Hotdog_Hero.png";
import huskyHat from "../img/Husky_Hat.png";
import hyperDMGObol from "../img/Hyper_DMG_Obol.png";
import hyperDMGObolB from "../img/Hyper_DMG_Obol_B.png";
import hyperObolStack from "../img/Hyper_Obol_Stack.png";
import hyperObolStackSquareEdition from "../img/Hyper_Obol_Stack_Square_Edition.png";
import hyperPyreObol from "../img/Hyper_Pyre_Obol.png";
import hyperPyreObolB from "../img/Hyper_Pyre_Obol_B.png";
import hyperSixObol from "../img/Hyper_Six_Obol.png";
import hyperSixObolB from "../img/Hyper_Six_Obol_B.png";
import hyperSkullObol from "../img/Hyper_Skull_Obol.png";
import hyperSkullObolB from "../img/Hyper_Skull_Obol_B.png";
import iceAge3 from "../img/Ice_Age_3.png";
import iceCreamSundae from "../img/Ice_Cream_Sundae.png";
import iceGuardCard from "../img/Ice_Guard_Card.png";
import iceGuardHelmet from "../img/Ice_Guard_Helmet.png";
import icefish from "../img/Icefish.png";
import icefishCard from "../img/Icefish_Card.png";
import icicleNest from "../img/Icicle_Nest.png";
import icingIronbite from "../img/Icing_Ironbite.png";
import idleSkiller from "../img/Idle_Skiller.png";
import inevitableSnakenhotepCard from "../img/Inevitable_Snakenhotep_Card.png";
import instablabFollower from "../img/Instablab_Follower.png";
import intellectostampo from "../img/Intellectostampo.png";
import inventoryBagA from "../img/Inventory_Bag_A.png";
import inventoryBagB from "../img/Inventory_Bag_B.png";
import inventoryBagC from "../img/Inventory_Bag_C.png";
import inventoryBagD from "../img/Inventory_Bag_D.png";
import inventoryBagE from "../img/Inventory_Bag_E.png";
import inventoryBagF from "../img/Inventory_Bag_F.png";
import inventoryBagG from "../img/Inventory_Bag_G.png";
import inventoryBagH from "../img/Inventory_Bag_H.png";
import inventoryBagU from "../img/Inventory_Bag_U.png";
import inventoryBagV from "../img/Inventory_Bag_V.png";
import inventoryBagW from "../img/Inventory_Bag_W.png";
import inventoryBagX from "../img/Inventory_Bag_X.png";
import inventoryBagY from "../img/Inventory_Bag_Y.png";
import inventoryBagZ from "../img/Inventory_Bag_Z.png";
import invisibleHat from "../img/Invisible_Hat.png";
import ironBar from "../img/Iron_Bar.png";
import ironBoots from "../img/Iron_Boots.png";
import ironFishingRod from "../img/Iron_Fishing_Rod.png";
import ironHatchet from "../img/Iron_Hatchet.png";
import ironHelmet from "../img/Iron_Helmet.png";
import ironHook from "../img/Iron_Hook.png";
import ironOre from "../img/Iron_Ore.png";
import ironOreCard from "../img/Iron_Ore_Card.png";
import ironPickaxe from "../img/Iron_Pickaxe.png";
import ironPlatebody from "../img/Iron_Platebody.png";
import ironPlatelegs from "../img/Iron_Platelegs.png";
import ironVein from "../img/Iron_Vein.png";
import islandAdventurerNametag from "../img/Island_Adventurer_Nametag.png";
import itsABoyCelebration from "../img/Its_a_Boy_Celebration.png";
import itsAGirlCelebration from "../img/Its_a_Girl_Celebration.png";
import itsAlrightCelebration from "../img/Its_Alright_Celebration.png";
import jadeMintStamp from "../img/Jade_Mint_Stamp.png";
import jadeScarab from "../img/Jade_Scarab.png";
import jaggedObolOfMassiveTrolling from "../img/Jagged_Obol_of_Massive_Trolling.png";
import jar from "../img/Jar.png";
import jellyfish from "../img/Jellyfish.png";
import jellyfishCard from "../img/Jellyfish_Card.png";
import jobApplication from "../img/Job_Application.png";
import journeymanRecipe from "../img/Journeyman_Recipe.png";
import jumboShrimp from "../img/Jumbo_Shrimp.png";
import jumboShrimpCard from "../img/Jumbo_Shrimp_Card.png";
import jungleLogs from "../img/Jungle_Logs.png";
import jungleLogsCard from "../img/Jungle_Logs_Card.png";
import jungleTree from "../img/Jungle_Tree.png";
import junkPickaxe from "../img/Junk_Pickaxe.png";
import kachowStatue from "../img/Kachow_Statue.png";
import kapowStamp from "../img/Kapow_Stamp.png";
import kattlekrukCard from "../img/Kattlekruk_Card.png";
import kebabSticks from "../img/Kebab_Sticks.png";
import ketchupBottle from "../img/Ketchup_Bottle.png";
import keyToDesertChain from "../img/Key_to_Desert_Chain.png";
import keyToMountainsChain from "../img/Key_to_Mountains_Chain.png";
import keyToPurgatoryChain from "../img/Key_to_Purgatory_Chain.png";
import keychainFragment from "../img/Keychain_Fragment.png";
import kingDootCard from "../img/King_Doot_Card.png";
import kingFrogCard from "../img/King_Frog_Card.png";
import kingOfFood from "../img/King_of_Food.png";
import kiwiFruit from "../img/Kiwi_Fruit.png";
import knuckleSabers from "../img/Knuckle_Sabers.png";
import kraken from "../img/Kraken.png";
import krakenCard from "../img/Kraken_Card.png";
import krukCavityTooth from "../img/Kruk_Cavity_Tooth.png";
import krukTooth from "../img/Kruk_Tooth.png";
import kruksVolcanoKey from "../img/Kruk-s_Volcano_Key.png";
import krunkToken from "../img/Krunk_Token.png";
import labRing from "../img/Lab_Ring.png";
import labTubeStamp from "../img/Lab_Tube_Stamp.png";
import laboratoryScrubs from "../img/Laboratory_Scrubs.png";
import ladleStamp from "../img/Ladle_Stamp.png";
import ladybug from "../img/Ladybug.png";
import ladybugCard from "../img/Ladybug_Card.png";
import ladybugNest from "../img/Ladybug_Nest.png";
import lamparCard from "../img/Lampar_Card.png";
import lanternSpiritCard from "../img/Lantern_Spirit_Card.png";
import largeBugPouch from "../img/Large_Bug_Pouch.png";
import largeChoppinPouch from "../img/Large_Choppin_Pouch.png";
import largeCritterPouch from "../img/Large_Critter_Pouch.png";
import largeExperienceBalloon from "../img/Large_Experience_Balloon.png";
import largeFishPouch from "../img/Large_Fish_Pouch.png";
import largeFishingSpot from "../img/Large_Fishing_Spot.gif";
import largeFoodPouch from "../img/Large_Food_Pouch.png";
import largeMaterialsPouch from "../img/Large_Materials_Pouch.png";
import largeMiningPouch from "../img/Large_Mining_Pouch.png";
import largePohayoh from "../img/Large_Pohayoh.png";
import largeSoulPouch from "../img/Large_Soul_Pouch.png";
import lavaSezBuyMoreGems from "../img/Lava_Sez_Buy_More_Gems.png";
import lavaSlimerCard from "../img/Lava_Slimer_Card.png";
import lavasAwesomeNametag from "../img/Lava-s_Awesome_Nametag.png";
import lazloCard from "../img/Lazlo_Card.png";
import leafyBranch from "../img/Leafy_Branch.png";
import leafyChain from "../img/Leafy_Chain.png";
import leafyDroplet from "../img/Leafy_Droplet.png";
import leafyHorn from "../img/Leafy_Horn.png";
import leafyRing from "../img/Leafy_Ring.png";
import leafyVines from "../img/Leafy_Vines.png";
import leatherCap from "../img/Leather_Cap.png";
import leatherHide from "../img/Leather_Hide.png";
import leek from "../img/Leek.png";
import leekSpiritCard from "../img/Leek_Spirit_Card.png";
import lemonSlice from "../img/Lemon_Slice.png";
import lemonyChoco from "../img/Lemony_Choco.png";
import lightLantern from "../img/Light_Lantern.png";
import lilMiningBaggyStamp from "../img/Lil-_Mining_Baggy_Stamp.png";
import liquidNitrogen from "../img/Liquid_Nitrogen.png";
import literalElephant from "../img/Literal_Elephant.png";
import littleWoodenKatana from "../img/Little_Wooden_Katana.png";
import loggerHeels from "../img/Logger_Heels.png";
import lonelyHunterToken from "../img/Lonely_Hunter_Token.png";
import longswordStamp from "../img/Longsword_Stamp.png";
import loomisRoomKey from "../img/Loomi-s_Room_Key.png";
import loominadiToken from "../img/Loominadi_Token.png";
import lostBatteries from "../img/Lost_Batteries.png";
import loveRing from "../img/Love_Ring.png";
import loveulyteCard from "../img/Loveulyte_Card.png";
import loveyDoveyLetter from "../img/Lovey_Dovey_Letter.png";
import luciferianSkull from "../img/Luciferian_Skull.png";
import luckierLad from "../img/Luckier_Lad.png";
import luckyLad from "../img/Lucky_Lad.png";
import lugiBracket from "../img/Lugi_Bracket.png";
import lumberbobStatue from "../img/Lumberbob_Statue.png";
import lustreBar from "../img/Lustre_Bar.png";
import lustreChestplate from "../img/Lustre_Chestplate.png";
import lustreLogger from "../img/Lustre_Logger.png";
import lustreNetting from "../img/Lustre_Netting.png";
import lustreOre from "../img/Lustre_Ore.png";
import lustreOreCard from "../img/Lustre_Ore_Card.png";
import lustrePickaxe from "../img/Lustre_Pickaxe.png";
import lustreRod from "../img/Lustre_Rod.png";
import lustreScales from "../img/Lustre_Scales.png";
import lustreShieldshoe from "../img/Lustre_Shieldshoe.png";
import lustreVeil from "../img/Lustre_Veil.png";
import lustreVein from "../img/Lustre_Vein.png";
import maccieCard from "../img/Maccie_Card.png";
import mafiosoCard from "../img/Mafioso_Card.png";
import magicMeatloaf from "../img/Magic_Meatloaf.png";
import magmaBarrel from "../img/Magma_Barrel.png";
import magmaCoreBattleskirt from "../img/Magma_Core_Battleskirt.png";
import magmaCoreHeaddress from "../img/Magma_Core_Headdress.png";
import magmaCoreLavarunners from "../img/Magma_Core_Lavarunners.png";
import magmaCoreWavemaille from "../img/Magma_Core_Wavemaille.png";
import magmaGeode from "../img/Magma_Geode.png";
import magmaKillerRing from "../img/Magma_Killer_Ring.png";
import magmaLeaf from "../img/Magma_Leaf.png";
import magmaMaul from "../img/Magma_Maul.png";
import magmaObolOfBigTimeDomeo from "../img/Magma_Obol_of_Big_Time_Domeo.png";
import magnifiqueGodcaster from "../img/Magnifique_Godcaster.png";
import mamaTrollCard from "../img/Mama_Troll_Card.png";
import mamoothCard from "../img/Mamooth_Card.png";
import mamoothHideBag from "../img/Mamooth_Hide_Bag.png";
import mamoothTusk from "../img/Mamooth_Tusk.png";
import manaStamp from "../img/Mana_Stamp.png";
import manamoarStamp from "../img/Manamoar_Stamp.png";
import manifestedSkull from "../img/Manifested_Skull.png";
import mantaRay from "../img/Manta_Ray.png";
import mantaRayCard from "../img/Manta_Ray_Card.png";
import mapleLogs from "../img/Maple_Logs.png";
import mapleLogsCard from "../img/Maple_Logs_Card.png";
import mapleTree from "../img/Maple_Tree.png";
import marbiglassHatchet from "../img/Marbiglass_Hatchet.png";
import marbiglassHeaddress from "../img/Marbiglass_Headdress.png";
import marbiglassLegplates from "../img/Marbiglass_Legplates.png";
import marbiglassNetting from "../img/Marbiglass_Netting.png";
import marbiglassPickaxe from "../img/Marbiglass_Pickaxe.png";
import marbiglassRod from "../img/Marbiglass_Rod.png";
import marbiglassSoles from "../img/Marbiglass_Soles.png";
import marbiglassTunic from "../img/Marbiglass_Tunic.png";
import marbleBar from "../img/Marble_Bar.png";
import marbleOre from "../img/Marble_Ore.png";
import marbleVein from "../img/Marble_Vein.png";
import markOfMember from "../img/Mark_of_Member.png";
import marvelousObolStack from "../img/Marvelous_Obol_Stack.png";
import mashedPotato from "../img/Mashed_Potato.png";
import mashedPotatoCard from "../img/Mashed_Potato_Card.png";
import masonJarStamp from "../img/Mason_Jar_Stamp.png";
import massiveBugPouch from "../img/Massive_Bug_Pouch.png";
import massiveChoppinPouch from "../img/Massive_Choppin_Pouch.png";
import massiveCritterPouch from "../img/Massive_Critter_Pouch.png";
import massiveFig from "../img/Massive_Fig.png";
import massiveFishPouch from "../img/Massive_Fish_Pouch.png";
import massiveFoodPouch from "../img/Massive_Food_Pouch.png";
import massiveGodbreaker from "../img/Massive_Godbreaker.png";
import massiveMaterialsPouch from "../img/Massive_Materials_Pouch.png";
import massiveMiningPouch from "../img/Massive_Mining_Pouch.png";
import massiveSoulPouch from "../img/Massive_Soul_Pouch.png";
import massiveTrollCard from "../img/Massive_Troll_Card.png";
import masslessUnitForPhysicsQuestions from "../img/Massless_Unit_for_Physics_Questions.png";
import masterOfNothing from "../img/Master_of_Nothing.png";
import masterRecipe from "../img/Master_Recipe.png";
import mattyBagStamp from "../img/Matty_Bag_Stamp.png";
import maxoSlappoStamp from "../img/Maxo_Slappo_Stamp.png";
import mayonnaiseBottle from "../img/Mayonnaise_Bottle.png";
import mCRTshirt from "../img/MCR_Tshirt.png";
import meaningOfGiftmasCard from "../img/Meaning_of_Giftmas_Card.png";
import meatPie from "../img/Meat_Pie.png";
import meatyTraps from "../img/Meaty_Traps.png";
import medBlunderhillsNPCToken from "../img/Med_Blunderhills_NPC_Token.png";
import medFBTundraNPCToken from "../img/Med_FB_Tundra_NPC_Token.png";
import medYumyumDezNPCToken from "../img/Med_Yumyum_Dez_NPC_Token.png";
import mediumExperienceBalloon from "../img/Medium_Experience_Balloon.png";
import mediumFishingSpot from "../img/Medium_Fishing_Spot.gif";
import megafeatherNametag from "../img/Megafeather_Nametag.png";
import megalodon from "../img/Megalodon.png";
import megalodonTooth from "../img/Megalodon_Tooth.png";
import meltyCube from "../img/Melty_Cube.png";
import memberHoodie from "../img/Member_Hoodie.png";
import messageBottle from "../img/Message_Bottle.png";
import meteorhead from "../img/Meteorhead.png";
import meteorite from "../img/Meteorite.png";
import meteoriteRing from "../img/Meteorite_Ring.png";
import midnightCookie from "../img/Midnight_Cookie.png";
import midnightStopwatch from "../img/Midnight_Stopwatch.png";
import militiaHelm from "../img/Militia_Helm.png";
import milkChoco from "../img/Milk_Choco.png";
import mimicCard from "../img/Mimic_Card.png";
import minervowl from "../img/Minervowl.png";
import miniMaterialsPouch from "../img/Mini_Materials_Pouch.png";
import miniatureChoppinPouch from "../img/Miniature_Choppin_Pouch.png";
import miniatureMiningPouch from "../img/Miniature_Mining_Pouch.png";
import minichiefSpiritCard from "../img/Minichief_Spirit_Card.png";
import miningCertificate from "../img/Mining_Certificate.png";
import miningStatue from "../img/Mining_Statue.png";
import minisculeFoodPouch from "../img/Miniscule_Food_Pouch.png";
import mintoChoco from "../img/Minto_Choco.png";
import minuteglass from "../img/Minuteglass.png";
import misterBrightsideCard from "../img/Mister_Brightside_Card.png";
import misterloinSteak from "../img/Misterloin_Steak.png";
import mistleberries from "../img/Mistleberries.png";
import mittensOfTheGods from "../img/Mittens_of_the_Gods.png";
import mmmDonutChain from "../img/Mmm_Donut_Chain.png";
import moltenCloak from "../img/Molten_Cloak.png";
import moltenCoreKnucklers from "../img/Molten_Core_Knucklers.png";
import moltenLamp from "../img/Molten_Lamp.png";
import moltenObolOfDeadDivine from "../img/Molten_Obol_of_Dead_Divine.png";
import moltiCard from "../img/Molti_Card.png";
import mongoWormSlices from "../img/Mongo_Worm_Slices.png";
import monsterRating from "../img/Monster_Rating.png";
import moonmoonCard from "../img/Moonmoon_Card.png";
import mosquisnow from "../img/Mosquisnow.png";
import mosquisnowCard from "../img/Mosquisnow_Card.png";
import moteHovel from "../img/Mote_Hovel.png";
import mountainBread from "../img/Mountain_Bread.png";
import mousey from "../img/Mousey.png";
import mouseyCard from "../img/Mousey_Card.png";
import moustacheComb from "../img/Moustache_Comb.png";
import mrBlueberryCard from "../img/Mr_Blueberry_Card.png";
import multikillStamp from "../img/Multikill_Stamp.png";
import multitoolStamp from "../img/Multitool_Stamp.png";
import murmilloHelm from "../img/Murmillo_Helm.png";
import mustardBottle from "../img/Mustard_Bottle.png";
import mutantCrabbo from "../img/Mutant_Crabbo.png";
import mutatedMushCard from "../img/Mutated_Mush_Card.png";
import mutton from "../img/Mutton.png";
import muttonStatue from "../img/Mutton_Statue.png";
import mysteryUpgradeStoneI from "../img/Mystery_Upgrade_Stone_I.png";
import mysteryUpgradeStoneII from "../img/Mystery_Upgrade_Stone_II.png";
import mysteryUpgradeStoneIII from "../img/Mystery_Upgrade_Stone_III.png";
import mysteryUpgradeStoneIV from "../img/Mystery_Upgrade_Stone_IV.png";
import nakeoMoleo from "../img/Nakeo_Moleo.png";
import naturalTraps from "../img/Natural_Traps.png";
import nebulaKillerRing from "../img/Nebula_Killer_Ring.png";
import nebulaRoyal from "../img/Nebula_Royal.png";
import needledrop from "../img/Needledrop.png";
import negative7Chain from "../img/Negative_7_Chain.png";
import nestEggsStamp from "../img/Nest_Eggs_Stamp.png";
import neutronIceRing from "../img/Neutron_Ice_Ring.png";
import newbieCardPack from "../img/Newbie_Card_Pack.png";
import neyeptuneCard from "../img/Neyeptune_Card.png";
import nightshadeNametag from "../img/Nightshade_Nametag.png";
import ninjaChest from "../img/Ninja_Chest.png";
import nomwich from "../img/Nomwich.png";
import notDynamite from "../img/Not_Dynamite.png";
import noviceRecipe from "../img/Novice_Recipe.png";
import nugetCake from "../img/Nuget_Cake.png";
import nugetCakeFedora from "../img/Nuget_Cake_Fedora.png";
import nulloSalt from "../img/Nullo_Salt.png";
import nuttoCard from "../img/Nutto_Card.png";
import nyanborgir from "../img/Nyanborgir.png";
import oakLogs from "../img/Oak_Logs.png";
import oakLogsCard from "../img/Oak_Logs_Card.png";
import oakTree from "../img/Oak_Tree.png";
import obolFragment from "../img/Obol_Fragment.png";
import oceanicRing from "../img/Oceanic_Ring.png";
import oceanmanStatue from "../img/Oceanman_Statue.png";
import octodarCard from "../img/Octodar_Card.png";
import octoplop from "../img/Octoplop.png";
import oJJuice from "../img/OJ_Juice.png";
import olReliableStatue from "../img/Ol_Reliable_Statue.png";
import oldHatchet from "../img/Old_Hatchet.png";
import omegaMotherboard from "../img/Omega_Motherboard.png";
import omegaNanochip from "../img/Omega_Nanochip.png";
import oneOfTheDivine from "../img/One_of_the_Divine.png";
import onePoundOfFeathers from "../img/One_Pound_of_Feathers.png";
import onePoundOfSteel from "../img/One_Pound_of_Steel.png";
import onion from "../img/Onion.png";
import onyxTools from "../img/Onyx_Tools.png";
import oozieSoul from "../img/Oozie_Soul.png";
import oozieSoulCard from "../img/Oozie_Soul_Card.png";
import orange from "../img/Orange.png";
import orangeBeanie from "../img/Orange_Beanie.png";
import orangeSlice from "../img/Orange_Slice.png";
import orangeTee from "../img/Orange_Tee.png";
import owlio from "../img/Owlio.png";
import owlioCard from "../img/Owlio_Card.png";
import palmTree from "../img/Palm_Tree.png";
import pancakes from "../img/Pancakes.png";
import paperBag from "../img/Paper_Bag.png";
import paperBoat from "../img/Paper_Boat.png";
import papuaPiggeaToken from "../img/Papua_Piggea_Token.png";
import parasite from "../img/Parasite.png";
import pardonedTurkey from "../img/Pardoned_Turkey.png";
import birthdayHat from "../img/Party_Hat.png";
import peanut from "../img/Peanut.png";
import pearlerShell from "../img/Pearler_Shell.png";
import pecuniaStatue from "../img/Pecunia_Statue.png";
import peeperPouch from "../img/Peeper_Pouch.png";
import pen from "../img/Pen.png";
import penguinCard from "../img/Penguin_Card.png";
import pentastudSlapper from "../img/Pentastud_Slapper.png";
import persephonesBouquet from "../img/Persephones_Bouquet.png";
import petEgg from "../img/Pet_Egg.png";
import peteThePeanut from "../img/Pete_the_Peanut.png";
import pharaohBow from "../img/Pharaoh_Bow.png";
import phoenixWings from "../img/Phoenix_Wings.png";
import phoneBox from "../img/Phone_Box.png";
import pickaxeStamp from "../img/Pickaxe_Stamp.png";
import picnicToken from "../img/Picnic_Token.png";
import pie from "../img/Pie.png";
import piggyChain from "../img/Piggy_Chain.png";
import pileOfProcessorChips from "../img/Pile_of_Processor_Chips.png";
import pincerArm from "../img/Pincer_Arm.png";
import pincerHandChain from "../img/Pincer_Hand_Chain.png";
import pincerminCard from "../img/Pincermin_Card.png";
import pingy from "../img/Pingy.png";
import pingyCard from "../img/Pingy_Card.png";
import pinionSpur from "../img/Pinion_Spur.png";
import pinkBeanie from "../img/Pink_Beanie.png";
import pinkHeadband from "../img/Pink_Headband.png";
import pizza from "../img/Pizza.png";
import plank from "../img/Plank.png";
import planktop from "../img/Planktop.png";
import plasmaBarrel from "../img/Plasma_Barrel.png";
import plastiDougCard from "../img/Plasti_Doug_Card.png";
import platFishingRod from "../img/Plat_Fishing_Rod.png";
import platHatchet from "../img/Plat_Hatchet.png";
import platedCrumbs from "../img/Plated_Crumbs.png";
import platinet from "../img/Platinet.png";
import platinumAGIObol from "../img/Platinum_AGI_Obol.png";
import platinumBar from "../img/Platinum_Bar.png";
import platinumBoots from "../img/Platinum_Boots.png";
import platinumHelmet from "../img/Platinum_Helmet.png";
import platinumLUKObol from "../img/Platinum_LUK_Obol.png";
import platinumObolOfAmpleAnthropods from "../img/Platinum_Obol_of_Ample_Anthropods.png";
import platinumObolOfBlindingSpeed from "../img/Platinum_Obol_of_Blinding_Speed.png";
import platinumObolOfCards from "../img/Platinum_Obol_of_Cards.png";
import platinumObolOfConstruction from "../img/Platinum_Obol_of_Construction.png";
import platinumObolOfDefenseWithAnS from "../img/Platinum_Obol_of_Defense_with_an_S.png";
import platinumObolOfDwarvenDelving from "../img/Platinum_Obol_of_Dwarven_Delving.png";
import platinumObolOfExperience from "../img/Platinum_Obol_of_Experience.png";
import platinumObolOfKillimanjaro from "../img/Platinum_Obol_of_Killimanjaro.png";
import platinumObolOfLethalDamage from "../img/Platinum_Obol_of_Lethal_Damage.png";
import platinumObolOfLumbyLoggo from "../img/Platinum_Obol_of_Lumby_Loggo.png";
import platinumObolOfPoppityPoppy from "../img/Platinum_Obol_of_Poppity_Poppy.png";
import platinumObolOfTrapping from "../img/Platinum_Obol_of_Trapping.png";
import platinumObolOfTremendousTrout from "../img/Platinum_Obol_of_Tremendous_Trout.png";
import platinumObolOfWorship from "../img/Platinum_Obol_of_Worship.png";
import platinumObolOfYahtzeeSixes from "../img/Platinum_Obol_of_Yahtzee_Sixes.png";
import platinumOre from "../img/Platinum_Ore.png";
import platinumOreCard from "../img/Platinum_Ore_Card.png";
import platinumPickaxe from "../img/Platinum_Pickaxe.png";
import platinumPlatbody from "../img/Platinum_Platbody.png";
import platinumShins from "../img/Platinum_Shins.png";
import platinumSTRObol from "../img/Platinum_STR_Obol.png";
import platinumTwine from "../img/Platinum_Twine.png";
import platinumVein from "../img/Platinum_Vein.png";
import platinumWISObol from "../img/Platinum_WIS_Obol.png";
import plumpcakes from "../img/Plumpcakes.png";
import pocketSand from "../img/Pocket_Sand.png";
import poisonFroge from "../img/Poison_Froge.png";
import poisonicFrogCard from "../img/Poisonic_Frog_Card.png";
import pokerChip from "../img/Poker_Chip.png";
import polearmStamp from "../img/Polearm_Stamp.png";
import polishedBludgeon from "../img/Polished_Bludgeon.png";
import poopCard from "../img/Poop_Card.png";
import poopyPickaxe from "../img/Poopy_Pickaxe.png";
import popCat from "../img/Pop_Cat.png";
import poppedCorn from "../img/Popped_Corn.png";
import postOfficeBoxResetoMagnifico from "../img/Post_Office_Box_Reseto_Magnifico.png";
import potatoChip from "../img/Potato_Chip.png";
import potatoPeaPastry from "../img/Potato_Pea_Pastry.png";
import potatoRemains from "../img/Potato_Remains.png";
import potentEXPPotion from "../img/Potent_EXP_Potion.png";
import potentLifePotion from "../img/Potent_Life_Potion.png";
import potentManaPotion from "../img/Potent_Mana_Potion.png";
import potentSpeedPotion from "../img/Potent_Speed_Potion.png";
import potentStrengthPotion from "../img/Potent_Strength_Potion.png";
import potionStamp from "../img/Potion_Stamp.png";
import pottyRolls from "../img/Potty_Rolls.png";
import pottyRollsCard from "../img/Potty_Rolls_Card.png";
import powerStatue from "../img/Power_Statue.png";
import preCrimeBox from "../img/Pre_Crime_Box.png";
import premiumAGIStone from "../img/Premium_AGI_Stone.png";
import premiumBonusSwapper from "../img/Premium_Bonus_Swapper.png";
import premiumLUKStone from "../img/Premium_LUK_Stone.png";
import premiumStoneRefunder from "../img/Premium_Stone_Refunder.png";
import premiumSTRStone from "../img/Premium_STR_Stone.png";
import premiumWISStone from "../img/Premium_WIS_Stone.png";
import pretzel from "../img/Pretzel.png";
import prickleSkull from "../img/Prickle_Skull.png";
import pristineLongbow from "../img/Pristine_Longbow.png";
import propellerCap from "../img/Propeller_Cap.png";
import prosperousPouch from "../img/Prosperous_Pouch.png";
import protectorsPride from "../img/Protectors_Pride.png";
import pugilistDemise from "../img/Pugilist_Demise.png";
import pumpkin from "../img/Pumpkin.png";
import purbunni from "../img/Purbunni.png";
import pureOpalNavette from "../img/Pure_Opal_Navette.png";
import pureOpalRhinestone from "../img/Pure_Opal_Rhinestone.png";
import pureOpalRhombol from "../img/Pure_Opal_Rhombol.png";
import purgatoryStalkerCard from "../img/Purgatory_Stalker_Card.png";
import purpFrogeStamp from "../img/Purp_Froge_Stamp.png";
import purpMushroomCard from "../img/Purp_Mushroom_Card.png";
import purpleMushCap from "../img/Purple_Mush_Cap.png";
import purpleNavette from "../img/Purple_Navette.png";
import purpleRhombol from "../img/Purple_Rhombol.png";
import purpleSalt from "../img/Purple_Salt.png";
import purpleScrew from "../img/Purple_Screw.png";
import purpleTee from "../img/Purple_Tee.png";
import purpleTupacband from "../img/Purple_Tupacband.png";
import pvcPipe from "../img/PVC_Pipe.png";
import pyriteNavette from "../img/Pyrite_Navette.png";
import pyritePyramite from "../img/Pyrite_Pyramite.png";
import pyriteRhinestone from "../img/Pyrite_Rhinestone.png";
import pyriteRhombol from "../img/Pyrite_Rhombol.png";
import qualityObolStack from "../img/Quality_Obol_Stack.png";
import quarterstaff from "../img/Quarterstaff.png";
import quenchieCard from "../img/Quenchie_Card.png";
import questinStamp from "../img/Questin_Stamp.png";
import quotientEXPPotion from "../img/Quotient_EXP_Potion.png";
import radiantAmarokBackstabber from "../img/Radiant_Amarok_Backstabber.png";
import radiantAmarokCard from "../img/Radiant_Amarok_Card.png";
import radioactiveWaste from "../img/Radioactive_Waste.png";
import ramWool from "../img/Ram_Wool.png";
import ratCard from "../img/Rat_Card.png";
import ratatouey from "../img/Ratatouey.png";
import ratsTail from "../img/Rats_Tail.png";
import rawNigiri from "../img/Raw_Nigiri.png";
import realCivilEngineerHelmet from "../img/Real_Civil_Engineer_Helmet.png";
import reallyReallyResourceCoupon from "../img/Really_Really_Resource_Coupon.png";
import redFrisbee from "../img/Red_Frisbee.png";
import redHeadband from "../img/Red_Headband.png";
import redMushroomCard from "../img/Red_Mushroom_Card.png";
import redSneakerChain from "../img/Red_Sneaker_Chain.png";
import redSporeCap from "../img/Red_Spore_Cap.png";
import redTomePages from "../img/Red_Tome_Pages.png";
import redoxSalts from "../img/Redox_Salts.png";
import refineryStamp from "../img/Refinery_Stamp.png";
import refurbishedCog from "../img/Refurbished_Cog.png";
import reinforcedHeadband from "../img/Reinforced_Headband.png";
import reinforcedNet from "../img/Reinforced_Net.png";
import relicChain from "../img/Relic_Chain.png";
import resourceCoupon from "../img/Resource_Coupon.png";
import rexRing from "../img/Rex_Ring.png";
import ribbedTunic from "../img/Ribbed_Tunic.png";
import riceCake from "../img/Rice_Cake.png";
import riceball from "../img/Riceball.png";
import ricecakeCard from "../img/Ricecake_Card.png";
import riftwalkerNametag from "../img/Riftwalker_Nametag.png";
import riftwalkerWings from "../img/Riftwalker_Wings.png";
import rippedTunic from "../img/Ripped_Tunic.png";
import riverSpiritCard from "../img/River_Spirit_Card.png";
import robeOfTheGods from "../img/Robe_of_the_Gods.png";
import rootedSoul from "../img/Rooted_Soul.png";
import rootedSoulCard from "../img/Rooted_Soul_Card.png";
import rottingGrandfroggerCard from "../img/Rotting_Grandfrogger_Card.png";
import roughRockers from "../img/Rough_Rockers.png";
import royalBayonet from "../img/Royal_Bayonet.png";
import royalEggCard from "../img/Royal_Egg_Card.png";
import royalFabric from "../img/Royal_Fabric.png";
import royalHeadpiece from "../img/Royal_Headpiece.png";
import royalSuggmaUrn from "../img/Royal_Suggma_Urn.png";
import royalTraps from "../img/Royal_Traps.png";
import royalTurban from "../img/Royal_Turban.png";
import royalYolk from "../img/Royal_Yolk.png";
import rusticKeyChain from "../img/Rustic_Key_Chain.png";
import sackOfSuccess from "../img/Sack_of_Success.png";
import sacrilegiousKattlekrukCard from "../img/Sacrilegious_Kattlekruk_Card.png";
import saharanFoal from "../img/Saharan_Foal.png";
import sailboatStamp from "../img/Sailboat_Stamp.png";
import sailingGoldBar from "../img/Sailing_Gold_Bar.png";
import salad from "../img/Salad.png";
import samuraiGuardianCard from "../img/Samurai_Guardian_Card.png";
import sandCastleCard from "../img/Sand_Castle_Card.png";
import sandGiantCard from "../img/Sand_Giant_Card.png";
import sandOfTime from "../img/Sand_of_Time.png";
import sandShark from "../img/Sand_Shark.png";
import sandSharkCard from "../img/Sand_Shark_Card.png";
import sandyPotCard from "../img/Sandy_Pot_Card.png";
import sandySatchel from "../img/Sandy_Satchel.png";
import sanicRing from "../img/Sanic_Ring.png";
import santaHat from "../img/Santa_Hat.png";
import sapphireNavette from "../img/Sapphire_Navette.png";
import sapphirePyramite from "../img/Sapphire_Pyramite.png";
import sapphireRhinestone from "../img/Sapphire_Rhinestone.png";
import sapphireRhombol from "../img/Sapphire_Rhombol.png";
import sappyDNASplicer from "../img/Sappy_DNA_Splicer.png";
import sasheSidestamp from "../img/Sashe_Sidestamp.png";
import saucyLogfries from "../img/Saucy_Logfries.png";
import saucyWeiner from "../img/Saucy_Weiner.png";
import sausySausage from "../img/Sausy_Sausage.png";
import sawStamp from "../img/Saw_Stamp.png";
import sawdust from "../img/Sawdust.png";
import scarab from "../img/Scarab.png";
import scarabCard from "../img/Scarab_Card.png";
import scarabNest from "../img/Scarab_Nest.png";
import scimitarStamp from "../img/Scimitar_Stamp.png";
import scorpie from "../img/Scorpie.png";
import scorpieCard from "../img/Scorpie_Card.png";
import scoutingReport from "../img/Scouting_Report.png";
import scripticusSpoons from "../img/Scripticus_Spoons.png";
import scubidewToken from "../img/Scubidew_Token.png";
import sculptingTools from "../img/Sculpting_Tools.png";
import seaUrchin from "../img/Sea_Urchin.png";
import seasonedMarrow from "../img/Seasoned_Marrow.png";
import secretMap from "../img/Secret_Map.png";
import sedimentCoreGrunkler from "../img/Sediment_Core_Grunkler.png";
import seesawStatue from "../img/Seesaw_Statue.png";
import sentientBowl from "../img/Sentient_Bowl.png";
import sentientCereal from "../img/Sentient_Cereal.png";
import sentientCerealCard from "../img/Sentient_Cereal_Card.png";
import serratedChestOfTheDivine from "../img/Serrated_Chest_of_the_Divine.png";
import serratedRexRing from "../img/Serrated_Rex_Ring.png";
import sesameSeed from "../img/Sesame_Seed.png";
import shallowWatering from "../img/Shallow_Watering.png";
import shardsureLeif from "../img/Shardsure_Leif.png";
import shatteredCeramic from "../img/Shattered_Ceramic.png";
import shatteredSkull from "../img/Shattered_Skull.png";
import sheekScrubs from "../img/Sheek_Scrubs.png";
import sheepieCard from "../img/Sheepie_Card.png";
import sheepieDairy from "../img/Sheepie_Dairy.png";
import shellSnakeCard from "../img/Shell_Snake_Card.png";
import shellfish from "../img/Shellfish.png";
import shellfishCard from "../img/Shellfish_Card.png";
import shieldStamp from "../img/Shield_Stamp.png";
import shinyBoredBeanie from "../img/Shiny_Bored_Beanie.png";
import shinyPearl from "../img/Shiny_Pearl.png";
import shiveringSack from "../img/Shivering_Sack.png";
import shogunHelmet from "../img/Shogun_Helmet.png";
import shrapshell from "../img/Shrapshell.png";
import shuvelleToken from "../img/Shuvelle_Token.png";
import shuvellesVote from "../img/Shuvelle-s_Vote.png";
import siegeCaptainCap from "../img/Siege_Captain_Cap.png";
import sigilStamp from "../img/Sigil_Stamp.png";
import signedArrestWarrant from "../img/Signed_Arrest_Warrant.png";
import signedContract from "../img/Signed_Contract.png";
import silkrodeMotherboard from "../img/Silkrode_Motherboard.png";
import silkrodeNanochip from "../img/Silkrode_Nanochip.png";
import silkrodeProcessor from "../img/Silkrode_Processor.png";
import silkrodeSoftware from "../img/Silkrode_Software.png";
import silkskinTraps from "../img/Silkskin_Traps.png";
import silverAGIObol from "../img/Silver_AGI_Obol.png";
import silverAntique from "../img/Silver_Antique.png";
import silverChest from "../img/Silver_Chest.png";
import silverLUKObol from "../img/Silver_LUK_Obol.png";
import silverObolOfBigBark from "../img/Silver_Obol_of_Big_Bark.png";
import silverObolOfBigBugs from "../img/Silver_Obol_of_Big_Bugs.png";
import silverObolOfCards from "../img/Silver_Obol_of_Cards.png";
import silverObolOfConstruction from "../img/Silver_Obol_of_Construction.png";
import silverObolOfDefence from "../img/Silver_Obol_of_Defence.png";
import silverObolOfDoubleSixes from "../img/Silver_Obol_of_Double_Sixes.png";
import silverObolOfExperience from "../img/Silver_Obol_of_Experience.png";
import silverObolOfLittleDamage from "../img/Silver_Obol_of_Little_Damage.png";
import silverObolOfMegakill from "../img/Silver_Obol_of_Megakill.png";
import silverObolOfModerateMining from "../img/Silver_Obol_of_Moderate_Mining.png";
import silverObolOfPocketChange from "../img/Silver_Obol_of_Pocket_Change.png";
import silverObolOfPopPop from "../img/Silver_Obol_of_Pop_Pop.png";
import silverObolOfPunyPikes from "../img/Silver_Obol_of_Puny_Pikes.png";
import silverObolOfTrapping from "../img/Silver_Obol_of_Trapping.png";
import silverObolOfWorship from "../img/Silver_Obol_of_Worship.png";
import silverPen from "../img/Silver_Pen.png";
import silverPocketwatch from "../img/Silver_Pocketwatch.png";
import silverStopwatch from "../img/Silver_Stopwatch.png";
import silverSTRObol from "../img/Silver_STR_Obol.png";
import silverTwine from "../img/Silver_Twine.png";
import silverWISObol from "../img/Silver_WIS_Obol.png";
import simpleKeyChain from "../img/Simple_Key_Chain.png";
import singlecle from "../img/Singlecle.png";
import sippyStraw from "../img/Sippy_Straw.png";
import sirStacheCard from "../img/Sir_Stache_Card.png";
import sizableBugPouch from "../img/Sizable_Bug_Pouch.png";
import sizableChoppinPouch from "../img/Sizable_Choppin_Pouch.png";
import sizableCritterPouch from "../img/Sizable_Critter_Pouch.png";
import sizableFishPouch from "../img/Sizable_Fish_Pouch.png";
import sizableFoodPouch from "../img/Sizable_Food_Pouch.png";
import sizableMaterialsPouch from "../img/Sizable_Materials_Pouch.png";
import sizableMiningPouch from "../img/Sizable_Mining_Pouch.png";
import sizableSoulPouch from "../img/Sizable_Soul_Pouch.png";
import skelefish from "../img/Skelefish.png";
import skelefishCard from "../img/Skelefish_Card.png";
import skelefishStamp from "../img/Skelefish_Stamp.png";
import skeletalObolOfEfauntsGaze from "../img/Skeletal_Obol_of_Efaunt-s_Gaze.png";
import skeweredSnek from "../img/Skewered_Snek.png";
import skullLance from "../img/Skull_Lance.png";
import skulledHelmetOfTheDivine from "../img/Skulled_Helmet_of_the_Divine.png";
import skullfishPendant from "../img/Skullfish_Pendant.png";
import skullslipHallow from "../img/Skullslip_Hallow.png";
import skydoggieSpiritCard from "../img/Skydoggie_Spirit_Card.png";
import sleekCoif from "../img/Sleek_Coif.png";
import sleekShank from "../img/Sleek_Shank.png";
import slimeCard from "../img/Slime_Card.png";
import slimeSludge from "../img/Slime_Sludge.png";
import slimsharpFin from "../img/Slimsharp_Fin.png";
import slimyNecklace from "../img/Slimy_Necklace.png";
import slurpinHerm from "../img/Slurpin_Herm.png";
import slushSkull from "../img/Slush_Skull.png";
import slushyObolOfMuchDilapidation from "../img/Slushy_Obol_of_Much_Dilapidation.png";
import smallBugPouch from "../img/Small_Bug_Pouch.png";
import smallChoppinPouch from "../img/Small_Choppin_Pouch.png";
import smallCritterPouch from "../img/Small_Critter_Pouch.png";
import smallEXPPotion from "../img/Small_EXP_Potion.png";
import smallExperienceBalloon from "../img/Small_Experience_Balloon.png";
import smallFishPouch from "../img/Small_Fish_Pouch.png";
import smallFishingSpot from "../img/Small_Fishing_Spot.gif";
import smallFoodPouch from "../img/Small_Food_Pouch.png";
import smallLifePotion from "../img/Small_Life_Potion.png";
import smallManaPotion from "../img/Small_Mana_Potion.png";
import smallMaterialPouch from "../img/Small_Material_Pouch.png";
import smallMiningPouch from "../img/Small_Mining_Pouch.png";
import smallSoulPouch from "../img/Small_Soul_Pouch.png";
import smallSpeedPotion from "../img/Small_Speed_Potion.png";
import smallStrengthPotion from "../img/Small_Strength_Potion.png";
import smartDirtStamp from "../img/Smart_Dirt_Stamp.png";
import smolWorm from "../img/Smol_Worm.png";
import smolderinCardPack from "../img/Smolderin_Card_Pack.png";
import snakeJarToken from "../img/Snake_Jar_Token.png";
import snakeSkin from "../img/Snake_Skin.png";
import snakenhotepCard from "../img/Snakenhotep_Card.png";
import snakeskinventoryBag from "../img/Snakeskinventory_Bag.png";
import sneakyPeekyStamp from "../img/Sneaky_Peeky_Stamp.png";
import snelbieCard from "../img/Snelbie_Card.png";
import snoutsToken from "../img/Snouts_Token.png";
import snowBall from "../img/Snow_Ball.png";
import snowden from "../img/Snowden.png";
import snowflakeNametag from "../img/Snowflake_Nametag.png";
import snowman from "../img/Snowman_-Premium_Helmet-.png";
import snowmanCard from "../img/Snowman_Card.png";
import soda from "../img/Soda.png";
import sodaCanCard from "../img/Soda_Can_Card.png";
import solesOfTheTroll from "../img/Soles_of_the_Troll.png";
import soulbleGum from "../img/Soulble_Gum.png";
import soupedLabRing from "../img/Souped_Lab_Ring.png";
import sourishFish from "../img/Sourish_Fish.png";
import sovereignEmperorCard from "../img/Sovereign_Emperor_Card.png";
import spaggyWesterados from "../img/Spaggy_Westerados.png";
import spaghetti from "../img/Spaghetti.png";
import sparkyMarbleStaff from "../img/Sparky_Marble_Staff.png";
import specialTalentBook from "../img/Special_Talent_Book.png";
import spectacular4thYearNametag from "../img/Spectacular_4th_Year_Nametag.png";
import speedStatue from "../img/Speed_Statue.png";
import spiceStamp from "../img/Spice_Stamp.png";
import spicySpaceRibs from "../img/Spicy_Space_Ribs.png";
import spikedLeggingsOfTheDivine from "../img/Spiked_Leggings_of_the_Divine.png";
import spikedMenace from "../img/Spiked_Menace.png";
import spikemouthStamp from "../img/Spikemouth_Stamp.png";
import spineTinglerSniper from "../img/Spine_Tingler_Sniper.png";
import spiralStatue from "../img/Spiral_Statue.png";
import spiritDiamond from "../img/Spirit_Diamond.png";
import spiritLeaf from "../img/Spirit_Leaf.png";
import spiritedMane from "../img/Spirited_Mane.png";
import spiritlordHornChain from "../img/Spiritlord_Horn_Chain.png";
import spitfire from "../img/Spitfire.png";
import spontaneitySalts from "../img/Spontaneity_Salts.png";
import spookyTimeCandy from "../img/Spooky_Time_Candy.png";
import sporeCap from "../img/Spore_Cap.png";
import sporeTee from "../img/Spore_Tee.png";
import sprigglyStorm from "../img/Spriggly_Storm.png";
import springBaggie from "../img/Spring_Baggie.png";
import springFlowersNametag from "../img/Spring_Flowers_Nametag.png";
import springSplendorCard from "../img/Spring_Splendor_Card.png";
import sproutSpiritCard from "../img/Sprout_Spirit_Card.png";
import sproutinaldToken from "../img/Sproutinald_Token.png";
import squishySoul from "../img/Squishy_Soul.png";
import squishySoulCard from "../img/Squishy_Soul_Card.png";
import stackedRiceCake from "../img/Stacked_Rice_Cake.png";
import staffOfTheUndeadPlague from "../img/Staff_of_the_Undead_Plague.png";
import stainedPearl from "../img/Stained_Pearl.png";
import stampleStamp from "../img/Stample_Stamp.png";
import starBlobulyteGalaxyChain from "../img/Star_Blobulyte_Galaxy_Chain.png";
import starTalentResetPotion from "../img/Star_Talent_Reset_Potion.png";
import starfireBar from "../img/Starfire_Bar.png";
import starfireHatchet from "../img/Starfire_Hatchet.png";
import starfireOre from "../img/Starfire_Ore.png";
import starfireOreCard from "../img/Starfire_Ore_Card.png";
import starfirePickaxe from "../img/Starfire_Pickaxe.png";
import starfireRod from "../img/Starfire_Rod.png";
import starfireTrimNetting from "../img/Starfire_Trim_Netting.png";
import starfireVein from "../img/Starfire_Vein.png";
import starlight from "../img/Starlight.png";
import statGraphStamp from "../img/Stat_Graph_Stamp.png";
import statWallstreetStamp from "../img/Stat_Wallstreet_Stamp.png";
import stealthStatue from "../img/Stealth_Statue.png";
import steamCap from "../img/Steam_Cap.png";
import steamyTimeCandy from "../img/Steamy_Time_Candy.png";
import steelAxe from "../img/Steel_Axe.png";
import steelBand from "../img/Steel_Band.png";
import steelTraps from "../img/Steel_Traps.png";
import steveSword from "../img/Steve_Sword.png";
import stick from "../img/Stick.png";
import stickyBun from "../img/Sticky_Bun.png";
import stickyStick from "../img/Sticky_Stick.png";
import stiltPole from "../img/Stilt_Pole.png";
import stiltedSeekerCard from "../img/Stilted_Seeker_Card.png";
import stiltmoleCard from "../img/Stiltmole_Card.png";
import stiltzchoToken from "../img/Stiltzcho_Token.png";
import stinkyAxe from "../img/Stinky_Axe.png";
import stonePeanut from "../img/Stone_Peanut.png";
import storageChest1 from "../img/Storage_Chest_1.png";
import storageChest2 from "../img/Storage_Chest_2.png";
import storageChest3 from "../img/Storage_Chest_3.png";
import storageChest4 from "../img/Storage_Chest_4.png";
import storageChest5 from "../img/Storage_Chest_5.png";
import storageChest6 from "../img/Storage_Chest_6.png";
import storageChest7 from "../img/Storage_Chest_7.png";
import storageChest8 from "../img/Storage_Chest_8.png";
import storageChest9 from "../img/Storage_Chest_9.png";
import storageChest10 from "../img/Storage_Chest_10.png";
import storageChest11 from "../img/Storage_Chest_11.png";
import storageChest12 from "../img/Storage_Chest_12.png";
import storageChest13 from "../img/Storage_Chest_13.png";
import storageChest14 from "../img/Storage_Chest_14.png";
import storageChest15 from "../img/Storage_Chest_15.png";
import storageChest16 from "../img/Storage_Chest_16.png";
import storageChest17 from "../img/Storage_Chest_17.png";
import storageChest18 from "../img/Storage_Chest_18.png";
import storageChest19 from "../img/Storage_Chest_19.png";
import storageChest20 from "../img/Storage_Chest_20.png";
import storageChest21 from "../img/Storage_Chest_21.png";
import storageChest22 from "../img/Storage_Chest_22.png";
import storageChest23 from "../img/Storage_Chest_23.png";
import storageChest24 from "../img/Storage_Chest_24.png";
import storageChest25 from "../img/Storage_Chest_25.png";
import storageChest26 from "../img/Storage_Chest_26.png";
import storageChest27 from "../img/Storage_Chest_27.png";
import storageChest28 from "../img/Storage_Chest_28.png";
import storageChest90 from "../img/Storage_Chest_90.png";
import storageChest91 from "../img/Storage_Chest_91.png";
import storageChest92 from "../img/Storage_Chest_92.png";
import storageChest93 from "../img/Storage_Chest_93.png";
import storageChest94 from "../img/Storage_Chest_94.png";
import storageChest95 from "../img/Storage_Chest_95.png";
import storageChest96 from "../img/Storage_Chest_96.png";
import storageChest97 from "../img/Storage_Chest_97.png";
import storageChest98 from "../img/Storage_Chest_98.png";
import storageChest99 from "../img/Storage_Chest_99.png";
import storageChest99B from "../img/Storage_Chest_99B.png";
import storageChest99C from "../img/Storage_Chest_99C.png";
import strangeRock from "../img/Strange_Rock.png";
import strawHat from "../img/Straw_Hat.png";
import strawbiggy from "../img/Strawbiggy.png";
import strungBludgeon from "../img/Strung_Bludgeon.png";
import strungJewels from "../img/Strung_Jewels.png";
import strungToothOfTheDivine from "../img/Strung_Tooth_of_the_Divine.png";
import studdedHide from "../img/Studded_Hide.png";
import stumpProp from "../img/Stump_Prop.png";
import stumpTree from "../img/Stump_Tree.png";
import subClassSwapToken from "../img/Sub_Class_Swap_Token.png";
import suggmaAshes from "../img/Suggma_Ashes.png";
import suggmaCard from "../img/Suggma_Card.png";
import sukkaFoo from "../img/Sukka_Foo.png";
import summerArmorStone from "../img/Summer_Armor_Stone.png";
import summerCooler from "../img/Summer_Cooler.png";
import summerShell from "../img/Summer_Shell.png";
import summerShovelNametag from "../img/Summer_Shovel_Nametag.png";
import summerSpiritCard from "../img/Summer_Spirit_Card.png";
import summerToolUpgradeStone from "../img/Summer_Tool_Upgrade_Stone.png";
import summerWeaponStone from "../img/Summer_Weapon_Stone.png";
import summonerStone from "../img/Summoner_Stone.png";
import summonerStoneStamp from "../img/Summoner_Stone_Stamp.png";
import sundriedGlass from "../img/Sundried_Glass.png";
import sushiChain from "../img/Sushi_Chain.png";
import sushiRoll from "../img/Sushi_Roll.png";
import swagSwingyToolStamp from "../img/Swag_Swingy_Tool_Stamp.png";
import swordStamp from "../img/Sword_Stamp.png";
import tacoChain from "../img/Taco_Chain.png";
import talentIIStamp from "../img/Talent_II_Stamp.png";
import talentIIIStamp from "../img/Talent_III_Stamp.png";
import talentIVStamp from "../img/Talent_IV_Stamp.png";
import talentPointResetFragment from "../img/Talent_Point_Reset_Fragment.png";
import talentPointResetPotion from "../img/Talent_Point_Reset_Potion.png";
import talentPointSpecialTab from "../img/Talent_Point_Special_Tab.png";
import talentPointTab1 from "../img/Talent_Point_Tab_1.png";
import talentPointTab2 from "../img/Talent_Point_Tab_2.png";
import talentPointTab3 from "../img/Talent_Point_Tab_3.png";
import talentPointTab4 from "../img/Talent_Point_Tab_4.png";
import talentSStamp from "../img/Talent_S_Stamp.png";
import tangledCords from "../img/Tangled_Cords.png";
import tarantulight from "../img/Tarantulight.png";
import targetCard from "../img/Target_Card.png";
import targetStamp from "../img/Target_Stamp.png";
import tatteredCloth from "../img/Tattered_Cloth.png";
import tattersOfTheGods from "../img/Tatters_of_the_Gods.png";
import tenacityRing from "../img/Tenacity_Ring.png";
import theBobberChallengeScroll from "../img/The_Bobber_Challenge_Scroll.png";
import theClassic from "../img/The_Classic.png";
import theCrowPerch from "../img/The_Crow_Perch.png";
import theDivineScarf from "../img/The_Divine_Scarf.png";
import theIceBreaker from "../img/The_Ice_Breaker.png";
import theRedBoaty from "../img/The_Red_Boaty.png";
import theStingers from "../img/The_Stingers.png";
import thermisterCard from "../img/Thermister_Card.png";
import thiccSkinStatue from "../img/Thicc_Skin_Statue.png";
import thiefHood from "../img/Thief_Hood.png";
import thinVeilOfTheTroll from "../img/Thin_Veil_of_The_Troll.png";
import thingymabob from "../img/Thingymabob.png";
import thread from "../img/Thread.png";
import tikiChiefToken from "../img/Tiki_Chief_Token.png";
import timeCandyChain from "../img/Time_Candy_Chain.png";
import timeThingy from "../img/Time_Thingy.png";
import timelessNametag from "../img/Timeless_Nametag.png";
import timelessWatch from "../img/Timeless_Watch.png";
import toiletTree from "../img/Toilet_Tree.png";
import tomahawkStamp from "../img/Tomahawk_Stamp.png";
import tongueBone from "../img/Tongue_Bone.png";
import toolUpgradeStoneI from "../img/Tool_Upgrade_Stone_I.png";
import toolUpgradeStoneII from "../img/Tool_Upgrade_Stone_II.png";
import toolUpgradeStoneIII from "../img/Tool_Upgrade_Stone_III.png";
import toolUpgradeStoneIV from "../img/Tool_Upgrade_Stone_IV.png";
import toolUpgradeStoneSK from "../img/Tool_Upgrade_Stone_SK.png";
import toolUpgradeStoneV from "../img/Tool_Upgrade_Stone_V.png";
import toolUpgradeStoneVI from "../img/Tool_Upgrade_Stone_VI.png";
import topHat from "../img/Top_Hat.png";
import tornJeans from "../img/Torn_Jeans.png";
import totallyNormalBag from "../img/Totally_Normal_and_not_fake_Bag.png";
import tottoise from "../img/Tottoise.png";
import toxicMercury from "../img/Toxic_Mercury.png";
import toxicSludge from "../img/Toxic_Sludge.png";
import tPPeteToken from "../img/TP_Pete_Token.png";
import trafficCone from "../img/Traffic_Cone.png";
import trailblazer from "../img/Trailblazer.png";
import trashTunaNametag from "../img/Trash_Tuna_Nametag.png";
import tremorWurmCard from "../img/Tremor_Wurm_Card.png";
import trenchSeawater from "../img/Trench_Seawater.png";
import triadEssenceStamp from "../img/Triad_Essence_Stamp.png";
import trimmedRunePlatelegs from "../img/Trimmed_Rune_Platelegs.png";
import tripleThreat from "../img/Triple_Threat.png";
import tripleshotStamp from "../img/Tripleshot_Stamp.png";
import triumphantTreason from "../img/Triumphant_Treason.png";
import trollFlower from "../img/Troll_Flower.png";
import trollScales from "../img/Troll_Scales.png";
import trollsEnclaveKey from "../img/Troll-s_Enclave_Key.png";
import trollishGarb from "../img/Trollish_Garb.png";
import tropilogs from "../img/Tropilogs.png";
import tropilogsCard from "../img/Tropilogs_Card.png";
import trustyNails from "../img/Trusty_Nails.png";
import tundraKillerRing from "../img/Tundra_Killer_Ring.png";
import tundraLogs from "../img/Tundra_Logs.png";
import tundraLogsCard from "../img/Tundra_Logs_Card.png";
import tundraMiscCompletionToken from "../img/Tundra_Misc_Completion_Token.png";
import tundraNPCCompletionToken from "../img/Tundra_NPC_Completion_Token.png";
import tundraSkillsCompletionToken from "../img/Tundra_Skills_Completion_Token.png";
import turkeyALaThank from "../img/Turkey_a_la_Thank.png";
import tuttle from "../img/Tuttle.png";
import tvCard from "../img/TV_Card.png";
import tVRemote from "../img/TV_Remote.png";
import twinOresStamp from "../img/Twin_Ores_Stamp.png";
import twistedScales from "../img/Twisted_Scales.png";
import twistyLeaf from "../img/Twisty_Leaf.png";
import twosoulStatue from "../img/Twosoul_Statue.png";
import tysonCard from "../img/Tyson_Card.png";
import ultraUnboxer from "../img/Ultra_Unboxer.png";
import uninflatedGlove from "../img/Uninflated_Glove.png";
import valenslimeChest from "../img/Valenslime_Chest.png";
import valentslimeCard from "../img/Valentslime_Card.png";
import valvePatentedCircleThingies from "../img/Valve_Patented_Circle_Thingies.png";
import veinyLogs from "../img/Veiny_Logs.png";
import veinyLogsCard from "../img/Veiny_Logs_Card.png";
import vendorStamp from "../img/Vendor_Stamp.png";
import vengefulGrandfroggerCard from "../img/Vengeful_Grandfrogger_Card.png";
import vigilantObolOfIceGuard from "../img/Vigilant_Obol_of_Ice_Guard.png";
import vikingCap from "../img/Viking_Cap.png";
import violenceStamp from "../img/Violence_Stamp.png";
import vitalityStamp from "../img/Vitality_Stamp.png";
import vmanNametag from "../img/Vman_Nametag.png";
import voidAxeStamp from "../img/Void_Axe_Stamp.png";
import voidBar from "../img/Void_Bar.png";
import voidImperiumAxe from "../img/Void_Imperium_Axe.png";
import voidImperiumHelmet from "../img/Void_Imperium_Helmet.png";
import voidImperiumKicks from "../img/Void_Imperium_Kicks.png";
import voidImperiumNet from "../img/Void_Imperium_Net.png";
import voidImperiumPik from "../img/Void_Imperium_Pik.png";
import voidImperiumPlatebody from "../img/Void_Imperium_Platebody.png";
import voidImperiumRod from "../img/Void_Imperium_Rod.png";
import voidImperiumShardshins from "../img/Void_Imperium_Shardshins.png";
import voidOre from "../img/Void_Ore.png";
import voidOreCard from "../img/Void_Ore_Card.png";
import voidSwordStamp from "../img/Void_Sword_Stamp.png";
import voidVein from "../img/Void_Vein.png";
import volumetricBugPouch from "../img/Volumetric_Bug_Pouch.png";
import volumetricChoppingPouch from "../img/Volumetric_Chopping_Pouch.png";
import volumetricCrittaPouch from "../img/Volumetric_Critta_Pouch.png";
import volumetricFishPouch from "../img/Volumetric_Fish_Pouch.png";
import volumetricFoodPouch from "../img/Volumetric_Food_Pouch.png";
import volumetricMattyPouch from "../img/Volumetric_Matty_Pouch.png";
import volumetricMiningPouch from "../img/Volumetric_Mining_Pouch.png";
import volumetricSoulPouch from "../img/Volumetric_Soul_Pouch.png";
import voodofish from "../img/Voodofish.png";
import wakawakaWar from "../img/Wakawaka_War_Totem.gif";
import wakkaCherry from "../img/Wakka_Cherry.png";
import walkingStickCard from "../img/Walking_Stick_Card.png";
import warpedHelmetUpgradeStone from "../img/Warped_Helmet_Upgrade_Stone.png";
import warpedWeaponUpgradeStone from "../img/Warped_Weapon_Upgrade_Stone.png";
import wartoothChain from "../img/Wartooth_Chain.png";
import waterDroplets from "../img/Water_Droplets.png";
import waxSkull from "../img/Wax_Skull.png";
import wealthRing from "../img/Wealth_Ring.png";
import wealthyWallet from "../img/Wealthy_Wallet.png";
import weaponUpgradeStoneC from "../img/Weapon_Upgrade_Stone_C.png";
import weaponUpgradeStoneI from "../img/Weapon_Upgrade_Stone_I.png";
import weaponUpgradeStoneII from "../img/Weapon_Upgrade_Stone_II.png";
import weaponUpgradeStoneIII from "../img/Weapon_Upgrade_Stone_III.png";
import weaponUpgradeStoneIV from "../img/Weapon_Upgrade_Stone_IV.png";
import weaponUpgradeStoneSK from "../img/Weapon_Upgrade_Stone_SK.png";
import weaponUpgradeStoneV from "../img/Weapon_Upgrade_Stone_V.png";
import weaponUpgradeStoneVI from "../img/Weapon_Upgrade_Stone_VI.png";
import weddingCake from "../img/Wedding_Cake.png";
import wellingtonToken from "../img/Wellington_Token.png";
import whatamelonChain from "../img/Whatamelon_Chain.png";
import whattsoToken from "../img/Whattso_Token.png";
import whippedCocoa from "../img/Whipped_Cocoa.png";
import whiteEssenceStamp from "../img/White_Essence_Stamp.png";
import whiteHeadband from "../img/White_Headband.png";
import wienerLinks from "../img/Wiener_Links.png";
import wigBandana from "../img/Wig_Bandana.png";
import wildBoar from "../img/Wild_Boar.png";
import willowLogs from "../img/Willow_Logs.png";
import wispyLumber from "../img/Wispy_Lumber.png";
import wispyLumberCard from "../img/Wispy_Lumber_Card.png";
import wispyTree from "../img/Wispy_Tree.png";
import witchHat from "../img/Witch_Hat.png";
import wodeBoardCard from "../img/Wode_Board_Card.png";
import woodChip from "../img/Wood_Chip.png";
import woodMushroomCard from "../img/Wood_Mushroom_Card.png";
import woodenAorticMass from "../img/Wooden_Aortic_Mass.png";
import woodenBow from "../img/Wooden_Bow.png";
import woodenSpear from "../img/Wooden_Spear.png";
import woodenTraps from "../img/Wooden_Traps.png";
import woodlinChest from "../img/Woodlin_Chest.png";
import woodlinSpiritCard from "../img/Woodlin_Spirit_Card.png";
import woodsmanToken from "../img/Woodsman_Token.png";
import woodularCircle from "../img/Woodular_Circle.png";
import workerBee from "../img/Worker_Bee.png";
import workerBeeCard from "../img/Worker_Bee_Card.png";
import wormieSlices from "../img/Wormie_Slices.png";
import wormieWeight from "../img/Wormie_Weight.png";
import worshipFloppyDisc from "../img/Worship_Floppy_Disc.png";
import wranglerOfTheQoxzul from "../img/Wrangler_of_the_Qoxzul.png";
import wrathGrapes from "../img/Wrath_Grapes.png";
import wrigglyBall from "../img/Wriggly_Ball.png";
import wurmTail from "../img/Wurm_Tail.png";
import xyloboneCard from "../img/Xylobone_Card.png";
import yellowBeanie from "../img/Yellow_Beanie.png";
import yellowHeadband from "../img/Yellow_Headband.png";
import yellowSnowflake from "../img/Yellow_Snowflake.png";
import yetiHam from "../img/Yeti_Ham.png";
import yondergreenToken from "../img/Yondergreen_Token.png";
import yondergreensVote from "../img/Yondergreens_Vote.png";
import yumiPeachring from "../img/Yumi_Peachring.png";
import yumyumDesertNPCCompletionToken from "../img/Yumyum_Desert_NPC_Completion_Token.png";
import yumyumMiscCompletionToken from "../img/Yumyum_Misc_Completion_Token.png";
import yumYumSheriff from "../img/YumYum_Sheriff.png";
import yumyumSkillsCompletionToken from "../img/Yumyum_Skills_Completion_Token.png";
import zeroPointStopwatch from "../img/Zero_Point_Stopwatch.png";
import zeusGonFishin from "../img/Zeus_Gon_Fishin.png";

const i = (name: string, url: URLString) => [name, url];
export const imageURLs: Record<string, URLString> = Object.fromEntries([
  i("Sappy DNA Splicer", sappyDNASplicer),
  i("Bolstered DNA Splicer", bolsteredDNASplicer),
  i("Double Barreled DNA Splicer", doubleBarreledDNASplicer),
  i("Ergonomic DNA Splicer", ergonomicDNASplicer),

  i("Green Mushroom Card", greenMushroomCard),
  i("Red Mushroom Card", redMushroomCard),
  i("Frog Card", frogCard),
  i("Bored Bean Card", boredBeanCard),
  i("Slime Card", slimeCard),
  i("Baby Boa Card", babyBoaCard),
  i("Carrotman Card", carrotmanCard),
  i("Glublin Card", glublinCard),
  i("Wode Board Card", wodeBoardCard),
  i("Gigafrog Card", gigafrogCard),
  i("Poop Card", poopCard),
  i("Rat Card", ratCard),
  i("Walking Stick Card", walkingStickCard),
  i("Nutto Card", nuttoCard),
  i("Crystal Carrot Card", crystalCarrotCard),
  i("Wood Mushroom Card", woodMushroomCard),
  i("Sandy Pot Card", sandyPotCard),
  i("Mimic Card", mimicCard),
  i("Crabcake Card", crabcakeCard),
  i("Mafioso Card", mafiosoCard),
  i("Sand Castle Card", sandCastleCard),
  i("Pincermin Card", pincerminCard),
  i("Mashed Potato Card", mashedPotatoCard),
  i("Tyson Card", tysonCard),
  i("Moonmoon Card", moonmoonCard),
  i("Sand Giant Card", sandGiantCard),
  i("Snelbie Card", snelbieCard),
  i("Dig Doug Card", digDougCard),
  i("Crystal Crabal Card", crystalCrabalCard),
  i("Bandit Bob Card", banditBobCard),
  i("Copper Ore Card", copperOreCard),
  i("Iron Ore Card", ironOreCard),
  i("Gold Ore Card", goldOreCard),
  i("Fire Forge Card", fireForgeCard),
  i("Oak Logs Card", oakLogsCard),
  i("Bleach Logs Card", bleachLogsCard),
  i("Jungle Logs Card", jungleLogsCard),
  i("Forest Fibres Card", forestFibresCard),
  i("Goldfish Card", goldfishCard),
  i("Hermit Can Card", hermitCanCard),
  i("Jellyfish Card", jellyfishCard),
  i("Fly Card", flyCard),
  i("Butterfly Card", butterflyCard),
  i("Platinum Ore Card", platinumOreCard),
  i("Dementia Ore Card", dementiaOreCard),
  i("Void Ore Card", voidOreCard),
  i("Cinder Forge Card", cinderForgeCard),
  i("Tropilogs Card", tropilogsCard),
  i("Potty Rolls Card", pottyRollsCard),
  i("Veiny Logs Card", veinyLogsCard),
  i("Bloach Card", bloachCard),
  i("Sentient Cereal Card", sentientCerealCard),
  i("Fruitfly Card", fruitflyCard),
  i("Forest Soul Card", forestSoulCard),
  i("Dune Soul Card", duneSoulCard),
  i("Froge Card", frogeCard),
  i("Crabbo Card", crabboCard),
  i("Scorpie Card", scorpieCard),
  i("Sheepie Card", sheepieCard),
  i("Frost Flake Card", frostFlakeCard),
  i("Sir Stache Card", sirStacheCard),
  i("Bloque Card", bloqueCard),
  i("Mamooth Card", mamoothCard),
  i("Snowman Card", snowmanCard),
  i("Penguin Card", penguinCard),
  i("Thermister Card", thermisterCard),
  i("Quenchie Card", quenchieCard),
  i("Cryosnake Card", cryosnakeCard),
  i("Bop Box Card", bopBoxCard),
  i("Neyeptune Card", neyeptuneCard),
  i("Dedotated Ram Card", dedotatedRamCard),
  i("Xylobone Card", xyloboneCard),
  i("Bloodbone Card", bloodboneCard),
  i("Crystal Cattle Card", crystalCattleCard),
  i("Lustre Ore Card", lustreOreCard),
  i("Starfire Ore Card", starfireOreCard),
  i("Dreadlo Ore Card", dreadloOreCard),
  i("Godshard Ore Card", godshardOreCard),
  i("Tundra Logs Card", tundraLogsCard),
  i("Wispy Lumber Card", wispyLumberCard),
  i("Alien Hive Chunk Card", alienHiveChunkCard),
  i("Cubed Logs Card", cubedLogsCard),
  i("Maple Logs Card", mapleLogsCard),
  i("Dandielogs Card", dandielogsCard),
  i("Bamboo Logs Card", bambooLogsCard),
  i("Effervescent Logs Card", effervescentLogsCard),
  i("Skelefish Card", skelefishCard),
  i("Sand Shark Card", sandSharkCard),
  i("Manta Ray Card", mantaRayCard),
  i("Kraken Card", krakenCard),
  i("Mosquisnow Card", mosquisnowCard),
  i("Flycicle Card", flycicleCard),
  i("Worker Bee Card", workerBeeCard),
  i("Fairy Card", fairyCard),
  i("Scarab Card", scarabCard),
  i("Dust Mote Card", dustMoteCard),
  i("Ladybug Card", ladybugCard),
  i("Firefly Card", fireflyCard),
  i("Mousey Card", mouseyCard),
  i("Owlio Card", owlioCard),
  i("Pingy Card", pingyCard),
  i("Bunny Card", bunnyCard),
  i("Dung Beat Card", dungBeatCard),
  i("Honker Card", honkerCard),
  i("Blobfish Card", blobfishCard),
  i("Rooted Soul Card", rootedSoulCard),
  i("Frigid Soul Card", frigidSoulCard),
  i("Squishy Soul Card", squishySoulCard),
  i("Oozie Soul Card", oozieSoulCard),
  i("Breezy Soul Card", breezySoulCard),
  i("Icefish Card", icefishCard),
  i("Shellfish Card", shellfishCard),
  i("Jumbo Shrimp Card", jumboShrimpCard),
  i("Caulifish Card", caulifishCard),
  i("Purp Mushroom Card", purpMushroomCard),
  i("TV Card", tvCard),
  i("Donut Card", donutCard),
  i("Demon Genie Card", demonGenieCard),
  i("Soda Can Card", sodaCanCard),
  i("Flying Worm Card", flyingWormCard),
  i("Gelatinous Cuboid Card", gelatinousCuboidCard),
  i("Choccie Card", choccieCard),
  i("Biggole Wurm Card", biggoleWurmCard),
  i("Clammie Card", clammieCard),
  i("Octodar Card", octodarCard),
  i("Flombeige Card", flombeigeCard),
  i("Stilted Seeker Card", stiltedSeekerCard),
  i("Crystal Custard Card", crystalCustardCard),
  i("Suggma Card", suggmaCard),
  i("Maccie Card", maccieCard),
  i("Mister Brightside Card", misterBrightsideCard),
  i("Cheese Nub Card", cheeseNubCard),
  i("Stiltmole Card", stiltmoleCard),
  i("Molti Card", moltiCard),
  i("Purgatory Stalker Card", purgatoryStalkerCard),
  i("Citringe Card", citringeCard),
  i("Lampar Card", lamparCard),
  i("Fire Spirit Card", fireSpiritCard),
  i("Biggole Mole Card", biggoleMoleCard),
  i("Crawler Card", crawlerCard),
  i("Tremor Wurm Card", tremorWurmCard),
  i("Crystal Capybara Card", crystalCapybaraCard),
  i("Sprout Spirit Card", sproutSpiritCard),
  i("Ricecake Card", ricecakeCard),
  i("River Spirit Card", riverSpiritCard),
  i("Baby Troll Card", babyTrollCard),
  i("Woodlin Spirit Card", woodlinSpiritCard),
  i("Bamboo Spirit Card", bambooSpiritCard),
  i("Lantern Spirit Card", lanternSpiritCard),
  i("Mama Troll Card", mamaTrollCard),
  i("Leek Spirit Card", leekSpiritCard),
  i("Ceramic Spirit Card", ceramicSpiritCard),
  i("Skydoggie Spirit Card", skydoggieSpiritCard),
  i("Royal Egg Card", royalEggCard),
  i("Minichief Spirit Card", minichiefSpiritCard),
  i("Samurai Guardian Card", samuraiGuardianCard),
  i("Crystal Candalight Card", crystalCandalightCard),
  i("Poisonic Frog Card", poisonicFrogCard),
  i("Globohopper Card", globohopperCard),
  i("King Frog Card", kingFrogCard),
  i("Lava Slimer Card", lavaSlimerCard),
  i("Chromatium Frog Card", chromatiumFrogCard),
  i("Eldritch Croaker Card", eldritchCroakerCard),
  i("Grandfrogger Card", grandfroggerCard),
  i("Rotting Grandfrogger Card", rottingGrandfroggerCard),
  i("Forlorn Grandfrogger Card", forlornGrandfroggerCard),
  i("Vengeful Grandfrogger Card", vengefulGrandfroggerCard),
  i("Target Card", targetCard),
  i("Grumblo Card", grumbloCard),
  i("Beefie Card", beefieCard),
  i("Lazlo Card", lazloCard),
  i("Cactopunk Card", cactopunkCard),
  i("Crescent Spud Card", crescentSpudCard),
  i("Snakenhotep Card", snakenhotepCard),
  i("Enraged Snakenhotep Card", enragedSnakenhotepCard),
  i("Inevitable Snakenhotep Card", inevitableSnakenhotepCard),
  i("Ice Guard Card", iceGuardCard),
  i("Glaciaxus Card", glaciaxusCard),
  i("Golden Glaciaxus Card", goldenGlaciaxusCard),
  i("Caustic Glaciaxus Card", causticGlaciaxusCard),
  i("Baba Yaga Card", babaYagaCard),
  i("Dr Defecaus Card", drDefecausCard),
  i("Boop Card", boopCard),
  i("Amarok Card", amarokCard),
  i("Chaotic Amarok Card", chaoticAmarokCard),
  i("Radiant Amarok Card", radiantAmarokCard),
  i("Biggie Hours Card", biggieHoursCard),
  i("King Doot Card", kingDootCard),
  i("Efaunt Card", efauntCard),
  i("Chaotic Efaunt Card", chaoticEfauntCard),
  i("Gilded Efaunt Card", gildedEfauntCard),
  i("Dilapidated Slush Card", dilapidatedSlushCard),
  i("Chizoar Card", chizoarCard),
  i("Chaotic Chizoar Card", chaoticChizoarCard),
  i("Blighted Chizoar Card", blightedChizoarCard),
  i("Mutated Mush Card", mutatedMushCard),
  i("Massive Troll Card", massiveTrollCard),
  i("Chaotic Troll Card", chaoticTrollCard),
  i("Blitzkrieg Troll Card", blitzkriegTrollCard),
  i("Domeo Magmus Card", domeoMagmusCard),
  i("Kattlekruk Card", kattlekrukCard),
  i("Chaotic Kattlekruk Card", chaoticKattlekrukCard),
  i("Sacrilegious Kattlekruk Card", sacrilegiousKattlekrukCard),
  i("Demented Spiritlord Card", dementedSpiritlordCard),
  i("Emperor Card", emperorCard),
  i("Chaotic Emperor Card", chaoticEmperorCard),
  i("Sovereign Emperor Card", sovereignEmperorCard),
  i("Ghost (Event) Card", ghostEventCard),
  i("Giftmas Blobulyte Card", giftmasBlobulyteCard),
  i("Meaning of Giftmas Card", meaningOfGiftmasCard),
  i("Valentslime Card", valentslimeCard),
  i("Loveulyte Card", loveulyteCard),
  i("Chocco Box Card", choccoBoxCard),
  i("Giant Rose Card", giantRoseCard),
  i("Floofie Card", floofieCard),
  i("Shell Snake Card", shellSnakeCard),
  i("Egggulyte Card", egggulyteCard),
  i("Egg Capsule Card", eggCapsuleCard),
  i("Plasti Doug Card", plastiDougCard),
  i("Mr Blueberry Card", mrBlueberryCard),
  i("Coastiolyte Card", coastiolyteCard),
  i("Summer Spirit Card", summerSpiritCard),
  i("Golden Giftmas Box Card", goldenGiftmasBoxCard),
  i("Bubbulyte Card", bubbulyteCard),
  i("Spring Splendor Card", springSplendorCard),
  i("Falloween Pumpkin Card", falloweenPumpkinCard),

  i("Fly", fly),
  i("Butterfly", butterfly),
  i("Sentient Cereal", sentientCereal),
  i("Fruitfly", fruitfly),
  i("Mosquisnow", mosquisnow),
  i("Flycicle", flycicle),
  i("Worker Bee", workerBee),
  i("Fairy", fairy),
  i("Scarab", scarab),
  i("Dust Mote", dustMote),
  i("Dream Particulate", dreamParticulate),
  i("Ladybug", ladybug),
  i("Firefly", firefly),

  i("Copper Netted Net", copperNettedNet),
  i("Reinforced Net", reinforcedNet),
  i("Golden Net", goldenNet),
  i("Platinet", platinet),
  i("Dementia Net", dementiaNet),
  i("Void Imperium Net", voidImperiumNet),
  i("Lustre Netting", lustreNetting),
  i("Starfire Trim Netting", starfireTrimNetting),
  i("Dreadlo Matted Netting", dreadloMattedNetting),
  i("Marbiglass Netting", marbiglassNetting),
  i("Wrangler of the Qoxzul", wranglerOfTheQoxzul),

  i("Fly Nest", flyNest),
  i("Butterfly Bar", butterflyBar),
  i("Sentient Bowl", sentientBowl),
  i("Grocery Bag", groceryBag),
  i("Snowden", snowden),
  i("Icicle Nest", icicleNest),
  i("Bee Hive", beeHive),
  i("Fairy Hovel", fairyHovel),
  i("Scarab Nest", scarabNest),
  i("Mote Hovel", moteHovel),
  i("Dream Particulate", dreamParticulate),
  i("Ladybug Nest", ladybugNest),
  i("Firefly Nest", fireflyNest),

  i("Old Hatchet", oldHatchet),
  i("Copper Chopper", copperChopper),
  i("Iron Hatchet", ironHatchet),
  i("Grumbie the Hatchet Hammer", grumbieTheHatchetHammer),
  i("Golden Axe", goldenAxe),
  i("Stinky Axe", stinkyAxe),
  i("Plat Hatchet", platHatchet),
  i("Dementia Dicer", dementiaDicer),
  i("Void Imperium Axe", voidImperiumAxe),
  i("Lustre Logger", lustreLogger),
  i("Starfire Hatchet", starfireHatchet),
  i("Dreadlo Hatchet", dreadloHatchet),
  i("Marbiglass Hatchet", marbiglassHatchet),
  i("Annihilator of the Yggdrasil", annihilatorOfTheYggdrasil),

  i("Grass Leaf", grassLeaf),
  i("Twisty Leaf", twistyLeaf),
  i("Arctic Leaf", arcticLeaf),
  i("Galactic Leaf", galacticLeaf),
  i("Magma Leaf", magmaLeaf),
  i("Spirit Leaf", spiritLeaf),

  i("Oak Logs", oakLogs),
  i("Bleach Logs", bleachLogs),
  i("Jungle Logs", jungleLogs),
  i("Forest Fibres", forestFibres),
  i("Potty Rolls", pottyRolls),
  i("Tropilogs", tropilogs),
  i("Veiny Logs", veinyLogs),
  i("Tundra Logs", tundraLogs),
  i("Wispy Lumber", wispyLumber),
  i("Alien Hive Chunk", alienHiveChunk),
  i("Cubed Logs", cubedLogs),
  i("Maple Logs", mapleLogs),
  i("Dandielogs", dandielogs),
  i("Willow Logs", willowLogs),
  i("Bamboo Logs", bambooLogs),
  i("Effervescent Logs", effervescentLogs),

  i("Oak Tree", oakTree),
  i("Birch Tree", birchTree),
  i("Jungle Tree", jungleTree),
  i("Forest Tree", forestTree),
  i("Palm Tree", palmTree),
  i("Toilet Tree", toiletTree),
  i("Stump Tree", stumpTree),
  i("Saharan Foal", saharanFoal),
  i("Wispy Tree", wispyTree),
  i("Alien Tree", alienTree),
  i("Cubed Tree", cubedTree),
  i("Maple Tree", mapleTree),
  i("Dandelioli Tree", dandelioliTree),
  i("Equinox Willow Tree", equinoxWillowTree),
  i("Bamboo Tree", bambooTree),
  i("Effervescent Eucalyptus Tree", effervescentEucalyptusTree),

  i("Dewdrop Bronze Chest", bronzeChest),
  i("Dewdrop Silver Chest", silverChest),
  i("Dewdrop Gold Chest", goldChest),
  i("Sandstone Bronze Chest", bronzeChest),
  i("Sandstone Silver Chest", silverChest),
  i("Sandstone Gold Chest", goldChest),
  i("Chillsnap Bronze Chest", bronzeChest),
  i("Chillsnap Silver Chest", silverChest),
  i("Chillsnap Gold Chest", goldChest),
  i("Astro Bronze Chest", bronzeChest),
  i("Astro Silver Chest", silverChest),
  i("Astro Gold Chest", goldChest),
  i("Molten Bronze Chest", bronzeChest),
  i("Molten Silver Chest", silverChest),
  i("Molten Gold Chest", goldChest),
  i("Whimsical Bronze Chest", bronzeChest),
  i("Whimsical Silver Chest", silverChest),
  i("Whimsical Gold Chest", goldChest),

  i("Redox Salts", redoxSalts),
  i("Explosive Salts", explosiveSalts),
  i("Spontaneity Salts", spontaneitySalts),
  i("Dioxide Synthesis", dioxideSynthesis),
  i("Purple Salt", purpleSalt),
  i("Nullo Salt", nulloSalt),

  i("1 HR Time Candy", _1HRTimeCandy),
  i("2 HR Time Candy", _2HRTimeCandy),
  i("4 HR Time Candy", _4HRTimeCandy),
  i("12 HR Time Candy", _12HRTimeCandy),
  i("24 HR Time Candy", _24HRTimeCandy),
  i("72 HR Time Candy", _72HRTimeCandy),
  i("Steamy Time Candy", steamyTimeCandy),
  i("Spooky Time Candy", spookyTimeCandy),
  i("Cosmic Time Candy", cosmicTimeCandy),

  i("Small Experience Balloon", smallExperienceBalloon),
  i("Medium Experience Balloon", mediumExperienceBalloon),
  i("Large Experience Balloon", largeExperienceBalloon),

  i("Basketball", basketball),
  i("Secret Map", secretMap),
  i("Event Point", eventPoint),
  i("Talent Point Reset Fragment", talentPointResetFragment),
  i("Talent Point Reset Potion", talentPointResetPotion),
  i("Star Talent Reset Potion", starTalentResetPotion),
  i("Sub Class Swap Token", subClassSwapToken),
  i("Elite Class Swap Token", eliteClassSwapToken),
  i("Post Office Box Reseto Magnifico", postOfficeBoxResetoMagnifico),
  i("Hat Premiumifier", hatPremiumifier),
  i("Premium Stone Refunder", premiumStoneRefunder),
  i("Premium Bonus Swapper", premiumBonusSwapper),
  i("Gold Food Coupon", goldFoodCoupon),
  i("Resource Coupon", resourceCoupon),
  i("Really Really Resource Coupon", reallyReallyResourceCoupon),
  i("Black Pearl", blackPearl),
  i("Divinity Pearl", divinityPearl),
  i("Holy Pearl", holyPearl),
  i("Silver Pocketwatch", silverPocketwatch),
  i("Gold Pocketwatch", goldPocketwatch),
  i("Crop Transfer Ticket", cropTransferTicket),
  i("Anvil Reset Whetstone", anvilResetWhetstone),
  i("Bottled Town Teleport", bottledTownTeleport),
  i("Bottled World Town Teleport", bottledWorldTownTeleport),
  i("Equinox Mirror", equinoxMirror),

  i("Crimson String", crimsonString),
  i("Giftmas Box", giftmasBox),
  i("Summer Cooler", summerCooler),
  i("Job Application", jobApplication),
  i("Sculpting Tools", sculptingTools),
  i("Guilding Tools", guildingTools),
  i("Onyx Tools", onyxTools),
  i("BobJoePickle", bobJoePickle),
  i("BallJoePickle", ballJoePickle),
  i("BoneJoePickle", boneJoePickle),
  i("Mining Certificate", miningCertificate),
  i("Broken Mic", brokenMic),
  i("Loomi's Room Key", loomisRoomKey),
  i("Desert Topaz", desertTopaz),
  i("Glacier Quartz", glacierQuartz),
  i("Galaxial Amethyst", galaxialAmethyst),
  i("Magma Geode", magmaGeode),
  i("Spirit Diamond", spiritDiamond),
  i("Stone Peanut", stonePeanut),
  i("Ketchup Bottle", ketchupBottle),
  i("Mustard Bottle", mustardBottle),
  i("Class Certificate", classCertificate),
  i("Scouting Report", scoutingReport),
  i("Strange Rock", strangeRock),
  i("Forest Villas Flyer Thingy", forestVillasFlyerThingy),
  i("Dog Bone", dogBone),
  i("Empty Box", emptyBox),
  i("Employment Statistics", employmentStatistics),
  i("Red Frisbee", redFrisbee),
  i("Golden Dubloon", goldenDubloon),
  i("Signed Arrest Warrant", signedArrestWarrant),
  i("Time Thingy", timeThingy),
  i("Corporatube Sub", corporatubeSub),
  i("Instablab Follower", instablabFollower),
  i("Cloudsound Follower", cloudsoundFollower),
  i("Birthday Card", birthdayCard),
  i("Pre Crime Box", preCrimeBox),
  i("Bag o Nuts", bagONuts),
  i("Casual Confidante", casualConfidante),
  i("Triumphant Treason", triumphantTreason),
  i("Claiming Cashe", claimingCashe),
  i("Bolt Cutters", boltCutters),
  i("Monster Rating", monsterRating),
  i("Player Rating With Letter P", monsterRating),
  i("Player Rating With Letter S", monsterRating),
  i("Flowies", flowies),
  i("The Bobber Challenge Scroll", theBobberChallengeScroll),
  i("Dootophone", dootophone),
  i("Damaged Cog", damagedCog),
  i("Refurbished Cog", refurbishedCog),
  i("Shuvelle's Vote", shuvellesVote),
  i("Yondergreens Vote", yondergreensVote),
  i("Bill Brr's Vote", billBrrsVote),
  i("Signed Contract", signedContract),
  i("Blunderhills NPC Completion Token", blunderhillsNPCCompletionToken),
  i("Blunder Skills Completion Token", blunderSkillsCompletionToken),
  i("Blunderhills Misc Completion Token", blunderhillsMiscCompletionToken),
  i("Yumyum Desert NPC Completion Token", yumyumDesertNPCCompletionToken),
  i("Yumyum Skills Completion Token", yumyumSkillsCompletionToken),
  i("Yumyum Misc Completion Token", yumyumMiscCompletionToken),
  i("Easy Blunderhills NPC Token", easyBlunderhillsNPCToken),
  i("Med Blunderhills NPC Token", medBlunderhillsNPCToken),
  i("Hard Blunderhills NPC Token", hardBlunderhillsNPCToken),
  i("Woodsman Token", woodsmanToken),
  i("Glumlee Token", glumleeToken),
  i("Stiltzcho Token", stiltzchoToken),
  i("Funguy Token", funguyToken),
  i("Krunk Token", krunkToken),
  i("Tiki Chief Token", tikiChiefToken),
  i("Dog Bone Token", dogBoneToken),
  i("Papua Piggea Token", papuaPiggeaToken),
  i("Picnic Token", picnicToken),
  i("TP Pete Token", tPPeteToken),
  i("Sproutinald Token", sproutinaldToken),
  i("Dazey Token", dazeyToken),
  i("Bandit Bob Token", banditBobToken),
  i("Snake Jar Token", snakeJarToken),
  i("Whattso Token", whattsoToken),
  i("Cowbo Jones Token", cowboJonesToken),
  i("Carpetiem Token", carpetiemToken),
  i("Goldric Token", goldricToken),
  i("Cattleprod Token", cattleprodToken),
  i("Fishpaste Token", fishpasteToken),
  i("Loominadi Token", loominadiToken),
  i("Djonnut Token", djonnutToken),
  i("Scubidew Token", scubidewToken),
  i("Wellington Token", wellingtonToken),
  i("Easy Yumyum Dez NPC Token", easyYumyumDezNPCToken),
  i("Med Yumyum Dez NPC Token", medYumyumDezNPCToken),
  i("Hard Yumyum Dez NPC Token", hardYumyumDezNPCToken),
  i("Lonely Hunter Token", lonelyHunterToken),
  i("Hoggi Token", hoggiToken),
  i("Bellows Token", bellowsToken),
  i("Snouts Token", snoutsToken),
  i("Shuvelle Token", shuvelleToken),
  i("Yondergreen Token", yondergreenToken),
  i("Bill Brr Token", billBrrToken),
  i("Crystalswine Token", crystalswineToken),
  i("Easy FB Tundra NPC Token", easyFBTundraNPCToken),
  i("Med FB Tundra NPC Token", medFBTundraNPCToken),
  i("Hard FB Tundra NPC Token", hardFBTundraNPCToken),
  i("Tundra NPC Completion Token", tundraNPCCompletionToken),
  i("Tundra Skills Completion Token", tundraSkillsCompletionToken),
  i("Tundra Misc Completion Token", tundraMiscCompletionToken),
  i("Sesame Seed", sesameSeed),
  i("Blinding Lantern", blindingLantern),
  i("Elderly Peanut", elderlyPeanut),
  i("Pete the Peanut", peteThePeanut),

  i("Forest Villa Key", forestVillaKey),
  i("Efaunt's Tomb Key", efauntsTombKey),
  i("Chizoar's Cavern Key", chizoarsCavernKey),
  i("Troll's Enclave Key", trollsEnclaveKey),
  i("Kruk's Volcano Key", kruksVolcanoKey),
  i("Colosseum Ticket", colosseumTicket),
  i("Silver Pen", silverPen),
  i("Gem", gem),
  i("Talent Point Tab 1", talentPointTab1),
  i("Talent Point Tab 2", talentPointTab2),
  i("Talent Point Tab 3", talentPointTab3),
  i("Talent Point Tab 4", talentPointTab4),
  i("Talent Point Special Tab", talentPointSpecialTab),

  i("Goldfish", goldfish),
  i("Hermit Can", hermitCan),
  i("Jellyfish", jellyfish),
  i("Bloach", bloach),
  i("Skelefish", skelefish),
  i("Sand Shark", sandShark),
  i("Manta Ray", mantaRay),
  i("Kraken", kraken),
  i("Icefish", icefish),
  i("Shellfish", shellfish),
  i("Jumbo Shrimp", jumboShrimp),
  i("Caulifish", caulifish),
  i("Equinox Fish", equinoxFish),

  i("Copper Fish Rod", copperFishRod),
  i("Iron Fishing Rod", ironFishingRod),
  i("Gold Fishing Rod", goldFishingRod),
  i("Plat Fishing Rod", platFishingRod),
  i("Dementia Rod for Fishing", dementiaRodForFishing),
  i("Void Imperium Rod", voidImperiumRod),
  i("Lustre Rod", lustreRod),
  i("Starfire Rod", starfireRod),
  i("Dreadlo Rod", dreadloRod),
  i("Marbiglass Rod", marbiglassRod),

  i("Angler of the Iliunne", anglerOfTheIliunne),
  i("Gold Twine", goldTwine),
  i("Platinum Twine", platinumTwine),
  i("Scripticus Spoons", scripticusSpoons),
  i("Its a Boy Celebration", itsABoyCelebration),
  i("Its a Girl Celebration", itsAGirlCelebration),
  i("Its Alright Celebration", itsAlrightCelebration),
  i("Iron Hook", ironHook),
  i("Basic Bobber", basicBobber),
  i("Silver Twine", silverTwine),
  i("Fun Flags", funFlags),
  i("Electrical Wiring", electricalWiring),
  i("Wiener Links", wienerLinks),
  i("Zeus Gon Fishin", zeusGonFishin),
  i("Dualhook Prongs", dualhookProngs),
  i("One Pound of Feathers", onePoundOfFeathers),
  i("Massless Unit for Physics Questions", masslessUnitForPhysicsQuestions),
  i("Literal Elephant", literalElephant),
  i("Triple Threat", tripleThreat),
  i("Crash Box", crashBox),
  i("Fat Albert", fatAlbert),
  i("Valve Patented Circle Thingies", valvePatentedCircleThingies),
  i("Copper Twine", copperTwine),
  i("Wormie Weight", wormieWeight),
  i("Leafy Vines", leafyVines),
  i("One Pound of Steel", onePoundOfSteel),
  i("Needledrop", needledrop),
  i("Dynamite", dynamite),
  i("Not Dynamite", notDynamite),

  i("Small Fishing Spot", smallFishingSpot),
  i("Medium Fishing Spot", mediumFishingSpot),
  i("Large Fishing Spot", largeFishingSpot),

  i("Nomwich", nomwich),
  i("Hot Dog", hotDog),
  i("Cheezy Pizza", cheezyPizza),
  i("Peanut", peanut),
  i("Saucy Weiner", saucyWeiner),
  i("Kebab Sticks", kebabSticks),
  i("Meat Pie", meatPie),
  i("Mountain Bread", mountainBread),
  i("Yeti Ham", yetiHam),
  i("Sheepie Dairy", sheepieDairy),
  i("Cupcake", cupcake),
  i("Spicy Space Ribs", spicySpaceRibs),
  i("Lemon Slice", lemonSlice),
  i("Grilled Cheese Nomwich", grilledCheeseNomwich),
  i("Raw Nigiri", rawNigiri),
  i("Dumpling", dumpling),
  i("Cranberry Jam", cranberryJam),
  i("Milk Choco", milkChoco),
  i("Magic Meatloaf", magicMeatloaf),

  i("Small Strength Potion", smallStrengthPotion),
  i("Average Strength Potion", averageStrengthPotion),
  i("Decent Strength Potion", decentStrengthPotion),
  i("Potent Strength Potion", potentStrengthPotion),
  i("Small Life Potion", smallLifePotion),
  i("Average Life Potion", averageLifePotion),
  i("Decent Life Potion", decentLifePotion),
  i("Potent Life Potion", potentLifePotion),
  i("Small Speed Potion", smallSpeedPotion),
  i("Average Speed Potion", averageSpeedPotion),
  i("Decent Speed Potion", decentSpeedPotion),
  i("Potent Speed Potion", potentSpeedPotion),
  i("Small Mana Potion", smallManaPotion),
  i("Average Mana Potion", averageManaPotion),
  i("Decent Mana Potion", decentManaPotion),
  i("Potent Mana Potion", potentManaPotion),
  i("Small EXP Potion", smallEXPPotion),
  i("Average EXP Potion", averageEXPPotion),
  i("Minto Choco", mintoChoco),
  i("Decent EXP Potion", decentEXPPotion),
  i("Potent EXP Potion", potentEXPPotion),
  i("Quotient EXP Potion", quotientEXPPotion),
  i("Lemony Choco", lemonyChoco),
  i("Shiny Pearl", shinyPearl),
  i("Icing Ironbite", icingIronbite),
  i("Giftybread Man", giftybreadMan),
  i("Stained Pearl", stainedPearl),
  i("Saucy Logfries", saucyLogfries),
  i("Chogg Nog", choggNog),
  i("Slurpin Herm", slurpinHerm),
  i("Candy Canes", candyCanes),
  i("Aqua Pearl", aquaPearl),
  i("Buttered Toasted Butter", butteredToastedButter),
  i("Mistleberries", mistleberries),
  i("Critter Numnums", critterNumnums),
  i("Soulble Gum", soulbleGum),
  i("Bullet", bullet),
  i("FMJ Bullet", fMJBullet),
  i("Coldseeker Bullet", coldseekerBullet),
  i("Midnight Cookie", midnightCookie),
  i("Cherry Choco", cherryChoco),

  i("Golden Peanut", goldenPeanut),
  i("Golden Jam", goldenJam),
  i("Golden Kebabs", goldenKebabs),
  i("Golden Meat Pie", goldenMeatPie),
  i("Golden Nomwich", goldenNomwich),
  i("Golden Ham", goldenHam),
  i("Golden Bread", goldenBread),
  i("Golden Ribs", goldenRibs),
  i("Golden Cheese", goldenCheese),
  i("Golden Grilled Cheese Nomwich", goldenGrilledCheeseNomwich),
  i("Golden Hampter Gummy Candy", goldenHampterGummyCandy),
  i("Golden Nigiri", goldenNigiri),
  i("Golden Dumpling", goldenDumpling),
  i("Golden Cake", goldenCake),
  i("Butter Bar", butterBar),

  i("Grey Beret", greyBeret),
  i("Traffic Cone", trafficCone),
  i("Propeller Cap", propellerCap),
  i("Baseball Hat", baseballHat),
  i("Farmer Brim", farmerBrim),
  i("Leather Cap", leatherCap),
  i("Copper Helmet", copperHelmet),
  i("Militia Helm", militiaHelm),
  i("Thief Hood", thiefHood),
  i("Top Hat", topHat),
  i("Birthday Hat", birthdayHat),
  i("Iron Helmet", ironHelmet),
  i("Amarok Helmet", amarokHelmet),
  i("Gold Helmet", goldHelmet),
  i("Platinum Helmet", platinumHelmet),
  i("Viking Cap", vikingCap),
  i("Sleek Coif", sleekCoif),
  i("Witch Hat", witchHat),
  i("Efaunt Helmet", efauntHelmet),
  i("Dementia Helmet", dementiaHelmet),
  i("Void Imperium Helmet", voidImperiumHelmet),
  i("Mark of Member", markOfMember),
  i("Murmillo Helm", murmilloHelm),
  i("Conquistador Plume", conquistadorPlume),
  i("Adornment of the High Priest", adornmentOfTheHighPriest),
  i("Chizoar Helmet", chizoarHelmet),
  i("Lustre Veil", lustreVeil),
  i("Diabolical Headcase", diabolicalHeadcase),
  i("Thin Veil of The Troll", thinVeilOfTheTroll),
  i("Magma Core Headdress", magmaCoreHeaddress),
  i("Skulled Helmet of the Divine", skulledHelmetOfTheDivine),
  i("Marbiglass Headdress", marbiglassHeaddress),
  i("Crown of the Gods", crownOfTheGods),
  i("White Headband", whiteHeadband),
  i("Green Headband", greenHeadband),
  i("Red Headband", redHeadband),
  i("Purple Tupacband", purpleTupacband),
  i("Yellow Headband", yellowHeadband),
  i("Pink Headband", pinkHeadband),
  i("Stump Prop", stumpProp),
  i("Bored Beanie", boredBeanie),
  i("Shiny Bored Beanie", shinyBoredBeanie),
  i("Alien Headband", alienHeadband),
  i("Grandma Disguise", grandmaDisguise),
  i("Paper Boat", paperBoat),
  i("Cowbo Galloneer", cowboGalloneer),
  i("Jar", jar),
  i("Royal Turban", royalTurban),
  i("Acorn Topper", acornTopper),
  i("Nuget Cake Fedora", nugetCakeFedora),
  i("Honker Hat", honkerHat),
  i("Real Civil Engineer Helmet", realCivilEngineerHelmet),
  i("The Crow Perch", theCrowPerch),
  i("Ice Guard Helmet", iceGuardHelmet),
  i("Big Pretty Bow", bigPrettyBow),
  i("Bunny Ears", bunnyEars),
  i("Summer Shell", summerShell),
  i("Santa Hat", santaHat),
  i("3rd Anniversary Ice Cream Topper", _3rdAnniversaryIceCreamTopper),
  i("Steam Cap", steamCap),
  i("Apple Launch Hat", appleLaunchHat),
  i("Funny Hat", funnyHat),
  i("Meteorhead", meteorhead),

  i("Simple Key Chain", simpleKeyChain),
  i("Leafy Chain", leafyChain),
  i("Red Sneaker Chain", redSneakerChain),
  i("Wartooth Chain", wartoothChain),
  i("8 Ball Chain", eightBallChain),
  i("Piggy Chain", piggyChain),
  i("Dumbphone Chain", dumbphoneChain),
  i("Horn Chain", hornChain),
  i("Rustic Key Chain", rusticKeyChain),
  i("Taco Chain", tacoChain),
  i("Cactus Chain", cactusChain),
  i("Relic Chain", relicChain),
  i("Balloon Dog Chain", balloonDogChain),
  i("Frozen Tart Chain", frozenTartChain),
  i("Whatamelon Chain", whatamelonChain),
  i("9 Ball Chain", nineBallChain),
  i("Pincer Hand Chain", pincerHandChain),
  i("Gilded Key Chain", gildedKeyChain),
  i("Sushi Chain", sushiChain),
  i("Time Candy Chain", timeCandyChain),
  i("Star Blobulyte Galaxy Chain", starBlobulyteGalaxyChain),
  i("Mmm Donut Chain", mmmDonutChain),
  i("Negative 7 Chain", negative7Chain),
  i("Diamond Honker Chain", diamondHonkerChain),
  i("BobGoldPickle Chain", bobGoldPickleChain),
  i("Eye Owe Ess Chain", eyeOweEssChain),
  i("Key to Desert Chain", keyToDesertChain),
  i("Key to Mountains Chain", keyToMountainsChain),
  i("Key to Purgatory Chain", keyToPurgatoryChain),
  i("Spiritlord Horn Chain", spiritlordHornChain),

  i("Cue Tape", cueTape),
  i("Thread", thread),
  i("Trusty Nails", trustyNails),
  i("Boring Brick", boringBrick),
  i("Chain Link", chainLink),
  i("Leather Hide", leatherHide),
  i("Pinion Spur", pinionSpur),
  i("Lugi Bracket", lugiBracket),
  i("Purple Screw", purpleScrew),
  i("Thingymabob", thingymabob),
  i("Tangled Cords", tangledCords),
  i("PVC Pipe", pvcPipe),
  i("Distilled Water", distilledWater),
  i("Dense Water", denseWater),

  i("Junk Pickaxe", junkPickaxe),
  i("Copper Pickaxe", copperPickaxe),
  i("Iron Pickaxe", ironPickaxe),
  i("Skewered Snek", skeweredSnek),
  i("Poopy Pickaxe", poopyPickaxe),
  i("Gold Pickaxe", goldPickaxe),
  i("Platinum Pickaxe", platinumPickaxe),
  i("Dementia Pickaxe", dementiaPickaxe),
  i("Void Imperium Pik", voidImperiumPik),
  i("Lustre Pickaxe", lustrePickaxe),
  i("Starfire Pickaxe", starfirePickaxe),
  i("Dreadlo Pickolo", dreadloPickolo),
  i("Marbiglass Pickaxe", marbiglassPickaxe),
  i("Destroyer of the Mollo Gomme", destroyerOfTheMolloGomme),

  i("Copper Ore", copperOre),
  i("Iron Ore", ironOre),
  i("Gold Ore", goldOre),
  i("Platinum Ore", platinumOre),
  i("Dementia Ore", dementiaOre),
  i("Void Ore", voidOre),
  i("Lustre Ore", lustreOre),
  i("Starfire Ore", starfireOre),
  i("Dreadlo Ore", dreadloOre),
  i("Godshard Ore", godshardOre),
  i("Marble Ore", marbleOre),

  i("Copper Bar", copperBar),
  i("Iron Bar", ironBar),
  i("Gold Bar", goldBar),
  i("Platinum Bar", platinumBar),
  i("Dementia Bar", dementiaBar),
  i("Void Bar", voidBar),
  i("Lustre Bar", lustreBar),
  i("Starfire Bar", starfireBar),
  i("Dreadlo Bar", dreadloBar),
  i("Godshard Bar", godshardBar),
  i("Marble Bar", marbleBar),

  i("Copper Vein", copperVein),
  i("Iron Vein", ironVein),
  i("Gold Vein", goldVein),
  i("Platinum Vein", platinumVein),
  i("Dementia Vein", dementiaVein),
  i("Void Vein", voidVein),
  i("Lustre Vein", lustreVein),
  i("Starfire Vein", starfireVein),
  i("Dreadlo Vein", dreadloVein),
  i("Godshard Vein", godshardVein),
  i("Marble Vein", marbleVein),

  i("Golden Oyster", goldenOyster),
  i("Obol Fragment", obolFragment),
  i("Quality Obol Stack", qualityObolStack),
  i("Marvelous Obol Stack", marvelousObolStack),
  i("Bossius Obol Stack", bossiusObolStack),
  i("Hyper Obol Stack", hyperObolStack),
  i("Hyper Obol Stack Square Edition", hyperObolStackSquareEdition),

  i("Crude Oil", crudeOil),
  i("Toxic Sludge", toxicSludge),
  i("Radioactive Waste", radioactiveWaste),
  i("Eco Friendly Oil", ecoFriendlyOil),
  i("Magma Barrel", magmaBarrel),
  i("Plasma Barrel", plasmaBarrel),
  i("Glumlee's Special Tutorial Oil", glumleesSpecialTutorialOil),

  i("Googley Eyes", googleyEyes),
  i("Dootjat Eye", dootjatEye),
  i("Guild Giftbox", guildGiftbox),
  i("Lovey Dovey Letter", loveyDoveyLetter),
  i("Choco Box", chocoBox),
  i("Egg Capsule", eggCapsule),
  i("Gummy Bunny", gummyBunny),
  i("Goldegg Capsule", goldeggCapsule),
  i("Beach Oyster", beachOyster),
  i("Phone Box", phoneBox),
  i("Gem Envelope", gemEnvelope),
  i("Spring Baggie", springBaggie),
  i("Anniversary Box", anniversaryBox),
  i("Falloween Treat", falloweenTreat),
  i("Golden Gift", goldenGift),
  i("Mayonnaise Bottle", mayonnaiseBottle),
  i("Broken Weapon", brokenWeapon),
  i("Dried Paint Blob", driedPaintBlob),
  i("Engraved Bullet", engravedBullet),
  i("Silver Antique", silverAntique),
  i("2021 Giftmas Box", _2021GiftmasBox),
  i("Newbie Card Pack", newbieCardPack),
  i("Ancient Card Pack", ancientCardPack),
  i("Eternal Card Pack", eternalCardPack),
  i("Dungeon Card Pack", dungeonCardPack),
  i("Galaxy Card Pack", galaxyCardPack),
  i("Smolderin Card Pack", smolderinCardPack),
  i("Dungeon Loot Dice", dungeonLootDice),
  i("Birthday Candle", birthdayCandle),

  i("Spore Cap", sporeCap),
  i("Frog Leg", frogLeg),
  i("Bean Slices", beanSlices),
  i("Red Spore Cap", redSporeCap),
  i("Slime Sludge", slimeSludge),
  i("Snake Skin", snakeSkin),
  i("Carrot Cube", carrotCube),
  i("Glublin Ear", glublinEar),
  i("Plank", plank),
  i("Bullfrog Horn", bullfrogHorn),
  i("Corn Kernels", cornKernels),
  i("Golden Plop", goldenPlop),
  i("Rats Tail", ratsTail),
  i("Bonemeal", bonemeal),
  i("Stick", stick),
  i("Woodular Circle", woodularCircle),
  i("Acorn", Acorn),
  i("Pocket Sand", pocketSand),
  i("Glass Shard", glassShard),
  i("Megalodon Tooth", megalodonTooth),
  i("Crabby Cakey", crabbyCakey),
  i("Nuget Cake", nugetCake),
  i("Coconotnotto", coconotnotto),
  i("Furled Flag", furledFlag),
  i("Pincer Arm", pincerArm),
  i("Potato Remains", potatoRemains),
  i("High Steaks", highSteaks),
  i("Wakka Cherry", wakkaCherry),
  i("Ghost", ghost),
  i("Singlecle", singlecle),
  i("Shrapshell", shrapshell),
  i("Floof Ploof", floofPloof),
  i("Melty Cube", meltyCube),
  i("Yellow Snowflake", yellowSnowflake),
  i("Moustache Comb", moustacheComb),
  i("Ram Wool", ramWool),
  i("Sticky Stick", stickyStick),
  i("Mamooth Tusk", mamoothTusk),
  i("Ice Age 3", iceAge3),
  i("Snow Ball", snowBall),
  i("Pen", pen),
  i("Cracked Glass", crackedGlass),
  i("Sippy Straw", sippyStraw),
  i("Cryosnake Skin", cryosnakeSkin),
  i("Audio Cord", audioCord),
  i("Contact Lense", contactLense),
  i("Black Lense", blackLense),
  i("Blood Bone", bloodBone),
  i("Purple Mush Cap", purpleMushCap),
  i("TV Remote", tVRemote),
  i("Lost Batteries", lostBatteries),
  i("Half Eaten Donut", halfEatenDonut),
  i("Genie Lamp", genieLamp),
  i("Bottle Cap", bottleCap),
  i("Wurm Tail", wurmTail),
  i("Tongue Bone", tongueBone),
  i("Crumpled Wrapper", crumpledWrapper),
  i("Smol Worm", smolWorm),
  i("Empty Oyster Shell", emptyOysterShell),
  i("Pearler Shell", pearlerShell),
  i("Wriggly Ball", wrigglyBall),
  i("Gel Chunk", gelChunk),
  i("Condensed Zap", condensedZap),
  i("Suggma Ashes", suggmaAshes),
  i("Royal Suggma Urn", royalSuggmaUrn),
  i("Plated Crumbs", platedCrumbs),
  i("Sundried Glass", sundriedGlass),
  i("Cheesy Crumbs", cheesyCrumbs),
  i("Stilt Pole", stiltPole),
  i("Hampter", hampter),
  i("Meteorite", meteorite),
  i("Shattered Skull", shatteredSkull),
  i("Orange Slice", orangeSlice),
  i("OJ Juice", oJJuice),
  i("Molten Lamp", moltenLamp),
  i("Spitfire", spitfire),
  i("Hard Hat", hardHat),
  i("Wormie Slices", wormieSlices),
  i("Mongo Worm Slices", mongoWormSlices),
  i("Leafy Droplet", leafyDroplet),
  i("Rice Cake", riceCake),
  i("Stacked Rice Cake", stackedRiceCake),
  i("Bamboo", bamboo),
  i("Leafy Horn", leafyHorn),
  i("Wooden Aortic Mass", woodenAorticMass),
  i("Leafy Branch", leafyBranch),
  i("Light Lantern", lightLantern),
  i("Dark Lantern", darkLantern),
  i("Troll Flower", trollFlower),
  i("Chopped Leek", choppedLeek),
  i("Shattered Ceramic", shatteredCeramic),
  i("Eviscerated Chunk", evisceratedChunk),
  i("Royal Yolk", royalYolk),
  i("Royal Fabric", royalFabric),
  i("Royal Headpiece", royalHeadpiece),
  i("Baba Yaga Baby Eggs", babaYagaBabyEggs),
  i("Minuteglass", minuteglass),
  i("Amarok Slab", amarokSlab),
  i("Chaotic Amarok Slab", chaoticAmarokSlab),
  i("Ripped Tunic", rippedTunic),
  i("Ribbed Tunic", ribbedTunic),
  i("Chizoar Spike", chizoarSpike),
  i("Chizoar Stalagmite", chizoarStalagmite),
  i("Troll Scales", trollScales),
  i("Kruk Tooth", krukTooth),
  i("Kruk Cavity Tooth", krukCavityTooth),

  i("Green Mushroom", greenMushroomCard),
  i("Red Mushroom", redMushroomCard),
  i("Frog", frogCard),
  i("Bored Bean", boredBeanCard),
  i("Slime", slimeCard),
  i("Baby Boa", babyBoaCard),
  i("Carrotman", carrotmanCard),
  i("Glublin", glublinCard),
  i("Wode Board", wodeBoardCard),
  i("Gigafrog", gigafrogCard),
  i("Poop", poopCard),
  i("Rat", ratCard),
  i("Walking Stick", walkingStickCard),
  i("Nutto", nuttoCard),
  i("Wood Mushroom", woodMushroomCard),
  i("Crystal Carrot", crystalCarrotCard),
  i("Baba Yaga", babaYagaCard),
  i("Dr Defecaus", drDefecausCard),
  i("Amarok", amarokCard),
  i("Chaotic Amarok", chaoticAmarokCard),
  i("Radiant Amarok", radiantAmarokCard),

  i("Sandy Pot", sandyPotCard),
  i("Mimic", mimicCard),
  i("Crabcake", crabcakeCard),
  i("Mafioso", mafiosoCard),
  i("Sand Castle", sandCastleCard),
  i("Pincermin", pincerminCard),
  i("Mashed Potato", mashedPotatoCard),
  i("Tyson", tysonCard),
  i("Moonmoon", moonmoonCard),
  i("Sand Giant", sandGiantCard),
  i("Snelbie", snelbieCard),
  i("Dig Doug", digDougCard),
  i("Crystal Crabal", crystalCrabalCard),
  i("Biggie Hours", biggieHoursCard),
  i("King Doot", kingDootCard),
  i("Efaunt", efauntCard),
  i("Chaotic Efaunt", chaoticEfauntCard),
  i("Gilded Efaunt", gildedEfauntCard),

  i("Sheepie", sheepieCard),
  i("Frost Flake", frostFlakeCard),
  i("Sir Stache", sirStacheCard),
  i("Bloque", bloqueCard),
  i("Mamooth", mamoothCard),
  i("Snowman", snowmanCard),
  i("Penguin", penguinCard),
  i("Thermister", thermisterCard),
  i("Quenchie", quenchieCard),
  i("Cryosnake", cryosnakeCard),
  i("Bop Box", bopBoxCard),
  i("Neyeptune", neyeptuneCard),
  i("Dedotated Ram", dedotatedRamCard),
  i("Xylobone", xyloboneCard),
  i("Bloodbone", bloodboneCard),
  i("Crystal Cattle", crystalCattleCard),
  i("Dilapidated Slush", dilapidatedSlushCard),
  i("Chizoar", chizoarCard),
  i("Chaotic Chizoar", chaoticChizoarCard),
  i("Blighted Chizoar", blightedChizoarCard),

  i("Purp Mushroom", purpMushroomCard),
  i("TV", tvCard),
  i("Donut", donutCard),
  i("Demon Genie", demonGenieCard),
  i("Soda Can", sodaCanCard),
  i("Flying Worm", flyingWormCard),
  i("Gelatinous Cuboid", gelatinousCuboidCard),
  i("Choccie", choccieCard),
  i("Biggole Wurm", biggoleWurmCard),
  i("Clammie", clammieCard),
  i("Octodar", octodarCard),
  i("Flombeige", flombeigeCard),
  i("Stilted Seeker", stiltedSeekerCard),
  i("Crystal Custard", crystalCustardCard),
  i("Massive Troll", massiveTrollCard),
  i("Chaotic Troll", chaoticTrollCard),
  i("Blitzkrieg Troll", blitzkriegTrollCard),

  i("Suggma", suggmaCard),
  i("Maccie", maccieCard),
  i("Mister Brightside", misterBrightsideCard),
  i("Cheese Nub", cheeseNubCard),
  i("Stiltmole", stiltmoleCard),
  i("Molti", moltiCard),
  i("Purgatory Stalker", purgatoryStalkerCard),
  i("Citringe", citringeCard),
  i("Lampar", lamparCard),
  i("Fire Spirit", fireSpiritCard),
  i("Biggole Mole", biggoleMoleCard),
  i("Crawler", crawlerCard),
  i("Tremor Wurm", tremorWurmCard),
  i("Crystal Capybara", crystalCapybaraCard),
  i("Domeo Magmus", domeoMagmusCard),
  i("Kattlekruk", kattlekrukCard),
  i("Chaotic Kattlekruk", chaoticKattlekrukCard),
  i("Sacrilegious Kattlekruk", sacrilegiousKattlekrukCard),

  i("Sprout Spirit", sproutSpiritCard),
  i("Ricecake", ricecakeCard),
  i("River Spirit", riverSpiritCard),
  i("Baby Troll", babyTrollCard),
  i("Woodlin Spirit", woodlinSpiritCard),
  i("Bamboo Spirit", bambooSpiritCard),
  i("Lantern Spirit", lanternSpiritCard),
  i("Mama Troll", mamaTrollCard),
  i("Leek Spirit", leekSpiritCard),
  i("Ceramic Spirit", ceramicSpiritCard),
  i("Skydoggie Spirit", skydoggieSpiritCard),
  i("Royal Egg", royalEggCard),
  i("Minichief Spirit", minichiefSpiritCard),
  i("Samurai Guardian", samuraiGuardianCard),
  i("Crystal Candalight", crystalCandalightCard),
  i("Demented Spiritlord", dementedSpiritlordCard),
  i("Emperor", emperorCard),
  i("Chaotic Emperor", chaoticEmperorCard),
  i("Sovereign Emperor", sovereignEmperorCard),

  i("Grandfrogger", grandfroggerCard),
  i("Rotting Grandfrogger", rottingGrandfroggerCard),
  i("Forlorn Grandfrogger", forlornGrandfroggerCard),
  i("Vengeful Grandfrogger", vengefulGrandfroggerCard),

  i("Hyper DMG Obol", hyperDMGObol),
  i("Hyper Pyre Obol", hyperPyreObol),
  i("Hyper Six Obol", hyperSixObol),
  i("Hyper Skull Obol", hyperSkullObol),
  i("Bronze AGI Obol", bronzeAGIObol),
  i("Bronze LUK Obol", bronzeLUKObol),
  i("Bronze Obol of Cards", bronzeObolOfCards),
  i("Bronze Obol of Chippin Chops", bronzeObolOfChippinChops),
  i("Bronze Obol of Construction", bronzeObolOfConstruction),
  i("Bronze Obol of Defence", bronzeObolOfDefence),
  i("Bronze Obol of Experience", bronzeObolOfExperience),
  i("Bronze Obol of Few Flies", bronzeObolOfFewFlies),
  i("Bronze Obol of Finite Fish", bronzeObolOfFiniteFish),
  i("Bronze Obol of Multikill", bronzeObolOfMultikill),
  i("Bronze Obol of Pop", bronzeObolOfPop),
  i("Bronze Obol of Puny Damage", bronzeObolOfPunyDamage),
  i("Bronze Obol of Small Swings", bronzeObolOfSmallSwings),
  i("Bronze Obol of Trapping", bronzeObolOfTrapping),
  i("Bronze Obol of Worship", bronzeObolOfWorship),
  i("Bronze STR Obol", bronzeSTRObol),
  i("Bronze WIS Obol", bronzeWISObol),
  i("Silver AGI Obol", silverAGIObol),
  i("Silver LUK Obol", silverLUKObol),
  i("Silver Obol of Big Bark", silverObolOfBigBark),
  i("Silver Obol of Big Bugs", silverObolOfBigBugs),
  i("Silver Obol of Construction", silverObolOfConstruction),
  i("Silver Obol of Defence", silverObolOfDefence),
  i("Silver Obol of Experience", silverObolOfExperience),
  i("Silver Obol of Little Damage", silverObolOfLittleDamage),
  i("Silver Obol of Megakill", silverObolOfMegakill),
  i("Silver Obol of Moderate Mining", silverObolOfModerateMining),
  i("Silver Obol of Pop Pop", silverObolOfPopPop),
  i("Silver Obol of Puny Pikes", silverObolOfPunyPikes),
  i("Silver Obol of Trapping", silverObolOfTrapping),
  i("Silver Obol of Worship", silverObolOfWorship),
  i("Silver STR Obol", silverSTRObol),
  i("Silver WIS Obol", silverWISObol),
  i("Gold AGI Obol", goldAGIObol),
  i("Gold LUK Obol", goldLUKObol),
  i("Gold STR Obol", goldSTRObol),
  i("Gold WIS Obol", goldWISObol),
  i("Golden Obol of Big Boy Damage", goldenObolOfBigBoyDamage),
  i("Platinum AGI Obol", platinumAGIObol),
  i("Platinum LUK Obol", platinumLUKObol),
  i("Platinum STR Obol", platinumSTRObol),
  i("Platinum WIS Obol", platinumWISObol),
  i("Grumpy Obol of the Grandfrogger", grumpyObolOfTheGrandfrogger),
  i("Hyper DMG Obol B", hyperDMGObolB),
  i("Hyper Pyre Obol B", hyperPyreObolB),
  i("Hyper Six Obol B", hyperSixObolB),
  i("Hyper Skull Obol B", hyperSkullObolB),
  i("Vigilant Obol of Ice Guard", vigilantObolOfIceGuard),
  i("Silver Obol of Cards", silverObolOfCards),
  i("Silver Obol of Double Sixes", silverObolOfDoubleSixes),
  i("Silver Obol of Pocket Change", silverObolOfPocketChange),
  i("Golden Obol of Construction", goldenObolOfConstruction),
  i("Golden Obol of Crazy Carp", goldenObolOfCrazyCarp),
  i("Golden Obol of Defence", goldenObolOfDefence),
  i("Golden Obol of Diligent Digging", goldenObolOfDiligentDigging),
  i("Golden Obol of Experience", goldenObolOfExperience),
  i("Golden Obol of Huge Hackin", goldenObolOfHugeHackin),
  i("Golden Obol of Insane Insects", goldenObolOfInsaneInsects),
  i("Golden Obol of Plentiful Riches", goldenObolOfPlentifulRiches),
  i("Golden Obol of Poppity Pop", goldenObolOfPoppityPop),
  i("Golden Obol of Trapping", goldenObolOfTrapping),
  i("Golden Obol of Triple Sixes", goldenObolOfTripleSixes),
  i("Golden Obol of Ultrakill", goldenObolOfUltrakill),
  i("Golden Obol of Worship", goldenObolOfWorship),
  i("Platinum Obol of Lethal Damage", platinumObolOfLethalDamage),
  i("Dementia AGI Obol", dementiaAGIObol),
  i("Dementia LUK Obol", dementiaLUKObol),
  i("Dementia STR Obol", dementiaSTRObol),
  i("Dementia WIS Obol", dementiaWISObol),
  i("Frozen Obol of Chizoar's Rage", frozenObolOfChizoarsRage),
  i("Granite Obol of Amarok's Stare", graniteObolOfAmaroksStare),
  i("Magma Obol of Big Time Domeo", magmaObolOfBigTimeDomeo),
  i("Skeletal Obol of Efaunt's Gaze", skeletalObolOfEfauntsGaze),
  i("Slushy Obol of Much Dilapidation", slushyObolOfMuchDilapidation),
  i("Golden Obol of Cards", goldenObolOfCards),
  i("Platinum Obol of Ample Anthropods", platinumObolOfAmpleAnthropods),
  i("Platinum Obol of Blinding Speed", platinumObolOfBlindingSpeed),
  i("Platinum Obol of Cards", platinumObolOfCards),
  i("Platinum Obol of Construction", platinumObolOfConstruction),
  i("Platinum Obol of Defense with an S", platinumObolOfDefenseWithAnS),
  i("Platinum Obol of Dwarven Delving", platinumObolOfDwarvenDelving),
  i("Platinum Obol of Experience", platinumObolOfExperience),
  i("Platinum Obol of Killimanjaro", platinumObolOfKillimanjaro),
  i("Platinum Obol of Lumby Loggo", platinumObolOfLumbyLoggo),
  i("Platinum Obol of Poppity Poppy", platinumObolOfPoppityPoppy),
  i("Platinum Obol of Trapping", platinumObolOfTrapping),
  i("Platinum Obol of Tremendous Trout", platinumObolOfTremendousTrout),
  i("Platinum Obol of Worship", platinumObolOfWorship),
  i("Platinum Obol of Yahtzee Sixes", platinumObolOfYahtzeeSixes),
  i("Dementia Obol of Infinite Damage", dementiaObolOfInfiniteDamage),
  i("Jagged Obol of Massive Trolling", jaggedObolOfMassiveTrolling),
  i("Molten Obol of Dead Divine", moltenObolOfDeadDivine),
  i("Dementia Obol of Cards", dementiaObolOfCards),
  i("Dementia Obol of Colossal Crawlies", dementiaObolOfColossalCrawlies),
  i("Dementia Obol of Construction", dementiaObolOfConstruction),
  i("Dementia Obol of Defence", dementiaObolOfDefence),
  i("Dementia Obol of Experience", dementiaObolOfExperience),
  i("Dementia Obol of Infinisixes", dementiaObolOfInfinisixes),
  i("Dementia Obol of Killionaire", dementiaObolOfKillionaire),
  i("Dementia Obol of Magisterial Metals", dementiaObolOfMagisterialMetals),
  i("Dementia Obol of Monument Marlins", dementiaObolOfMonumentMarlins),
  i("Dementia Obol of Pop Pop Pop Pop", dementiaObolOfPopPopPopPop),
  i("Dementia Obol of Trapping", dementiaObolOfTrapping),
  i("Dementia Obol of Worship", dementiaObolOfWorship),
  i("Dementia Obol of WOWOWOWWO", dementiaObolOfWOWOWOWWO),

  i("Torn Jeans", tornJeans),
  i("Give Up On Life Pants", giveUpOnLifePants),
  i("Copper Platelegs", copperPlatelegs),
  i("Iron Platelegs", ironPlatelegs),
  i("Dirty Coal Miner Baggy Soot Pants", dirtyCoalMinerBaggySootPants),
  i("Bleached Designer Wode Patch Pants", bleachedDesignerWodePatchPants),
  i("Fishing Overalls", fishingOveralls),
  i("Bandito Pantaloon", banditoPantaloon),
  i("Gold Platelegs", goldPlatelegs),
  i("Amarok Hinds", amarokHinds),
  i("Platinum Shins", platinumShins),
  i("Dementia Shins", dementiaShins),
  i("Efaunt Hipilium", efauntHipilium),
  i("Trimmed Rune Platelegs", trimmedRunePlatelegs),
  i("Void Imperium Shardshins", voidImperiumShardshins),
  i("Chizoar Scaled Leggings", chizoarScaledLeggings),
  i("Lustre Scales", lustreScales),
  i("Diabolical Trimed Leg Guards", diabolicalTrimedLegGuards),
  i("Twisted Scales", twistedScales),
  i("Magma Core Battleskirt", magmaCoreBattleskirt),
  i("Spiked Leggings of the Divine", spikedLeggingsOfTheDivine),
  i("Marbiglass Legplates", marbiglassLegplates),
  i("Tatters of the Gods", tattersOfTheGods),
  i("Adam's Leaf", adamsLeaf),

  i("Little Wooden Katana", littleWoodenKatana),
  i("Sleek Shank", sleekShank),
  i("Crescent Moon Pendant", crescentMoonPendant),
  i("Deathbloom Flower Pendant", deathbloomFlowerPendant),
  i("Carrot Horror", carrotHorror),
  i("Strung Bludgeon", strungBludgeon),
  i("Tarantulight", tarantulight),
  i("Cedar Pendant", cedarPendant),
  i("Chaotic Amarok Pendant", chaoticAmarokPendant),
  i("Polished Bludgeon", polishedBludgeon),
  i("Fishhead Pendant", fishheadPendant),
  i("Skullfish Pendant", skullfishPendant),
  i("Fuscismatia", fuscismatia),
  i("Deathly Cluster Pendant", deathlyClusterPendant),
  i("Chizoars Blankie", chizoarsBlankie),
  i("Hallowed Tail Pendant", hallowedTailPendant),
  i("Chizoars Caustic Scarf", chizoarsCausticScarf),
  i("Persephones Bouquet", persephonesBouquet),
  i("Strung Tooth of the Divine", strungToothOfTheDivine),
  i("The Divine Scarf", theDivineScarf),
  i("Slimy Necklace", slimyNecklace),

  i("Bandit Bob Mask", banditBobMask),
  i("Invisible Hat", invisibleHat),
  i("Hotdog Hero", hotdogHero),
  i("Parasite", parasite),
  i("Giftmas Tree", giftmasTree),
  i("Pop Cat", popCat),
  i("The Classic", theClassic),
  i("Green Beanie", greenBeanie),
  i("Big Bunny", bigBunny),
  i("Fluffy Ramsy", fluffyRamsy),
  i("Ele Sorcerer Pointed Hat", eleSorcererPointedHat),
  i("Borzoi Topper", borzoiTopper),
  i("Yellow Beanie", yellowBeanie),
  i("Bedsheet with Holes", bedsheetWithHoles),
  i("Carrotman Mask", carrotmanMask),
  i("Glublin Mask", glublinMask),
  i("Bloque Mask", bloqueMask),
  i("Giftmas Snoozy Cap", giftmasSnoozyCap),
  i("The Red Boaty", theRedBoaty),
  i("Corgi Topper", corgiTopper),
  i("Siege Captain Cap", siegeCaptainCap),
  i("Straw Hat", strawHat),
  i("Wig Bandana", wigBandana),
  i("Funky Hat", funkyHat),
  i("Reinforced Headband", reinforcedHeadband),
  i("Shogun Helmet", shogunHelmet),
  i("Gilded Headband", gildedHeadband),
  i("Bamboo Hat", bambooHat),
  i("Festive Beast Mask", festiveBeastMask),
  i("Heiress Headdress", heiressHeaddress),
  i("Spirited Mane", spiritedMane),
  i("Fiery Mane", fieryMane),
  i("Guardian Mane", guardianMane),
  i("Fanned Blossomage", fannedBlossomage),
  i("Dainty Brim", daintyBrim),
  i("Charcoal Hat", charcoalHat),
  i("Pardoned Turkey", pardonedTurkey),
  i("Paper Bag", paperBag),
  i("Diamon Horns", diamonHorns),
  i("Halloween Pumpkin", halloweenPumpkin),
  i("Strawbiggy", strawbiggy),
  i("Dairy Dunk", dairyDunk),
  i("Snowman", snowman),
  i("Husky Hat", huskyHat),
  i("Pink Beanie", pinkBeanie),
  i("Ice Cream Sundae", iceCreamSundae),
  i("Orange Beanie", orangeBeanie),
  i("Farmer Brimest", farmerBrimest),

  i("Leafy Ring", leafyRing),
  i("Bob Ring", bobRing),
  i("Bubble Ring", bubbleRing),
  i("Love Ring", loveRing),
  i("Wealth Ring", wealthRing),
  i("Cthulu's Ring", cthulusRing),
  i("Lava Sez Buy More Gems", lavaSezBuyMoreGems),
  i("HONK Ring", hONKRing),
  i("Equinox Ring", equinoxRing),
  i("Meteorite Ring", meteoriteRing),

  i("Timeless Watch", timelessWatch),
  i("Giant Nightshade", giantNightshade),
  i("Angel Wings", angelWings),
  i("Easter Egg Backpack", easterEggBackpack),
  i("Radiant Amarok Backstabber", radiantAmarokBackstabber),
  i("Gilded Efaunt Dislodged Tusks", gildedEfauntDislodgedTusks),
  i("Blighted Chizoar Shard Cape", blightedChizoarShardCape),
  i("Cascading Scaled Cape of Krieg", cascadingScaledCapeOfKrieg),
  i("Molten Cloak", moltenCloak),
  i("Giant Rose", giantRose),
  i("Giant Violet", giantViolet),
  i("Giant Starflower", giantStarflower),
  i("Riftwalker Wings", riftwalkerWings),
  i("Blooming Vine", bloomingVine),
  i("Eternal Flames of The Divine", eternalFlamesOfTheDivine),
  i("Phoenix Wings", phoenixWings),

  i("Lava's Awesome Nametag", lavasAwesomeNametag),
  i("Timeless Nametag", timelessNametag),
  i("Nightshade Nametag", nightshadeNametag),
  i("Riftwalker Nametag", riftwalkerNametag),
  i("Balling Nametag", ballingNametag),
  i("Vman Nametag", vmanNametag),
  i("Spring Flowers Nametag", springFlowersNametag),
  i("Trash Tuna Nametag", trashTunaNametag),
  i("Island Adventurer Nametag", islandAdventurerNametag),
  i("Summer Shovel Nametag", summerShovelNametag),
  i("Falloween Nametag", falloweenNametag),
  i("3rd Anniversary IdleOn Nametag", _3rdAnniversaryIdleOnNametag),
  i("Megafeather Nametag", megafeatherNametag),
  i("Spectacular 4th Year Nametag", spectacular4thYearNametag),
  i("4th Anniversary IdleOn Nametag", _4thAnniversaryIdleOnNametag),

  i("Meteorite", meteoriteRing),
  i("Mega Grumblo", grumbieTheHatchetHammer),
  i("Glacial Guild", vigilantObolOfIceGuard),
  i("Snake Swarm", skeweredSnek),
  i("Angry Frogs", grumpyObolOfTheGrandfrogger),

  i("Bandito Pantaloon (Beginner Recipe)", beginnerRecipe),
  i("Bleached Designer Wode Patch Pants (Beginner Recipe)", beginnerRecipe),
  i("Copper Band (Beginner Recipe)", beginnerRecipe),
  i("Double Goopi (Beginner Recipe)", beginnerRecipe),
  i("Fishing Overalls (Beginner Recipe)", beginnerRecipe),
  i("Fur Shirt (Beginner Recipe)", beginnerRecipe),
  i("Goo Galoshes (Beginner Recipe)", beginnerRecipe),
  i("Iron Boots (Beginner Recipe)", beginnerRecipe),
  i("Serrated Rex Ring (Beginner Recipe)", beginnerRecipe),
  i("Steel Band (Beginner Recipe)", beginnerRecipe),
  i("Defenders Dignity (Novice Recipe)", noviceRecipe),
  i("Dootjat Eye (Novice Recipe)", noviceRecipe),
  i("Googley Eyes (Novice Recipe)", noviceRecipe),
  i("Polished Bludgeon (Novice Recipe)", noviceRecipe),
  i("Protectors Pride (Novice Recipe)", noviceRecipe),
  i("Skullfish Pendant (Novice Recipe)", noviceRecipe),
  i("Star Talent Reset Potion (Novice Recipe)", noviceRecipe),
  i("Strung Bludgeon (Novice Recipe)", noviceRecipe),
  i("Bucket of Slush (Apprentice Recipe)", apprenticeRecipe),
  i("Dawn Stopwatch (Apprentice Recipe)", apprenticeRecipe),
  i("Midnight Stopwatch (Apprentice Recipe)", apprenticeRecipe),
  i("Bolstered DNA Splicer (Journeyman Recipe)", journeymanRecipe),
  i("Double Barreled DNA Splicer (Journeyman Recipe)", journeymanRecipe),
  i("Ergonomic DNA Splicer (Journeyman Recipe)", journeymanRecipe),
  i("Souped Lab Ring (Journeyman Recipe)", journeymanRecipe),
  i("Cattle Core Soothsayer Staff (Adept Recipe)", adeptRecipe),
  i("Coldseeker Bullet (Adept Recipe)", adeptRecipe),
  i("Colossal Food Pouch (Adept Recipe)", adeptRecipe),
  i("Colossal Matty Pouch (Adept Recipe)", adeptRecipe),
  i("Magma Core Battleskirt (Adept Recipe)", adeptRecipe),
  i("Magma Core Headdress (Adept Recipe)", adeptRecipe),
  i("Magma Core Lavarunners (Adept Recipe)", adeptRecipe),
  i("Magma Core Wavemaille (Adept Recipe)", adeptRecipe),
  i("Magma Maul (Adept Recipe)", adeptRecipe),
  i("Molten Core Knucklers (Adept Recipe)", adeptRecipe),
  i("Sediment Core Grunkler (Adept Recipe)", adeptRecipe),
  i("Crown of the Gods (Master Recipe)", masterRecipe),
  i("Demented Emperor Opal (Master Recipe)", masterRecipe),
  i("Divvy Slippers (Master Recipe)", masterRecipe),
  i("Doublestring Godshooter (Master Recipe)", masterRecipe),
  i("Drip of the Gods (Master Recipe)", masterRecipe),
  i("Elegant Spear (Master Recipe)", masterRecipe),
  i("Golden Cake (Master Recipe)", masterRecipe),
  i("Magnifique Godcaster (Master Recipe)", masterRecipe),
  i("Massive Godbreaker (Master Recipe)", masterRecipe),
  i("Mittens of the Gods (Master Recipe)", masterRecipe),
  i("Pentastud Slapper (Master Recipe)", masterRecipe),
  i("Pristine Longbow (Master Recipe)", masterRecipe),
  i("Robe of the Gods (Master Recipe)", masterRecipe),
  i("Shiny Bored Beanie (Master Recipe)", masterRecipe),
  i("Sparky Marble Staff (Master Recipe)", masterRecipe),
  i("Tatters of the Gods (Master Recipe)", masterRecipe),
  i("Zero Point Stopwatch (Master Recipe)", masterRecipe),

  i("Copper Band", copperBand),
  i("Pugilist Demise", pugilistDemise),
  i("Steel Band", steelBand),
  i("Elf Twist Ring", elfTwistRing),
  i("Silver Stopwatch", silverStopwatch),
  i("Dooble Goopi", doobleGoopi),
  i("Rex Ring", rexRing),
  i("Defenders Dignity", defendersDignity),
  i("Frisbee Ring", frisbeeRing),
  i("Serrated Rex Ring", serratedRexRing),
  i("Death Wish", deathWish),
  i("Sanic Ring", sanicRing),
  i("Bejeweled Ring", bejeweledRing),
  i("Protectors Pride", protectorsPride),
  i("Efaunt Trunculus", efauntTrunculus),
  i("Dawn Stopwatch", dawnStopwatch),
  i("Midnight Stopwatch", midnightStopwatch),
  i("Neutron Ice Ring", neutronIceRing),
  i("Lab Ring", labRing),
  i("Chef Ring", chefRing),
  i("Souped Lab Ring", soupedLabRing),
  i("Tenacity Ring", tenacityRing),
  i("Zero Point Stopwatch", zeroPointStopwatch),
  i("Demented Emperor Opal", dementedEmperorOpal),
  i("Dune Killer Ring", duneKillerRing),
  i("Tundra Killer Ring", tundraKillerRing),
  i("Nebula Killer Ring", nebulaKillerRing),
  i("Magma Killer Ring", magmaKillerRing),
  i("Shallow Watering", shallowWatering),
  i("Oceanic Ring", oceanicRing),
  i("Deepwater Trench Ring", deepwaterTrenchRing),

  i("Spore Tee", sporeTee),
  i("Black Tee", blackTee),
  i("Orange Tee", orangeTee),
  i("Green Tee", greenTee),
  i("Purple Tee", purpleTee),
  i("Blue Tee", blueTee),
  i("Copper Platebody", copperPlatebody),
  i("Planktop", planktop),
  i("Iron Platebody", ironPlatebody),
  i("Hide Shirt", hideShirt),
  i("Tattered Cloth", tatteredCloth),
  i("Fur Shirt", furShirt),
  i("MCR Tshirt", mCRTshirt),
  i("Amarok Bodyplate", amarokBodyplate),
  i("Gold Platebody", goldPlatebody),
  i("Studded Hide", studdedHide),
  i("Feral Leathering", feralLeathering),
  i("Furled Robes", furledRobes),
  i("Platinum Platbody", platinumPlatbody),
  i("Dementia Body", dementiaBody),
  i("Member Hoodie", memberHoodie),
  i("Efaunt Ribcage", efauntRibcage),
  i("Void Imperium Platebody", voidImperiumPlatebody),
  i("Damascus Plates", damascusPlates),
  i("Evergreen Wraps", evergreenWraps),
  i("Elegantine Robes", elegantineRobes),
  i("Chizoar Bodyplate", chizoarBodyplate),
  i("Lustre Chestplate", lustreChestplate),
  i("Diabolical Abdomen", diabolicalAbdomen),
  i("Trollish Garb", trollishGarb),
  i("Magma Core Wavemaille", magmaCoreWavemaille),
  i("Serrated Chest of the Divine", serratedChestOfTheDivine),
  i("Marbiglass Tunic", marbiglassTunic),
  i("Robe of the Gods", robeOfTheGods),

  i("Flip Flops", flipFlops),
  i("Copper Boots", copperBoots),
  i("Goo Galoshes", gooGaloshes),
  i("Iron Boots", ironBoots),
  i("Cavern Trekkers", cavernTrekkers),
  i("Logger Heels", loggerHeels),
  i("Angler Boots", anglerBoots),
  i("Bandito Boots", banditoBoots),
  i("Gold Boots", goldBoots),
  i("Amarok Paws", amarokPaws),
  i("Platinum Boots", platinumBoots),
  i("Dementia Boots", dementiaBoots),
  i("Efaunts Broken Ankles", efauntsBrokenAnkles),
  i("Void Imperium Kicks", voidImperiumKicks),
  i("Chizoar Walkers", chizoarWalkers),
  i("Cooking Clogs", cookingClogs),
  i("Laboratory Scrubs", laboratoryScrubs),
  i("Spaggy Westerados", spaggyWesterados),
  i("Lustre Shieldshoe", lustreShieldshoe),
  i("Fiberous Footings", fiberousFootings),
  i("Deep Sea Galoshes", deepSeaGaloshes),
  i("Rough Rockers", roughRockers),
  i("Chef Hat Shoes", chefHatShoes),
  i("Sheek Scrubs", sheekScrubs),
  i("Diabolical Toe Tips", diabolicalToeTips),
  i("Soles of the Troll", solesOfTheTroll),
  i("Divvy Slippers", divvySlippers),
  i("Magma Core Lavarunners", magmaCoreLavarunners),
  i("Devious Slippers of the Divine", deviousSlippersOfTheDivine),
  i("Marbiglass Soles", marbiglassSoles),
  i("Drip of the Gods", dripOfTheGods),

  i("Sword Stamp", swordStamp),
  i("Heart Stamp", heartStamp),
  i("Mana Stamp", manaStamp),
  i("Tomahawk Stamp", tomahawkStamp),
  i("Target Stamp", targetStamp),
  i("Shield Stamp", shieldStamp),
  i("Longsword Stamp", longswordStamp),
  i("Kapow Stamp", kapowStamp),
  i("Fist Stamp", fistStamp),
  i("Battleaxe Stamp", battleaxeStamp),
  i("Agile Stamp", agileStamp),
  i("Vitality Stamp", vitalityStamp),
  i("Book Stamp", bookStamp),
  i("Manamoar Stamp", manamoarStamp),
  i("Clover Stamp", cloverStamp),
  i("Scimitar Stamp", scimitarStamp),
  i("Bullseye Stamp", bullseyeStamp),
  i("Feather Stamp", featherStamp),
  i("Polearm Stamp", polearmStamp),
  i("Violence Stamp", violenceStamp),
  i("Buckler Stamp", bucklerStamp),
  i("Hermes Stamp", hermesStamp),
  i("Sukka Foo", sukkaFoo),
  i("Arcane Stamp", arcaneStamp),
  i("Avast Yar Stamp", avastYarStamp),
  i("Steve Sword", steveSword),
  i("Blover Stamp", bloverStamp),
  i("Stat Graph Stamp", statGraphStamp),
  i("Gilded Axe Stamp", gildedAxeStamp),
  i("Diamond Axe Stamp", diamondAxeStamp),
  i("Tripleshot Stamp", tripleshotStamp),
  i("Blackheart Stamp", blackheartStamp),
  i("Maxo Slappo Stamp", maxoSlappoStamp),
  i("Sashe Sidestamp", sasheSidestamp),
  i("Intellectostampo", intellectostampo),
  i("Conjocharmo Stamp", conjocharmoStamp),
  i("Dementia Sword Stamp", dementiaSwordStamp),
  i("Golden Sixes Stamp", goldenSixesStamp),
  i("Stat Wallstreet Stamp", statWallstreetStamp),
  i("Void Sword Stamp", voidSwordStamp),
  i("Void Axe Stamp", voidAxeStamp),
  i("Captalist Stats Stamp", captalistStatsStamp),
  i("Pickaxe Stamp", pickaxeStamp),
  i("Hatchet Stamp", hatchetStamp),
  i("Anvil Zoomer Stamp", anvilZoomerStamp),
  i("Lil' Mining Baggy Stamp", lilMiningBaggyStamp),
  i("Twin Ores Stamp", twinOresStamp),
  i("Choppin' Bag Stamp", choppinBagStamp),
  i("Duplogs Stamp", duplogsStamp),
  i("Matty Bag Stamp", mattyBagStamp),
  i("Smart Dirt Stamp", smartDirtStamp),
  i("Cool Diggy Tool Stamp", coolDiggyToolStamp),
  i("High IQ Lumber Stamp", highIQLumberStamp),
  i("Swag Swingy Tool Stamp", swagSwingyToolStamp),
  i("Alch Go Brrr Stamp", alchGoBrrrStamp),
  i("Brainstew Stamps", brainstewStamps),
  i("Drippy Drop Stamp", drippyDropStamp),
  i("Droplots Stamp", droplotsStamp),
  i("Fishing Rod Stamp", fishingRodStamp),
  i("Fishhead Stamp", fishheadStamp),
  i("Catch Net Stamp", catchNetStamp),
  i("Fly Intel Stamp", flyIntelStamp),
  i("Bag o Heads Stamp", bagOHeadsStamp),
  i("Holy Mackerel Stamp", holyMackerelStamp),
  i("Bugsack Stamp", bugsackStamp),
  i("Buzz Buzz Stamp", buzzBuzzStamp),
  i("Hidey Box Stamp", hideyBoxStamp),
  i("Purp Froge Stamp", purpFrogeStamp),
  i("Spikemouth Stamp", spikemouthStamp),
  i("Stample Stamp", stampleStamp),
  i("Saw Stamp", sawStamp),
  i("Amplestample Stamp", amplestampleStamp),
  i("Flowin Stamp", flowinStamp),
  i("Banked Pts Stamp", bankedPtsStamp),
  i("Cooked Meal Stamp", cookedMealStamp),
  i("Spice Stamp", spiceStamp),
  i("Ladle Stamp", ladleStamp),
  i("Nest Eggs Stamp", nestEggsStamp),
  i("Egg Stamp", eggStamp),
  i("Lab Tube Stamp", labTubeStamp),
  i("Sailboat Stamp", sailboatStamp),
  i("Gamejoy Stamp", gamejoyStamp),
  i("Divine Stamp", divineStamp),
  i("Multitool Stamp", multitoolStamp),
  i("Skelefish Stamp", skelefishStamp),
  i("Crop Evo Stamp", cropEvoStamp),
  i("Sneaky Peeky Stamp", sneakyPeekyStamp),
  i("Jade Mint Stamp", jadeMintStamp),
  i("Summoner Stone Stamp", summonerStoneStamp),
  i("White Essence Stamp", whiteEssenceStamp),
  i("Triad Essence Stamp", triadEssenceStamp),
  i("Dark Triad Essence Stamp", darkTriadEssenceStamp),
  i("Questin Stamp", questinStamp),
  i("Mason Jar Stamp", masonJarStamp),
  i("Crystallin", crystallin),
  i("Arcade Ball Stamp", arcadeBallStamp),
  i("Gold Ball Stamp", goldBallStamp),
  i("Potion Stamp", potionStamp),
  i("Golden Apple Stamp", goldenAppleStamp),
  i("Ball Timer Stamp", ballTimerStamp),
  i("Card Stamp", cardStamp),
  i("Forge Stamp", forgeStamp),
  i("Vendor Stamp", vendorStamp),
  i("Sigil Stamp", sigilStamp),
  i("Talent II Stamp", talentIIStamp),
  i("Talent III Stamp", talentIIIStamp),
  i("Talent IV Stamp", talentIVStamp),
  i("Talent S Stamp", talentSStamp),
  i("Multikill Stamp", multikillStamp),
  i("Biblio Stamp", biblioStamp),
  i("DNA Stamp", dNAStamp),
  i("Refinery Stamp", refineryStamp),
  i("Atomic Stamp", atomicStamp),

  i("Power Statue", powerStatue),
  i("Speed Statue", speedStatue),
  i("Mining Statue", miningStatue),
  i("Feasty Statue", feastyStatue),
  i("Health Statue", healthStatue),
  i("Kachow Statue", kachowStatue),
  i("Lumberbob Statue", lumberbobStatue),
  i("Thicc Skin Statue", thiccSkinStatue),
  i("Oceanman Statue", oceanmanStatue),
  i("Ol Reliable Statue", olReliableStatue),
  i("Exp Book Statue", expBookStatue),
  i("Anvil Statue", anvilStatue),
  i("Cauldron Statue", cauldronStatue),
  i("Beholder Statue", beholderStatue),
  i("Bullseye Statue", bullseyeStatue),
  i("Box Statue", boxStatue),
  i("Twosoul Statue", twosoulStatue),
  i("EhExPee Statue", ehExPeeStatue),
  i("Seesaw Statue", seesawStatue),
  i("Pecunia Statue", pecuniaStatue),
  i("Mutton Statue", muttonStatue),
  i("Egg Statue", eggStatue),
  i("Battleaxe Statue", battleaxeStatue),
  i("Spiral Statue", spiralStatue),
  i("Boat Statue", boatStatue),
  i("Compost Statue", compostStatue),
  i("Stealth Statue", stealthStatue),
  i("Essence Statue", essenceStatue),

  i("Action Frenzy (Special Talent Book)", specialTalentBook),
  i("American Tipper (Special Talent Book)", specialTalentBook),
  i("Attacks On Simmer (Special Talent Book)", specialTalentBook),
  i("Beginner Best Class (Special Talent Book)", specialTalentBook),
  i("Bored To Death (Special Talent Book)", specialTalentBook),
  i("Boss Battle Spillover (Special Talent Book)", specialTalentBook),
  i("Cardiovascular! (Special Talent Book)", specialTalentBook),
  i("Cash Money (Special Talent Book)", specialTalentBook),
  i("Coins for Charon (Special Talent Book)", specialTalentBook),
  i("Crystals 4 Dayys (Special Talent Book)", specialTalentBook),
  i("Dreamer Damage (Special Talent Book)", specialTalentBook),
  i("Dummy Thicc Stats (Special Talent Book)", specialTalentBook),
  i("Dungeonic Damage (Special Talent Book)", specialTalentBook),
  i("Exp Converter (Special Talent Book)", specialTalentBook),
  i("Filthy Damage (Special Talent Book)", specialTalentBook),
  i("Frothy Malk (Special Talent Book)", specialTalentBook),
  i("Just Exp (Special Talent Book)", specialTalentBook),
  i("Mega Crit (Special Talent Book)", specialTalentBook),
  i("Milkyway Candies (Special Talent Book)", specialTalentBook),
  i("Monolithialism (Special Talent Book)", specialTalentBook),
  i("Overaccurate Crit (Special Talent Book)", specialTalentBook),
  i("Printer Sampling (Special Talent Book)", specialTalentBook),
  i("Pulsation (Special Talent Book)", specialTalentBook),
  i("Quest Chungus (Special Talent Book)", specialTalentBook),
  i("Rando Event Looty (Special Talent Book)", specialTalentBook),
  i("Roll Da Dice (Special Talent Book)", specialTalentBook),
  i("Shrine Architect (Special Talent Book)", specialTalentBook),
  i("Stonks! (Special Talent Book)", specialTalentBook),
  i("Studious Quester (Special Talent Book)", specialTalentBook),
  i("Supersource (Special Talent Book)", specialTalentBook),
  i("Tick Tock (Special Talent Book)", specialTalentBook),
  i("Tiptoe Quickness (Special Talent Book)", specialTalentBook),
  i("Toilet Paper Postage (Special Talent Book)", specialTalentBook),
  i("Ubercharged Health (Special Talent Book)", specialTalentBook),
  i("Will of the Eldest (Special Talent Book)", specialTalentBook),

  i("Cardboard Traps", cardboardTraps),
  i("Silkskin Traps", silkskinTraps),
  i("Wooden Traps", woodenTraps),
  i("Natural Traps", naturalTraps),
  i("Steel Traps", steelTraps),
  i("Meaty Traps", meatyTraps),
  i("Royal Traps", royalTraps),
  i("Egalitarian Traps", egalitarianTraps),
  i("Forbidden Traps", forbiddenTraps),
  i("Containment of the Zrgyios", containmentOfTheZrgyios),

  i("Froge", froge),
  i("Poison Froge", poisonFroge),
  i("Crabbo", crabbo),
  i("Mutant Crabbo", mutantCrabbo),
  i("Scorpie", scorpie),
  i("Crescent Scorpie", crescentScorpie),
  i("Mousey", mousey),
  i("Nakeo Moleo", nakeoMoleo),
  i("Owlio", owlio),
  i("Minervowl", minervowl),
  i("Pingy", pingy),
  i("Eternal Lord of The Undying Ember", eternalLordOfTheUndyingEmber),
  i("Bunny", bunny),
  i("Purbunni", purbunni),
  i("Dung Beat", dungBeat),
  i("Jade Scarab", jadeScarab),
  i("Honker", honker),
  i("Diamond Duck", diamondDuck),
  i("Blobfish", blobfish),
  i("Voodofish", voodofish),
  i("Tuttle", tuttle),
  i("Tottoise", tottoise),

  i("King of Food", kingOfFood),
  i("Lucky Lad", luckyLad),
  i("Club Member", clubMember),
  i("Dice Dynamo", diceDynamo),
  i("Blunder Hero", blunderHero),
  i("Trailblazer", trailblazer),
  i("Ultra Unboxer", ultraUnboxer),
  i("Critter Baron", critterBaron),
  i("YumYum Sheriff", yumYumSheriff),
  i("Megalodon", megalodon),
  i("Club Maestro", clubMaestro),
  i("Beach Bro", beachBro),
  i("Frost Prince", frostPrince),
  i("Idle Skiller", idleSkiller),
  i("One of the Divine", oneOfTheDivine),
  i("Master of Nothing", masterOfNothing),
  i("Nebula Royal", nebulaRoyal),
  i("Luckier Lad", luckierLad),
  i("Baller", baller),
  i("Gladiator", gladiator),

  i("Anvil Tab 2", anvilTab2),
  i("Anvil Tab 3", anvilTab3),
  i("Anvil Tab 4", anvilTab4),
  i("Anvil Tab 5", anvilTab5),
  i("Anvil Tab 6", anvilTab6),
  i("Inventory Bag A", inventoryBagA),
  i("Inventory Bag B", inventoryBagB),
  i("Inventory Bag C", inventoryBagC),
  i("Inventory Bag D", inventoryBagD),
  i("Inventory Bag E", inventoryBagE),
  i("Inventory Bag F", inventoryBagF),
  i("Inventory Bag G", inventoryBagG),
  i("Inventory Bag H", inventoryBagH),
  i("Snakeskinventory Bag", snakeskinventoryBag),
  i("Totally Normal and not fake Bag", totallyNormalBag),
  i("Blunderbag", blunderbag),
  i("Sandy Satchel", sandySatchel),
  i("Bummo Bag", bummoBag),
  i("Capitalist Case", capitalistCase),
  i("Wealthy Wallet", wealthyWallet),
  i("Prosperous Pouch", prosperousPouch),
  i("Sack of Success", sackOfSuccess),
  i("Shivering Sack", shiveringSack),
  i("Mamooth Hide Bag", mamoothHideBag),
  i("Peeper Pouch", peeperPouch),
  i("4th Anniversary Bag", _4thAnniversaryBag),
  i("Inventory Bag U", inventoryBagU),
  i("Inventory Bag V", inventoryBagV),
  i("Inventory Bag W", inventoryBagW),
  i("Inventory Bag X", inventoryBagX),
  i("Inventory Bag Y", inventoryBagY),
  i("Inventory Bag Z", inventoryBagZ),
  i("Mini Materials Pouch", miniMaterialsPouch),
  i("Cramped Material Pouch", crampedMaterialPouch),
  i("Small Material Pouch", smallMaterialPouch),
  i("Average Material Pouch", averageMaterialPouch),
  i("Sizable Materials Pouch", sizableMaterialsPouch),
  i("Big Materials Pouch", bigMaterialsPouch),
  i("Large Materials Pouch", largeMaterialsPouch),
  i("Massive Materials Pouch", massiveMaterialsPouch),
  i("Volumetric Matty Pouch", volumetricMattyPouch),
  i("Colossal Matty Pouch", colossalMattyPouch),
  i("Gargantuan Matty Pouch", gargantuanMattyPouch),
  i("Herculean Matty Pouch", herculeanMattyPouch),
  i("Miniscule Food Pouch", minisculeFoodPouch),
  i("Cramped Food Pouch", crampedFoodPouch),
  i("Small Food Pouch", smallFoodPouch),
  i("Average Food Pouch", averageFoodPouch),
  i("Sizable Food Pouch", sizableFoodPouch),
  i("Big Food Pouch", bigFoodPouch),
  i("Large Food Pouch", largeFoodPouch),
  i("Massive Food Pouch", massiveFoodPouch),
  i("Volumetric Food Pouch", volumetricFoodPouch),
  i("Colossal Food Pouch", colossalFoodPouch),
  i("Gargantuan Food Pouch", gargantuanFoodPouch),
  i("Herculean Food Pouch", herculeanFoodPouch),
  i("Miniature Choppin Pouch", miniatureChoppinPouch),
  i("Cramped Choppin Pouch", crampedChoppinPouch),
  i("Small Choppin Pouch", smallChoppinPouch),
  i("Average Choppin Pouch", averageChoppinPouch),
  i("Sizable Choppin Pouch", sizableChoppinPouch),
  i("Big Choppin Pouch", bigChoppinPouch),
  i("Large Choppin Pouch", largeChoppinPouch),
  i("Massive Choppin Pouch", massiveChoppinPouch),
  i("Volumetric Chopping Pouch", volumetricChoppingPouch),
  i("Colossal Chopping Pouch", colossalChoppingPouch),
  i("Gargantuan Chopping Pouch", gargantuanChoppingPouch),
  i("Herculean Chopping Pouch", herculeanChoppingPouch),
  i("Miniature Mining Pouch", miniatureMiningPouch),
  i("Cramped Mining Pouch", crampedMiningPouch),
  i("Small Mining Pouch", smallMiningPouch),
  i("Average Mining Pouch", averageMiningPouch),
  i("Sizable Mining Pouch", sizableMiningPouch),
  i("Big Mining Pouch", bigMiningPouch),
  i("Large Mining Pouch", largeMiningPouch),
  i("Massive Mining Pouch", massiveMiningPouch),
  i("Volumetric Mining Pouch", volumetricMiningPouch),
  i("Colossal Mining Pouch", colossalMiningPouch),
  i("Gargantuan Mining Pouch", gargantuanMiningPouch),
  i("Herculean Mining Pouch", herculeanMiningPouch),
  i("Cramped Fish Pouch", crampedFishPouch),
  i("Small Fish Pouch", smallFishPouch),
  i("Average Fish Pouch", averageFishPouch),
  i("Sizable Fish Pouch", sizableFishPouch),
  i("Big Fish Pouch", bigFishPouch),
  i("Large Fish Pouch", largeFishPouch),
  i("Massive Fish Pouch", massiveFishPouch),
  i("Volumetric Fish Pouch", volumetricFishPouch),
  i("Colossal Fish Pouch", colossalFishPouch),
  i("Gargantuan Fish Pouch", gargantuanFishPouch),
  i("Herculean Fish Pouch", herculeanFishPouch),
  i("Cramped Bug Pouch", crampedBugPouch),
  i("Small Bug Pouch", smallBugPouch),
  i("Average Bug Pouch", averageBugPouch),
  i("Sizable Bug Pouch", sizableBugPouch),
  i("Big Bug Pouch", bigBugPouch),
  i("Large Bug Pouch", largeBugPouch),
  i("Massive Bug Pouch", massiveBugPouch),
  i("Volumetric Bug Pouch", volumetricBugPouch),
  i("Colossal Bug Pouch", colossalBugPouch),
  i("Gargantuan Bug Pouch", gargantuanBugPouch),
  i("Herculean Bug Pouch", herculeanBugPouch),
  i("Small Critter Pouch", smallCritterPouch),
  i("Sizable Critter Pouch", sizableCritterPouch),
  i("Big Critter Pouch", bigCritterPouch),
  i("Large Critter Pouch", largeCritterPouch),
  i("Massive Critter Pouch", massiveCritterPouch),
  i("Volumetric Critta Pouch", volumetricCrittaPouch),
  i("Colossal Critta Pouch", colossalCrittaPouch),
  i("Gargantuan Critta Pouch", gargantuanCrittaPouch),
  i("Herculean Critta Pouch", herculeanCrittaPouch),
  i("Small Soul Pouch", smallSoulPouch),
  i("Sizable Soul Pouch", sizableSoulPouch),
  i("Big Soul Pouch", bigSoulPouch),
  i("Large Soul Pouch", largeSoulPouch),
  i("Massive Soul Pouch", massiveSoulPouch),
  i("Volumetric Soul Pouch", volumetricSoulPouch),
  i("Colossal Soul Pouch", colossalSoulPouch),
  i("Gargantuan Soul Pouch", gargantuanSoulPouch),
  i("Herculean Soul Pouch", herculeanSoulPouch),
  i("Storage Chest 1", storageChest1),
  i("Storage Chest 2", storageChest2),
  i("Storage Chest 3", storageChest3),
  i("Storage Chest 4", storageChest4),
  i("Storage Chest 5", storageChest5),
  i("Storage Chest 6", storageChest6),
  i("Storage Chest 7", storageChest7),
  i("Storage Chest 8", storageChest8),
  i("Storage Chest 9", storageChest9),
  i("Storage Chest 10", storageChest10),
  i("Storage Chest 11", storageChest11),
  i("Storage Chest 12", storageChest12),
  i("Storage Chest 13", storageChest13),
  i("Storage Chest 14", storageChest14),
  i("Storage Chest 15", storageChest15),
  i("Storage Chest 16", storageChest16),
  i("Storage Chest 17", storageChest17),
  i("Storage Chest 18", storageChest18),
  i("Storage Chest 19", storageChest19),
  i("Storage Chest 20", storageChest20),
  i("Storage Chest 21", storageChest21),
  i("Storage Chest 22", storageChest22),
  i("Storage Chest 23", storageChest23),
  i("Storage Chest 24", storageChest24),
  i("Storage Chest 25", storageChest25),
  i("Storage Chest 26", storageChest26),
  i("Storage Chest 27", storageChest27),
  i("Storage Chest 28", storageChest28),
  i("Dank Paypay Chest", dankPaypayChest),
  i("Gelatinous Chest", gelatinousChest),
  i("Cheesy Chest", cheesyChest),
  i("Woodlin Chest", woodlinChest),
  i("Ninja Chest", ninjaChest),
  i("Cosmic Storage Chest", cosmicStorageChest),
  i("Storage Chest 90", storageChest90),
  i("Storage Chest 91", storageChest91),
  i("Storage Chest 92", storageChest92),
  i("Storage Chest 93", storageChest93),
  i("Storage Chest 94", storageChest94),
  i("Storage Chest 95", storageChest95),
  i("Storage Chest 96", storageChest96),
  i("Storage Chest 97", storageChest97),
  i("Storage Chest 98", storageChest98),
  i("Storage Chest 99", storageChest99),
  i("Storage Chest 99B", storageChest99B),
  i("Storage Chest 99C", storageChest99C),
  i("Holiday Chest", holidayChest),
  i("Valenslime Chest", valenslimeChest),

  i("Easter Armor Stone", easterArmorStone),
  i("Summer Armor Stone", summerArmorStone),
  i("Armor Upgrade Stone I", armorUpgradeStoneI),
  i("Armor Upgrade Stone G", armorUpgradeStoneG),
  i("Armor Upgrade Stone II", armorUpgradeStoneII),
  i("Armor Upgrade Stone B", armorUpgradeStoneB),
  i("Armor Upgrade Stone III", armorUpgradeStoneIII),
  i("Armor Upgrade Stone C", armorUpgradeStoneC),
  i("Armor Upgrade Stone IV", armorUpgradeStoneIV),
  i("Armor Upgrade Stone V", armorUpgradeStoneV),
  i("Armor Upgrade Stone SK", armorUpgradeStoneSK),
  i("Armor Upgrade Stone VI", armorUpgradeStoneVI),
  i("Easter Weapon Stone", easterWeaponStone),
  i("Summer Weapon Stone", summerWeaponStone),
  i("Weapon Upgrade Stone I", weaponUpgradeStoneI),
  i("Weapon Upgrade Stone II", weaponUpgradeStoneII),
  i("Weapon Upgrade Stone III", weaponUpgradeStoneIII),
  i("Weapon Upgrade Stone C", weaponUpgradeStoneC),
  i("Warped Weapon Upgrade Stone", warpedWeaponUpgradeStone),
  i("Weapon Upgrade Stone IV", weaponUpgradeStoneIV),
  i("Weapon Upgrade Stone V", weaponUpgradeStoneV),
  i("Weapon Upgrade Stone SK", weaponUpgradeStoneSK),
  i("Weapon Upgrade Stone VI", weaponUpgradeStoneVI),
  i("Easter Tool Upgrade Stone", easterToolUpgradeStone),
  i("Tool Upgrade Stone I", toolUpgradeStoneI),
  i("Giftmas Tool Upgrade Stone", giftmasToolUpgradeStone),
  i("Summer Tool Upgrade Stone", summerToolUpgradeStone),
  i("Tool Upgrade Stone II", toolUpgradeStoneII),
  i("Tool Upgrade Stone III", toolUpgradeStoneIII),
  i("Tool Upgrade Stone IV", toolUpgradeStoneIV),
  i("Tool Upgrade Stone V", toolUpgradeStoneV),
  i("Tool Upgrade Stone SK", toolUpgradeStoneSK),
  i("Tool Upgrade Stone VI", toolUpgradeStoneVI),
  i("Helmet Upgrade Stone I", helmetUpgradeStoneI),
  i("Warped Helmet Upgrade Stone", warpedHelmetUpgradeStone),
  i("Giftmas Helmet Upgrade Stone", giftmasHelmetUpgradeStone),
  i("Helmet Upgrade Stone SK", helmetUpgradeStoneSK),
  i("Mystery Upgrade Stone I", mysteryUpgradeStoneI),
  i("Mystery Upgrade Stone II", mysteryUpgradeStoneII),
  i("Mystery Upgrade Stone III", mysteryUpgradeStoneIII),
  i("Mystery Upgrade Stone IV", mysteryUpgradeStoneIV),
  i("Hat Premiumifier", hatPremiumifier),
  i("Premium Stone Refunder", premiumStoneRefunder),
  i("Premium Bonus Swapper", premiumBonusSwapper),
  i("Premium STR Stone", premiumSTRStone),
  i("Premium AGI Stone", premiumAGIStone),
  i("Premium WIS Stone", premiumWISStone),
  i("Premium LUK Stone", premiumLUKStone),

  i("Boxing Gloves", boxingGloves),
  i("The Stingers", theStingers),
  i("Bandage Wraps", bandageWraps),
  i("Uninflated Glove", uninflatedGlove),
  i("Eclectic Ordeal", eclecticOrdeal),
  i("Knuckle Sabers", knuckleSabers),
  i("Diabolical Gauntlet", diabolicalGauntlet),
  i("Molten Core Knucklers", moltenCoreKnucklers),
  i("Crackled Skull Destroyer", crackledSkullDestroyer),
  i("Pentastud Slapper", pentastudSlapper),
  i("Mittens of the Gods", mittensOfTheGods),
  i("Wooden Spear", woodenSpear),
  i("Steel Axe", steelAxe),
  i("Royal Bayonet", royalBayonet),
  i("Enforced Slasher", enforcedSlasher),
  i("The Ice Breaker", theIceBreaker),
  i("Deuscythe", deuscythe),
  i("Slimsharp Fin", slimsharpFin),
  i("Diabolical Flesh Ripper", diabolicalFleshRipper),
  i("Magma Maul", magmaMaul),
  i("Skull Lance", skullLance),
  i("Elegant Spear", elegantSpear),
  i("Massive Godbreaker", massiveGodbreaker),
  i("Wooden Bow", woodenBow),
  i("Birch Longbow", birchLongbow),
  i("Carrot Launcher", carrotLauncher),
  i("Spiked Menace", spikedMenace),
  i("Pharaoh Bow", pharaohBow),
  i("Blizzard Bow", blizzardBow),
  i("Blackhole Bow", blackholeBow),
  i("Shardsure Leif", shardsureLeif),
  i("Diabolical Continuit", diabolicalContinuit),
  i("Sediment Core Grunkler", sedimentCoreGrunkler),
  i("Spine Tingler Sniper", spineTinglerSniper),
  i("Pristine Longbow", pristineLongbow),
  i("Doublestring Godshooter", doublestringGodshooter),
  i("Gnarled Wand", gnarledWand),
  i("Quarterstaff", quarterstaff),
  i("Starlight", starlight),
  i("Crows Nest", crowsNest),
  i("Spriggly Storm", sprigglyStorm),
  i("Grey Gatsby", greyGatsby),
  i("Skullslip Hallow", skullslipHallow),
  i("Diabolical Opticule", diabolicalOpticule),
  i("Cattle Core Soothsayer Staff", cattleCoreSoothsayerStaff),
  i("Staff of the Undead Plague", staffOfTheUndeadPlague),
  i("Sparky Marble Staff", sparkyMarbleStaff),
  i("Magnifique Godcaster", magnifiqueGodcaster),

  i("Wax Skull", waxSkull),
  i("Ceramic Skull", ceramicSkull),
  i("Slush Skull", slushSkull),
  i("Horned Skull", hornedSkull),
  i("Prickle Skull", prickleSkull),
  i("Manifested Skull", manifestedSkull),
  i("Glauss Skull", glaussSkull),
  i("Luciferian Skull", luciferianSkull),
  i("Dreadnaught Skull", dreadnaughtSkull),
  i("Cultist Skull", cultistSkull),
  i("Crystal Skull of Esquire Vnoze", crystalSkullOfEsquireVnoze),

  i("Forest Soul", forestSoul),
  i("Dune Soul", duneSoul),
  i("Rooted Soul", rootedSoul),
  i("Frigid Soul", frigidSoul),
  i("Squishy Soul", squishySoul),
  i("Oozie Soul", oozieSoul),
  i("Breezy Soul", breezySoul),

  i("Pile of Processor Chips", pileOfProcessorChips),
  i("Strung Jewels", strungJewels),
  i("Blue Tome Pages", blueTomePages),
  i("Red Tome Pages", redTomePages),

  i("Goblin Gorfest", goblinGorfest),
  i("Wakawaka War", wakawakaWar),
  i("Acorn Assault", acornAssault),
  i("Frosty Firefight", frostyFirefight),
  i("Clash of Cans", clashOfCans),
  i("Citric Conflict", citricConflict),
  i("Breezy Battle", breezyBattle),

  i("Water Droplets", waterDroplets),
  i("Liquid Nitrogen", liquidNitrogen),
  i("Trench Seawater", trenchSeawater),
  i("Toxic Mercury", toxicMercury),

  i("Dungeon Credits", dungeonCredits),
  i("Dungeon Credits Flurbo Edition", dungeonCreditsFlurboEdition),
  i("Keychain Fragment", keychainFragment),

  i("Giftmas Present 2024", giftmasBox),
  i("Epic Santa Hat", epicSantaHat),
  i("Snowflake Nametag", snowflakeNametag),
  i("Frostyman Nametag", frostymanNametag),
  i("Pet Egg", petEgg),
  i("Cooking Ladle", cookingLadle),
  i("Cosmic Ball", cosmicBall),
  i("Worship Floppy Disc", worshipFloppyDisc),
  i("Bottled Wind", bottledWind),
  i("Gaming Fertilizer", gamingFertilizer),
  i("Compost Bag", compostBag),
  i("Summoner Stone", summonerStone),
  i("Sand of Time", sandOfTime),

  i("Garbage", garbage),
  i("Message Bottle", messageBottle),
  i("Sailing Gold Bar", sailingGoldBar),

  i("Amethyst Rhinestone", amethystRhinestone),
  i("Purple Navette", purpleNavette),
  i("Purple Rhombol", purpleRhombol),
  i("Sapphire Rhinestone", sapphireRhinestone),
  i("Sapphire Navette", sapphireNavette),
  i("Sapphire Rhombol", sapphireRhombol),
  i("Sapphire Pyramite", sapphirePyramite),
  i("Pyrite Rhinestone", pyriteRhinestone),
  i("Pyrite Navette", pyriteNavette),
  i("Pyrite Rhombol", pyriteRhombol),
  i("Pyrite Pyramite", pyritePyramite),
  i("Emerald Rhinestone", emeraldRhinestone),
  i("Emerald Navette", emeraldNavette),
  i("Emerald Rhombol", emeraldRhombol),
  i("Emerald Pyramite", emeraldPyramite),
  i("Emerald Ulthurite", emeraldUlthurite),
  i("Black Diamond Rhinestone", blackDiamondRhinestone),
  i("Black Diamond Ulthurite", blackDiamondUlthurite),
  i("Pure Opal Rhinestone", pureOpalRhinestone),
  i("Pure Opal Navette", pureOpalNavette),
  i("Pure Opal Rhombol", pureOpalRhombol),

  i("Grounded Nanochip", groundedNanochip),
  i("Grounded Motherboard", groundedMotherboard),
  i("Grounded Software", groundedSoftware),
  i("Grounded Processor", groundedProcessor),
  i("Potato Chip", potatoChip),
  i("Conductive Nanochip", conductiveNanochip),
  i("Conductive Motherboard", conductiveMotherboard),
  i("Conductive Software", conductiveSoftware),
  i("Conductive Processor", conductiveProcessor),
  i("Chocolatey Chip", chocolateyChip),
  i("Galvanic Nanochip", galvanicNanochip),
  i("Galvanic Motherboard", galvanicMotherboard),
  i("Galvanic Software", galvanicSoftware),
  i("Galvanic Processor", galvanicProcessor),
  i("Wood Chip", woodChip),
  i("Silkrode Nanochip", silkrodeNanochip),
  i("Silkrode Motherboard", silkrodeMotherboard),
  i("Silkrode Software", silkrodeSoftware),
  i("Silkrode Processor", silkrodeProcessor),
  i("Poker Chip", pokerChip),
  i("Omega Nanochip", omegaNanochip),
  i("Omega Motherboard", omegaMotherboard),

  i("Turkey a la Thank", turkeyALaThank),
  i("Egg", egg),
  i("Salad", salad),
  i("Pie", pie),
  i("Frenk Fries", frenkFries),
  i("Spaghetti", spaghetti),
  i("Corn", corn),
  i("Garlic Bread", garlicBread),
  i("Garlicless Bread", garliclessBread),
  i("Pizza", pizza),
  i("Apple", apple),
  i("Pancakes", pancakes),
  i("Corndog", corndog),
  i("Cabbage", cabbage),
  i("Potato Pea Pastry", potatoPeaPastry),
  i("Dango", dango),
  i("Sourish Fish", sourishFish),
  i("Octoplop", octoplop),
  i("Croissant", croissant),
  i("Canopy", canopy),
  i("Cannoli", cannoli),
  i("Cheese", cheese),
  i("Sawdust", sawdust),
  i("Eggplant", eggplant),
  i("Cheesy Bread", cheesyBread),
  i("Wild Boar", wildBoar),
  i("Donut", donut),
  i("Riceball", riceball),
  i("Cauliflower", cauliflower),
  i("Durian Fruit", durianFruit),
  i("Orange", orange),
  i("Bunt Cake", buntCake),
  i("Chocolate Truffle", chocolateTruffle),
  i("Leek", leek),
  i("Fortune Cookie", fortuneCookie),
  i("Pretzel", pretzel),
  i("Sea Urchin", seaUrchin),
  i("Mashed Potato", mashedPotato),
  i("Mutton", mutton),
  i("Wedding Cake", weddingCake),
  i("Eel", eel),
  i("Whipped Cocoa", whippedCocoa),
  i("Onion", onion),
  i("Soda", soda),
  i("Sushi Roll", sushiRoll),
  i("Buncha Banana", bunchaBanana),
  i("Pumpkin", pumpkin),
  i("Cotton Candy", cottonCandy),
  i("Massive Fig", massiveFig),
  i("Head Chef Bread", headChefBread),
  i("Kiwi Fruit", kiwiFruit),
  i("Popped Corn", poppedCorn),
  i("Double Cherry", doubleCherry),
  i("Ratatouey", ratatouey),
  i("Giant Tomato", giantTomato),
  i("Wrath Grapes", wrathGrapes),
  i("Sausy Sausage", sausySausage),
  i("Seasoned Marrow", seasonedMarrow),
  i("Sticky Bun", stickyBun),
  i("Frazzleberry", frazzleberry),
  i("Misterloin Steak", misterloinSteak),
  i("Large Pohayoh", largePohayoh),
  i("Bill Jack Pepper", billJackPepper),
  i("Burned Marshmallow", burnedMarshmallow),
  i("Yumi Peachring", yumiPeachring),
  i("Plumpcakes", plumpcakes),
  i("Nyanborgir", nyanborgir),
]);
